module.exports = {
  alarms: 'Alarmlar',
  contacts: 'İletişim',
  groups: 'Gruplar',
  settings: 'Ayarlar',
  notificationsTab: 'Bildirimler',
  specifyTimeInFutureForAlarm: 'Alarm geçmişte kalamaz.',
  specifyTimeInFutureForPreReminder: 'Alarm için ön hatırlatma geçmişte kaldı.',
  specifyNameForGroup: 'Grup adı gereklidir.',
  updatingGroupName: 'Grup bilgileri güncelleniyor.',
  unableToEditGroupName:
    'Grup bilgileri güncellenemiyor. Lütfen bir süre sonra tekrar deneyin.',
  selectSmallerImage: "Görüntü 10 MB'den büyük. Daha küçük bir görüntü seçin.",
  sendingVerificationCode:
    'Doğrulama kodunun {{formattedMobileNumber}} adresine gönderilmesi.',
  verifyingCode: 'Kodun doğrulanması.',
  creatingUserProfile: 'Kurmak...',
  unabeToCreateUserProfile:
    'Şu anda bir hesap oluşturulamıyor. Lütfen birkaç dakika içinde tekrar deneyin.',
  unableToSendVerificationCode: 'Doğrulama kodu gönderilemiyor. {{error}}',
  unableToVerifyCode: 'Kod doğrulanamıyor. {{error}}',
  unableToRegisterUserWithoutMobileNumber:
    'Kurulum gerçekleştirilemiyor. {{error}}',
  permissionDeniedToAccessCameraIos:
    "Galarm'ın kameraya erişim izni yok. \n\nAyarlar > Galarm'a gidin ve kameraya erişime izin verin.",
  permissionDeniedToAccessCameraAndroid:
    "Galarm'ın kameraya erişim izni yok.\n\nAyarlar > Uygulamalar > Galarm > İzinler bölümüne gidin ve kameraya erişime izin verin.",
  permissionDeniedToAccessPhotosIos:
    "Galarm'ın fotoğraflara erişim izni yok.\n\nAyarlar > Galarm'a gidin ve fotoğraflara erişime izin verin.",
  permissionDeniedToAccessPhotosAndroid:
    "Galarm'ın fotoğraflara erişim izni yok.\n\nAyarlar > Uygulamalar > Galarm > İzinler bölümüne gidin ve depolama alanına erişime izin verin.",
  permissionDeniedToAccessCalendarIos:
    "Galarm'ın takvime erişim izni yok.\nAyarlar > Takvimler bölümüne gidin ve Galarm'a erişim izni verin.",
  permissionDeniedToAccessCalendarAndroid:
    "Galarm'ın takvime erişim izni yok.\nAyarlar > Uygulamalar > Galarm > İzinler bölümüne gidin ve Takvim'e erişime izin verin.",
  verificationCodeSent:
    'Doğrulama kodu {{formattedMobileNumber}} adresine gönderildi.',
  rateTheApp:
    "Galarm'ı faydalı bulduğunuzu umuyoruz. Lütfen Play Store'da bizi değerlendirmek için bir dakikanızı ayırın. Desteğiniz için teşekkür ederiz.",
  backgroundAppRefreshDisabledPermission:
    'Galarm\'ın arka planda uygulama yenileme izni olmadığı için alarmlar çalmayabilir.\n\n"Etkinleştir "e dokunun ve "Arka Plan Uygulama Yenileme "yi etkinleştirin.',
  selectedGroupUnselected:
    'Katılımcı olarak bir grup veya bir dizi kişi seçebilirsiniz. Önceden seçmiş olduğunuz grubun seçimi kaldırılacaktır. Devam edelim mi?',
  selectedContactsUnselected:
    'Katılımcı olarak bir grup veya bir dizi kişi seçebilirsiniz. Önceden seçtiğiniz kişilerin seçimi kaldırılacaktır. Devam edelim mi?',
  notificationsDisabledIos:
    'Galarm\'ın bildirimleri gösterme izni olmadığı için alarmlar çalmayacaktır.\n\nAyarlar > Galarm > Bildirimler bölümüne gidin ve "Uyarılar", "Sesler" ve "Afişler "i etkinleştirin.',
  notificationsDisabledAndroid:
    'Alarm bildirimleri ekranda görünmeyecektir.\n\n"Etkinleştir "e dokunun, "Bildirimler "i seçin ve bildirimlere izin verin.',
  alarmNotificationChannelDisabled:
    'Alarm bildirimleri ekranda görünmeyecektir. \n\n"Etkinleştir "e dokunun ve alarm bildirimlerinin ekranda açılmasına izin verin.',
  alarmLockScreenNotificationlDisabled:
    'Alarm bildirimleri kilit ekranında gösterilmeyecektir. \n\n"Etkinleştir "e dokunun ve alarm bildirimlerinin kilit ekranında gösterilmesine izin verin.',
  alarmWillNotRingDueToNotificationsDisabledIos:
    'Bildirimler devre dışı bırakıldığı için alarmlar çalmayacaktır.\n\nAyarlar > Galarm > Bildirimler bölümüne gidin ve "Uyarılar", "Sesler" ve "Afişler "i etkinleştirin.',
  alarmWillNotRingDueToCriticalAlertsDisabledIos:
    'Kritik uyarılar devre dışı bırakıldığı için telefon sessize alındığında alarmlar çalmayacaktır.\n\nAyarlar > Galarm > Bildirimler bölümüne gidin ve "Kritik Uyarılar "ı etkinleştirin.',
  alarmWillNotRingDueToNotificationsDisabledAndroid:
    'Bildirimler devre dışı bırakıldığı için alarm ekranda görünmeyecektir.\n\n"Etkinleştir "e dokunun, "Bildirimler "i seçin ve bildirimlere izin verin.',
  noNotificationsScheduledAlarmInPast:
    'Alarm geçmişte kaldı. Hiçbir bildirim planlanmamıştır.',
  alarmOverAllowedLimit: {
    zero: '\nAlarm limitiniz olan {{limit}} alarmına ulaştınız.\n\nLütfen mevcut bir alarmı silin veya yeniden kullanın.',
    one: 'Alarm limitiniz olan {{limit}} alarmına ulaştınız.\n\nSilebileceğiniz veya yeniden kullanabileceğiniz 1 etkin olmayan alarmınız var.',
    other:
      'Alarm limitiniz olan {{limit}} alarmına ulaştınız.\n\nSilebileceğiniz veya yeniden kullanabileceğiniz {{count}} etkin olmayan alarmlarınız vardır.'
  },
  alarmAlreadyConfirmed: 'Zaten onayladın.',
  alarmAlreadyDeclined: 'Zaten reddettiniz.',
  participantMovedToPosition: '{{name}} {{count}} konumuna taşınmıştır.',
  memberIsFirstParticpant: '{{name}} ilk katılımcıdır.',
  memberIsLastParticpant: '{{name}} son katılımcıdır.',
  cantContinueWithRegistrationWhenOffline:
    'Cihaz çevrimdışı olduğu için kayıt işlemine devam edilemiyor.',
  cantContinueWithRegistrationWhenOfflineWithTryAgain:
    'Cihaz çevrimdışı olduğu için kayıt işlemine devam edilemiyor. İnternete bağlı olduğunuzdan emin olun.',
  confirmBlockContact:
    'Artık {{name}} adresinden herhangi bir alarm almayacaksınız. Devam edelim mi?',
  confirmUnblockContact:
    '{{name}} adresindeki engellemeyi kaldırmak, engellenen alarmları da geri yükleyecektir. Devam edelim mi?',
  unblockingContact:
    '{{name}} blokajının kaldırılması ve alarmların geri yüklenmesi.',
  unableToUnblockContact: 'Temasın engeli kaldırılamıyor. {{error}}',
  blockingContact: 'Engelleme {{name}}.',
  unableToBlockContact: 'Temas engellenemiyor. {{error}}',
  cantAddContactToAlarmBecauseBlocked:
    '{{name}} adresini engellediniz. Alarma katılımcı olarak eklemek için engellemeyi kaldırın.',
  cantAddContactToGroupBecauseBlocked:
    '{{name}} adresini engellediniz. Gruba üye olarak eklemek için engellemeyi kaldırın.',
  sendMessageNotAllowedForPastAlarms:
    'Etkin olmayan alarmlar için mesaj gönderilemez.',
  nameIsRequired: 'İsim gereklidir.',
  confirmDisableGroupAlarm:
    'Grup alarmının devre dışı bırakılması diğer katılımcılar için de alarmı devre dışı bırakacaktır. Devam edelim mi?',
  removeMemberFromGroup:
    '{{name}} adresini bu gruptan kaldırmak istiyor musunuz?',
  leaveGroupConfirm: 'Bu gruptan ayrılmak mı istiyorsun?',
  deviceOffline:
    'Cihaz çevrimdışı. İnternete bağlı olduğunuzdan emin olun ve tekrar deneyin.',
  mustBeOnlineForEnhancedAutoSnoozeCount:
    "Erteleme sayısı 2'den fazla olan bir alarmı kaydetmek için çevrimiçi olmalısınız.",
  cantUpdateTimezoneForAllAlarms:
    'Mevcut Alarmlar için Saat Dilimi Güncellenemiyor',
  cantUpdateRingtonesForAllAlarms:
    'Mevcut Alarmlar için Ses ve Titreşim Ayarları Güncellenemiyor',
  cantUpdateGroupDefaulConfigWhenOffline:
    'Cihaz çevrimdışı olduğu için değiştirilen grup yapılandırması gelecekteki alarmlara uygulanmayacaktır.',
  specifyFeedback: 'Geri bildirim gereklidir.',
  specifyEmailId: 'E-posta adresi gereklidir.',
  specifyValidEmailId: 'E-posta adresi geçerli değil.',
  specifyProblem: 'Sorun açıklaması gereklidir.',
  appInstalledUsingSameNumberOnDifferentPhone:
    "Galarm'ı aynı numarayı kullanarak farklı bir cihaza yüklediniz. Bu cihazdaki uygulama sıfırlandı.",
  invalidUid:
    'Bu kullanıcı hesabı artık mevcut değil. Bu cihazdaki Galarm uygulaması sıfırlandı.',
  accountDeleted: 'Hesabınız silindi.',
  deleteAccount: 'Hesabımı Sil',
  deletingAccount: 'Hesabınızı silme',
  howCanWeImprove:
    'Gittiğinizi gördüğümüz için üzgünüz. Nasıl daha iyi olabiliriz?',
  noMusicAlert: 'Müzik dosyası bulunamadı.',
  noLongerAvailableMusic:
    '{{fileName}} artık mevcut değildir. Zil sesi şu şekilde değiştirildi {{defaultRingtoneName}}',
  userInactiveTitle: 'Tekrar hoş geldiniz!',
  userInactiveMessage:
    'Önemli şeyler için alarmlar oluşturun ve onları asla kaçırmayın.',
  createAlarm: 'Alarm Oluştur',
  updatedAppAvailable: 'Uygulamanın yeni bir sürümü mevcuttur.',
  alarmOccurrenceDisabled: 'Bu olay için devre dışı',
  ownAlarmOccurrenceDone: {
    zero: 'İşaretli bitti {{timeString}}',
    one: '{{timeString}} adresinde tamamlandı olarak işaretlendi. {{dateString}}'
  },
  ownAlarmOccurrenceSkipped: {
    zero: 'Atlandı {{timeString}}',
    one: '{{timeString}} adresinde atlandı {{dateString}}'
  },
  enabledAlarmsCount: {
    one: '1 alarm etkinleştirildi.',
    other: '{{count}} alarmlar etkinleştirildi.'
  },
  enabledAndNotEnabledAlarmsCount: {
    one: '1 alarm etkinleştirildi. Gelecekte oluşmayacak alarmlar devre dışı kalır.',
    other:
      '{{count}} alarmlar etkinleştirildi. Gelecekte gerçekleşmeyecek alarmlar devre dışı kalır.'
  },
  disabledAlarmsCount: {
    one: '1 alarm devre dışı.',
    other: '{{count}} alarmlar devre dışı.'
  },
  ownAlarmOccurrenceUnacknowledged: 'Yanıt verilmedi',
  participantAlarmOccurrenceDone: {
    zero: '{{participantName}} adresinde işaretlenmiştir. {{timeString}}',
    one: 'Marked done by {{participantName}} at {{timeString}} on {{dateString}}'
  },
  participantAlarmOccurrenceSkipped: {
    zero: '{{participantName}} tarafından atlandı {{timeString}}',
    one: '{{participantName}} tarafından {{timeString}} tarihinde atlandı {{dateString}}'
  },
  participantAlarmOccurrenceUnacknowledged: '{{participantName}} cevap vermedi',
  groupAlarmOccurrenceConfirmed: {
    zero: 'Şu adreste onaylandı {{timeString}}',
    one: '{{timeString}} adresinde onaylanmıştır. {{dateString}}'
  },
  groupAlarmOccurrenceDeclined: {
    zero: 'Reddedildi {{timeString}}',
    one: '{{timeString}} adresinde reddedildi {{dateString}}'
  },
  warning: 'Uyarı',
  info: 'Bilgi',
  confirm: 'Onaylayın',
  error: 'Hata',
  cantUploadImage: 'Resim Yüklenemiyor',
  cantDeleteImage: 'Resim Silinemiyor',
  cantEditGroup: 'Grup Düzenlenemiyor',
  cantAddNewContact: 'Yeni Kişi Eklenemiyor',
  cantDeleteContact: 'Kişi Silinemiyor',
  cantEditContact: 'Kişi Düzenlenemiyor',
  cantSaveAlarm: 'Alarm Kaydedilemiyor',
  cantSaveGroup: 'Grup Kaydedilemiyor',
  cantReloadContacts: 'Kişiler Yeniden Yüklenemiyor',
  cantTakePhoto: 'Fotoğraf Çekemiyorum',
  cantExportToCalendar: 'Takvime Aktarılamıyor',
  cantOpenPhotoLibrary: 'Fotoğraf Kitaplığı Açılamıyor',
  cantDeleteAlarmHistory: 'Alarm Geçmişi Silinemiyor',
  cannotDuplicateAlarm: 'Alarm Çoğaltılamıyor',
  upgradeToPremiumToDuplicateAlarm:
    "Daha fazla grup ve arkadaş alarmı oluşturmak için Premium'a yükseltin.",
  confirmAcceptAlarm: 'Alarmı kabul edelim mi?',
  confirmRejectAlarm: 'Alarmı reddet?',
  deleteAlarm: 'Alarmı silelim mi?',
  restoreAlarmConfirmation: 'Alarmı geri yüklemek mi?',
  respondToRepeatingAlarm: {
    zero: '{{alarmCreatorName}} tarafından {{alarmName}} alarmına alıcı olarak eklendiniz. {{alarmTimeString}} {{alarmRepetitionString}} adresinden uyarı almaya başlayacaksınız. {{alarmDateString}}',
    one: '{{alarmCreatorName}} tarafından {{alarmName}} alarmına katılımcı olarak eklendiniz. {{alarmTimeString}} {{alarmRepetitionString}} adresinden uyarı alacaksınız. {{alarmDateString}}'
  },
  respondToOneTimeAlarm: {
    zero: '{{alarmCreatorName}} tarafından {{alarmName}} alarmına alıcı olarak eklendiniz. {{alarmTimeString}} adresinden uyarılacaksınız. {{alarmDateString}}',
    one: '{{alarmCreatorName}} tarafından {{alarmName}} alarmına katılımcı olarak eklendiniz. {{alarmTimeString}} adresinden uyarılacaksınız. {{alarmDateString}}'
  },
  cantMoveMemberUp: 'Hareket Edemiyor {{name}} Yukarı',
  cantMoveMemberDown: 'Hareket Edemiyor {{name}} Aşağı',
  decline: 'Reddet',
  cantEditProfile: 'Profil Düzenlenemiyor',
  cantSelectContact: 'Kişi Seçilemiyor',
  cantSendMessage: 'Mesaj Gönderilemiyor',
  cantSendVerificationCode: 'Doğrulama Kodu Gönderilemiyor',
  confirmBlockContactTitle: 'Blok İletişimini Onayla',
  confirmUnblockContactTitle: 'Kişi Engelini Kaldırmayı Onayla',
  cantSaveProfile: 'Profil Kaydedilemiyor',
  cantBlockContact: 'Teması Engelleyemiyorum',
  cantUnblockContact: 'Kişi Engelini Kaldıramıyorum',
  cantLoadEarlierMessages: 'Önceki Mesajlar Yüklenemiyor',
  cantRestoreAlarm: 'Alarm Geri Yüklenemiyor',
  cantSendFeedback: 'Geri Bildirim Gönderilemiyor',
  cantSubmitProblem: 'Sorun Gönderilemiyor',
  cantDeletePastAlarmsInBulk: 'Etkin Olmayan Alarmlar Toplu Olarak Silinemiyor',
  cantAddNewGroup: 'Yeni Grup Eklenemiyor',
  alreadySnoozing: 'Zaten Uyukluyorum',
  markAlarmUndone:
    "Bu alarmı 'Bitti' olarak işaretlediniz {{durationString}} önce. Geri alayım mı?",
  markAlarmUnskipped:
    'Bu alarmı atladınız {{durationString}} önce. Geri alayım mı?',
  cantUndo: 'Geri Alamıyorum',
  fetchMusicFromPhone: 'Mevcut müziği bulma.',
  enableAllAlarmsInCategory: 'Bu kategorideki tüm alarmları etkinleştirin mi?',
  disableAllAlarmsInCategory:
    'Bu kategorideki tüm alarmları devre dışı mı bırakayım?',
  allAlarmsAlreadyEnabled:
    'Bu kategorideki tüm alarmlar zaten etkin durumdadır.',
  allAlarmsAlreadyDisabled: 'Bu kategorideki tüm alarmlar zaten devre dışıdır.',
  time: 'Zaman',
  timeForBuddy: 'Buddy Zamanı',
  timeForYou: 'Hatırlat bana.',
  name: 'İsim',
  title: 'Başlık',
  notes: 'Notlar',
  repeat: 'Tekrarla',
  preReminder: 'Ön Hatırlatma',
  remove: 'Kaldırmak',
  considerEventsEndingWith:
    'Belirtilen metinle biten etkinlikler için alarm kurma',
  considerEventsContaining:
    'Belirtilen metni içeren etkinlikler için alarm kurma',
  eventsEndingWith: 'Belirtilen metinle biten etkinlikler',
  eventsContaining: 'Belirtilen metni içeren etkinlikler',
  preReminderShortAlert: '{{duration}} Ön Hatırlatma',
  preReminderTitle: '{{alarmName}} at {{date}}',
  preReminderGroupHelperText:
    'Bu ön hatırlatma sadece sizin içindir. Diğer alarm katılımcıları alarmı aldıktan sonra kendi ön hatırlatıcılarını ayarlayabilirler.',
  addPreReminder: 'Ön Hatırlatma Ekle',
  helperTextForPreReminder:
    'Ön hatırlatıcıyı kaldırmak için üstteki sıfırlama düğmesine dokunun.',
  edit: 'Düzenle',
  delete: 'Sil',
  creator: 'Yaratıcı',
  useAsDefaultGroupConfiguration: 'Gelecek Alarmlara Uygula',
  done: 'Bitti',
  selectAll: 'Hepsini seç',
  skipped: 'Atlandı',
  save: 'Kaydet',
  members: 'Üyeler',
  mobileNumber: 'Telefon Numarası',
  enter: 'Girin',
  addMembers: 'Üye Ekle',
  respond: 'Yanıt verin',
  yes: 'Evet',
  no: 'Hayır',
  notAvailable: 'Mevcut değil',
  cancel: 'İptal',
  participants: 'Katılımcılar',
  takePhoto: 'Fotoğraf Çek',
  chooseFromLibrary: 'Kütüphaneden Seçin',
  resendCode: 'Kodu Yeniden Gönder',
  register: 'Kayıt Olun',
  inviteFriends: 'Bu Uygulamayı Paylaş',
  invite: 'Davet Et',
  incorrectNumber: 'Yanlış Numara mı?',
  date: 'Tarih',
  cascadingAlarmInterval: 'Katılımcı uyarıları arasındaki süre',
  ringParticipantAlarmsByDefault: 'Kabul etmeden alarm çalma',
  alarmRingtone: 'Alarm Zil Sesi',
  pickASong: 'Telefondan müzik seçme',
  privacyPolicy: 'Gizlilik Politikası',
  sendFeedback: 'Geri bildirim',
  galarmWeb: 'Galarm Web',
  galarmEnterprise: 'Galarm Pro',
  galarmAdmin: 'Galarm Yönetici',
  troubleshooting: 'Sorun Giderme',
  alarmDidntRingHelp: 'Yardım edin! Alarmım çalmadı',
  autoStartSettingHelperText:
    'Telefonunuzda otomatik başlatma ayarı varsa, lütfen Galarm için otomatik başlatmanın etkinleştirildiğinden emin olun.',
  batteryOptimizationHelperText:
    'Galarm için pil optimizasyonunu devre dışı bırakın',
  troubleshootingHelperText:
    'Aşağıdaki ayarlar alarmların beklendiği gibi çalmasını engelliyor olabilir. Lütfen bu ayarları gözden geçirin.',
  getMoreHelpText: 'Hala sorun mu yaşıyorsunuz?',
  autoStartSetting: 'Otomatik başlatma',
  batteryOptimization: 'Pil optimizasyonu',
  battery: 'Akü',
  rateTheAppSettings: 'Bu Uygulamayı Değerlendirin',
  about: 'Hakkında & Yardım',
  leaveGroup: 'Gruptan Ayrılın',
  removeGroup: 'Grubu Kaldır',
  viewMember: '{{memberName}} görüntüle',
  removeMember: 'Kaldırmak {{memberName}}',
  changeMemberState: 'Kimin uyarabileceğini değiştirin {{memberName}}',
  changeYourGroupState: 'Sizi kimin uyarabileceğini değiştirin',
  numMembersInGroup: 'Üyelerimiz: {{count}}',
  notifications: 'Uygulama Bildirimleri devre dışı',
  backgroundAppRefresh: 'Arka Plan Uygulama Yenileme devre dışı',
  groupsInCommon: 'Ortak Gruplar',
  alarmsInCommon: 'Ortak Alarmlar',
  close: 'Kapat',
  responsePending: 'Yanıtınız?',
  later: 'Daha sonra',
  install: 'Kurulum',
  all: 'Tümü',
  numYears: {
    one: '1 yıl',
    other: '{{count}} yıllar'
  },
  numMonths: {
    one: '1 ay',
    other: '{{count}} aylar'
  },
  numDays: {
    one: '1 gün',
    other: '{{count}} günler'
  },
  hours: {
    one: '1 saat',
    other: '{{count}} saatler'
  },
  minutes: {
    one: '1 dakika',
    other: '{{count}} dakika'
  },
  seconds: {
    one: '1 saniye',
    other: '{{count}} saniye'
  },
  minutesSmall: '{{count}} min',
  secondsSmall: '{{count}} sn',
  hoursAfter: {
    one: '1 saat sonra',
    other: '{{count}} saatler sonra'
  },
  minutesAfter: {
    one: '1 dakika sonra',
    other: '{{count}} dakikalar sonra'
  },
  hoursAfterBuddy: {
    one: 'Dostumdan 1 saat sonra',
    other: "{{count}} buddy'den saatler sonra"
  },
  minutesAfterBuddy: {
    one: "Buddy'den 1 dakika sonra",
    other: "{{count}} Buddy'den dakikalar sonra"
  },
  longerThanAnHour: '> 1 saat',
  licenses: 'Üçüncü Taraf Lisanslama',
  version: 'Versiyon',
  termsOfService: 'Hizmet Koşulları',
  showPrivacyPolicy: '> Gizlilik Politikası',
  showTermsOfService: '> Hizmet Koşulları',
  showLicenses: '> Üçüncü Taraf Lisanslama',
  change: 'Değiştir',
  snooze: 'Ertele',
  somethingWentWrong: 'Bir şeyler ters gitti. Lütfen sayfayı yenileyin.',
  ringOnVibrate: 'Sessiz Çalma',
  vibrate: 'Titreşim',
  ringOnEarphoneOnly: 'Yalnızca kulaklıkta zil alarmı',
  ringOnSpeakerAndEarphone: 'Hoparlör ve kulaklıkta zil alarmı',
  whenEarphoneIsConnected: 'Kulaklık bağlandığında',
  tapGesture: 'Dokunun',
  slideGesture: 'Slayt',
  silent: 'Sessiz',
  volume: 'Ses Seviyesi',
  soundAndVibration: 'Ses ve Titreşim',
  advancedSettings: 'Gelişmiş Ayarlar',
  gestureToDismissAnAlarm: 'Bir alarmı kapatmak için hareket',
  someNotificationsAreMuted: 'Bazı bildirimlerin sesi kapatıldı',
  allNotificationsEnabled: 'Tüm bildirimler etkinleştirildi',
  notificationSettings: 'Bildirim Ayarları',
  missedAlarmsPlacement: 'Kaçırılan alarmların yeri',
  missedAlarmsPlacementTooltipMessage:
    'Kaçırılan alarmların alarm listenizde nerede görüneceğini seçin.',
  showMissedAlarmsOnTop: 'Üstte göster',
  showMissedAlarmsAfterUpcoming: 'Yaklaşan alarmlardan sonra göster',
  showMissedAlarmsNotification: 'Üstte bildirim göster',
  hideMissedAlarms: 'Kaçırılan alarmları gösterme',
  galarmWebNotifications: 'Galarm Web Bildirimleri',
  alarmsfromOthersNotifications: 'Katılımcı Alarmları Bildirimleri',
  sharedAlarmNotifications: 'Paylaşılan Alarm Bildirimleri',
  alarmChatNotifictions: 'Alarm Sohbet Bildirimleri',
  groupNotifications: 'Grup Bildirimleri',
  alarmAcknowledgementNotifications: 'Alarm Onay Bildirimleri',
  send: 'Gönder',
  prev: 'Önceki',
  snoozing: '{{timeString}}',
  snoozingStatus: 'Erteleme',
  specifySnoozeDuartion: 'Erteleme süresini belirtin',
  chooseDifferentDuration: 'Farklı bir süre seçin',
  noCalendarsFound: 'Cihazda takvim bulunamadı.',
  eventWillEndAt: 'Etkinlik {{timeString}} adresinde sona erecektir.',
  selectDurationWithinTheSameDay: 'Olay gün sınırını geçemez.',
  cannotMapRepeatTypeInTheDeviceCalendar:
    'Alarmınızın "Tekrarla" ayarı takvim tarafından desteklenmediği için "Takvime Aktar" yapılamıyor.',
  alarmSavedToCalendar: 'Alarm başarılı bir şekilde takvime kaydedildi.',
  faq: 'Sıkça Sorulan Sorular',
  searchingFaqs: 'İlgili yardım makaleleri aranıyor...',
  faqsMayHelp: 'Sorunuzu yanıtlayabilecek bazı yardım makaleleri bulduk:',
  noFaqsFound: 'İlgili yardım makalesi bulunamadı.',
  sendFeedbackAnyway: 'Geri bildirimi yine de gönder',
  editFeedback: 'Geri bildirimi düzenle',
  submitProblemAnyway: 'Sorunu yine de gönder',
  editProblem: 'Sorunu düzenle',
  openSettings: 'Ayarları Aç',
  openAppSettings: 'Uygulama Ayarlarını Açın',
  alreadyDone: 'Bitti',
  enableAutoStart: 'Otomatik Başlatmayı Etkinleştir',
  restrictedApps: 'Kısıtlı Uygulamalar',
  unmonitoredApps: 'İzlenmeyen Uygulamalar',
  enableProtected: 'Korumalı Uygulamalar',
  manageAppLaunch: 'Uygulama Başlatmayı Yönetme',
  unblockContact: 'İletişim Engelini Kaldır',
  blockContact: 'Kişiyi Engelle',
  call: 'Arayın {{name}}',
  text: 'Metin {{name}}',
  chat: 'Sohbet',
  ok: 'TAMAM.',
  stopSnooze: 'Ertelemeyi Durdur',
  emailId: 'E-posta Adresiniz',
  feedback: 'Geri bildirim',
  submit: 'Gönder',
  reportAProblem: 'Sorun Bildir',
  enableAlarm: 'Alarmı Etkinleştir',
  restoreAlarm: 'Alarmı Geri Yükle',
  deletePastAlarms: 'Etkin Olmayan Alarmları Sil',
  accept: 'Kabul et',
  defaultPersonalAlarmName: 'Kişisel Hatırlatma',
  defaultGroupAlarmName: 'Grup Etkinliği',
  defaultRecipientAlarmName: 'Buddy Alarm',
  search: 'Arama',
  recent: 'Yakın zamanda',
  upcoming: 'Yaklaşan',
  missed: 'Cevapsız',
  expired: 'Kaçırıldı',
  past: 'Geçmiş',
  active: 'Aktif',
  inactive: 'Aktif değil',
  allAlarms: 'Tüm Alarmlar',
  myAlarms: 'Alarmlarım',
  participantAlarms: 'Katılımcı Alarmları',
  pendingParticipantAlarms: 'Diğerlerinden Yeni Alarmlar',
  alarmsWithUnreadChatMessages: 'Yeni Sohbet ile Alarmlar',
  systemNotifications: 'Sistem Mesajları',
  missedAlarms: 'Kaçırılan Alarmlar',
  missedAlarmsInCategory: '{{name}} Kaçırılan Alarmlar',
  showMissedAlarms: 'Kaçırılan Alarmları Göster',
  recentlyDeletedAlarms: 'Son Silinen Alarmlar',
  searchAlarms: 'Arama Alarmları',
  searchTasks: 'Arama görevleri',
  startTypingToSearchTasks: 'Görevleri aramak için yazmaya başlayın',
  noTasksFoundForSearch: '"{{searchText}}" ile eşleşen görev bulunamadı',
  participant: 'Katılımcı',
  you: 'Sen',
  none: 'Hiçbiri',
  onceOnly: 'Sadece bir kez',
  weekdays: 'Hafta içi',
  weekends: 'Hafta Sonları',
  everyDayString: 'Günlük',
  everySunday: 'Her Pazar',
  everyMonday: 'Her Pazartesi',
  everyTuesday: 'Her Salı',
  everyWednesday: 'Her Çarşamba',
  everyThursday: 'Her Perşembe',
  everyFriday: 'Her Cuma',
  everySaturday: 'Her Cumartesi',
  sunday: 'Pazar',
  monday: 'Pazartesi',
  tuesday: 'Salı',
  wednesday: 'Çarşamba',
  thursday: 'Perşembe',
  friday: 'Cuma',
  saturday: 'Cumartesi',
  january: 'Ocak',
  february: 'Şubat',
  march: 'Mart',
  april: 'Nisan',
  may: 'Mayıs',
  june: 'Haziran',
  july: 'Temmuz',
  august: 'Ağustos',
  september: 'Eylül',
  october: 'Ekim',
  november: 'Kasım',
  december: 'Aralık',
  jan: 'Jan',
  feb: 'Şubat',
  mar: 'Mar',
  apr: 'Nisan',
  shortMay: 'Mayıs',
  jun: 'Haziran',
  jul: 'Temmuz',
  aug: 'Ağustos',
  sep: 'Eylül',
  oct: 'Ekim',
  nov: 'Kasım',
  dec: 'Aralık',
  sun: 'Paz',
  mon: 'Pzt',
  tue: 'Salı',
  wed: 'Çar',
  thu: 'Per',
  fri: 'Cuma',
  sat: 'Cmt',
  first: '1.',
  second: "2'nci",
  third: "3'üncü",
  fourth: 'Dördüncü',
  fifth: "5'inci",
  every: 'Her',
  oddNumberedDays: 'Tek Numaralı Tarihler',
  evenNumberedDays: 'Çift Numaralı Tarihler',
  noParticipants: 'Katılımcı Yok',
  typeYourMessage: 'Mesajınızı yazın',
  cantPostMessageToPastAlarm: 'Etkin olmayan bir alarma mesaj gönderilemiyor',
  groupName: 'Grup: {{name}}',
  confirmed: 'onaylandı',
  declined: 'reddedildi',
  Done: 'Bitti',
  Skip: 'Atla',
  Confirm: 'Onaylayın',
  Decline: 'Reddet',
  Accept: 'Kabul et',
  today: 'bugün',
  on: 'üzerinde',
  recipientAlarm: 'Buddy Alarm',
  recipient: 'Alıcı',
  remindMeAfter: 'Hatırlat bana.',
  remindMeIn: 'Hatırlat bana.',
  newRecipientAlarm: 'Yeni Buddy Alarmı',
  editRecipientAlarm: 'Buddy Alarmını Düzenle',
  newInstantAlarm: 'Yeni Anlık Alarm',
  instantAlarms: 'Anlık Alarmlar',
  noTaskAlarms: `Görev alarmı yok

Görev alarmları, görevlerden ve görev listelerinden ayarlanır.`,
  taskAlarmName: 'Görev: {{alarmName}}',
  noInstantAlarms: `Anlık alarm yok

Anlık alarmlar, acil durumlar veya bazı acil görevlerde bir kişiyi veya grubu anında uyarmak için kullanılabilir.`,
  alarmDone: 'Alarm İşaretlendi Tamamlandı',
  alarmSkipped: 'Alarm Atlandı',
  undo: 'Geri al',
  enterVerificationCode: 'Lütfen aşağıdaki 4 haneli kodu giriniz:',
  initializing: 'Başlatma',
  tryAgain: 'Tekrar Deneyin',
  nMore: '+ {{count}} daha fazla',
  enableNotification: 'Etkinleştir',
  enableAlarmNotificationChannel: 'Etkinleştir',
  enableBackgroundAppRefresh: 'Etkinleştir',
  viewImpactedAlarms: 'Alarmlar',
  viewImpactedGroups: 'Gruplar',
  dismiss: 'Dağılın',
  minsInterval: '+ {{count}}m',
  secsInterval: '+ {{count}}s',
  hoursInterval: '+ {{count}}h',
  daysInterval: '+ {{count}}d',
  snoozeUnitHours: 'Saatler',
  snoozeUnitMinutes: 'Dakika',
  snoozeUnitDays: 'Günler',
  selectMinutes: 'Dakikaları seçin',
  selectHours: 'Saatleri seçin',
  selectDays: 'Günleri seçin',
  selectHoursAndMinutes: 'Saat ve dakikaları seçin',
  enterDuration: 'Süre',
  snoozeUnit: 'Birim',
  specifySnoozeUnit: 'Erteleme birimini belirtin',
  specifySnoozeDuration: 'Erteleme süresini belirtin',
  duration: 'Süre',
  quickAlarmName: {
    zero: '{{minutes}} min hatırlatma',
    one: '{{hours}} saat hatırlatması',
    other: '{{hours}} saat {{minutes}} dakika hatırlatma'
  },
  alarmTitleForGoogleVoiceTimerCommand: '{{durationString}} Hatırlatma',
  addedAlarmFromVoiceCommand:
    '{{alarmName}} adresi için bir alarm eklendi. {{dateString}}',
  addedTimerFromVoiceCommand: 'için bir zamanlayıcı eklendi {{duration}}',
  clear: 'Temiz',
  ringtoneDuration: 'Zil Sesi Süresi',
  chooseDuration: 'Bir süre seçin. Toplamak için birden fazla kez dokunun.',
  newAlarm: 'Yeni Alarm',
  quickAlarm: 'Hızlı Hatırlatma',
  quickAlarmWillRingAt: 'Alarm {{timeString}} adresinde çalacaktır.',
  alarmWithSnoozeAt: 'Alarm bir sonraki çalma saatinde {{timeString}}',
  preReminderWillRingAt: {
    zero: 'Bu alarm için bir ön hatırlatma çalacaktır \n {{timeString}} adresinde.',
    one: 'Bu alarm için bir ön hatırlatma çalacaktır \nÖnceki gün {{timeString}} adresinde.',
    other:
      'Bu alarm için bir ön hatırlatma çalacaktır \n {{timeString}} {{count}} adresinden günler önce.'
  },
  random: 'Rastgele',
  enableAllAlarms: 'Tüm alarmları etkinleştirin',
  disableAllAlarms: 'Tüm alarmları devre dışı bırak',
  deleteAllAlarms: 'Tüm alarmları sil',
  hideCategory: 'Kategori Gizle',
  unhideCategory: 'Kategoriyi Göster',
  dontShowHiddenCategories: 'Gizli kategorileri gösterme',
  showHiddenCategories: 'Gizli kategorileri göster',
  welcomeAlarmsTitle: 'Hadi başlayalım!',
  welcomeAlarmsMessage: 'İşte yaygın olarak kullanılan bazı alarmlar:',
  onboardingAlarms: 'İşe Alım Alarmları',
  hiddenAlarmCategories: 'Gizli kategoriler',
  restorePurchases: 'Satın Almaları Geri Yükle',
  noAvailablePurchasesFound:
    'Hesabınız için kullanılabilir satın alma bulunamadı.\n\nGeri yükleyemediğiniz geçerli bir satın alma işleminiz varsa lütfen "Ayarlar > Geri Bildirim" seçeneğini kullanarak bize bir geri bildirim gönderin.',
  restoringPurchases: 'Satın alımların geri yüklenmesi',
  fetchingContacts: 'Hangi kişilerin Galarm kullandığını kontrol etme',
  enterNameAndUploadPhotoForUser:
    'Aşağıya adınızı girin ve isteğe bağlı olarak profil fotoğrafınızı yükleyin',
  enterNameAndUploadPhotoForGroup:
    'Aşağıya bir isim girin ve isteğe bağlı olarak bir grup fotoğrafı yükleyin',
  noContactsWithAppInstalled: 'Rehberinizdeki hiç kimse Galarm kullanmıyor.',
  galarmContacts: {
    one: '1 Galarm kontağı',
    other: '{{count}} Galarm iletişim bilgileri'
  },
  contactsPendingInvitation: {
    one: '1 bekleyen davetiye',
    other: '{{count}} bekleyen davetler'
  },
  otherContacts: {
    one: '1 diğer kişi',
    other: '{{count}} di̇ğer ki̇şi̇ler'
  },
  over100Contacts: "100'den fazla diğer kişi",
  noAlarms: 'Hiç alarmınız yok. Yeni bir alarm eklemek için + öğesine dokunun.',
  noContactsWeb: {
    one: 'Galarm kullanan herhangi bir kişi bulamadık. Ya kişilerinize erişim iznimiz yok ya da kişileriniz arasında Galarm kullanan kimse yok. Kişilerinizi mobil uygulamadan senkronize edebilirsiniz.\n\nUygulamadan yararlanmak için Galarm kullanan kişileri alarmlarınıza farklı şekillerde ekleyebilirsiniz',
    other:
      'Alarmlarınıza kişi eklemeye başlamak için lütfen mobil uygulamaya kaydolun.'
  },
  viewingAlarmsInCommon: 'Şunlarla ortak alarmlar {{name}}',
  viewingGroupsInCommon: 'İle ortak gruplar {{contactName}}',
  changeGroupMemberConfigTextForCascadingAlarm:
    'Aktif katılımcılar gösterilen sırada uyarılacaktır.',
  changeGroupMemberConfigTextForSimultaneousAlarm:
    'Yalnızca aktif katılımcılar uyarılacaktır.',
  changeGroupMemberStateText: {
    zero: '"{{groupName}}" grubu için bir alarm oluşturulduğunda sizi uyarabilecek üyeleri değiştirin.\n\nYalnızca izin verilen üyeler tarafından alarm oluşturulduğunda uyarılırsınız.',
    one: '"{{groupName}}" grubu için bir alarm oluşturulduğunda {{memberName}} adresini uyarabilecek üyeleri değiştirin.\n\n{{memberName}} yalnızca alarm izin verilen üyeler tarafından oluşturulduğunda uyarılacaktır.'
  },
  allowed: 'İzin verildi',
  notAllowed: 'İzin Verilmedi',
  changeStatus: 'İzin Verilen Üyeler',
  noUpcomingAlarms: 'Yaklaşan alarm yok',
  showMore: 'Daha Fazla Göster',
  nMorePastAlarms: {
    one: '1 etkin olmayan alarm daha',
    other: '{{count}} daha fazla etkin olmayan alarm'
  },
  shareAppMessage:
    'Galarm uygulamasını kullanarak hatırlatıcılar oluşturarak tüm işlerimi zamanında hallediyorum. Bu uygulama sayesinde birbirimizi de hatırlatmalarımıza dahil edebiliyoruz. Bu yenilikçi alarm ve hatırlatma uygulamasını indirmenizi tavsiye ederim. {{downloadLink}}',
  addingMembers: 'Üye ekleniyor.',
  unableToAddMembers: 'Üye eklenemiyor. {{error}}',
  removingMember: 'Üye çıkarılıyor.',
  unableToRemoveMember: 'Üye çıkarılamıyor. {{error}}',
  leavingGroup: 'Gruptan ayrılıyorum.',
  unableToLeaveGroup: 'Gruptan ayrılamıyorum. {{error}}',
  expiredPersonalAlarmForCreator: {
    zero: 'Bu alarmın süresi {{durationString}} önce doldu. Alarmı tamamlamak için "Bitti "ye dokunun.',
    one: 'Bu alarmın süresi {{durationString}} önce dolmuştur. Alarmı tamamlamak ve katılımcıları bilgilendirmek için "Bitti "ye dokunun.',
    other:
      'Bu alarmın süresi {{durationString}} önce dolmuştur. Alarmı tamamlamak ve katılımcıları bilgilendirmek için "Bitti "ye dokunun.'
  },
  donePersonalAlarmForCreator:
    'Bu alarmın süresi {{durationString}} önce doldu. Alarm tamamlandı olarak işaretlendi.',
  skippedPersonalAlarmForCreator:
    'Bu alarmın süresi {{durationString}} önce doldu. Alarmı atladınız.',
  expiredGroupAlarm:
    'Bu alarmın süresi {{durationString}} önce doldu. Lütfen katılımınızı onaylayın.',
  expiredPersonalAlarmForParticipant:
    'Bu alarmın süresi {{durationString}} önce doldu. Lütfen {{creatorName}} adresini hatırlatın.',
  alarmDurationAndroid:
    'Alarm şu andan itibaren {{durationString}} için ayarlandı.',
  alarmDurationIos:
    'Alarm şu andan itibaren {{durationString}} için ayarlandı.',
  alarmFeedbackHeader:
    'Hata ayıklama amacıyla bu alarmın bilgilerinin bir kısmını göndereceksiniz. Alarm adı, notlar veya katılımcılar gibi kişisel veriler paylaşılmayacaktır.',
  privacyPolicyHeader:
    "Gizliliğinize duyduğumuz saygı saatlerimizin tik takları arasında sürekli ilerliyor. Tıpkı sizin gibi biz de gizliliğe değer veriyoruz, bu nedenle uygulamanın yüklenmesi için gerekmedikçe veya yasalar gerektirmedikçe kişisel bilgilerinizi kimseyle paylaşmadığımızı bilmenizi isteriz. Her durumda, bilgilerinizi asla satmıyoruz. Bu kadar basit!\n \nOluşturduğunuz alarmlar yalnızca sizin cihazınızda ve alarm diğer katılımcıları da içeriyorsa bu katılımcıların cihazlarında görüntülenebilir.\n \nTelefonunuzun adres defterine/kişi listesine yalnızca Galarm'daki kişiler sekmesini doldurmak için erişiyoruz. Bu listeyi başka bir amaç için saklamıyoruz. Adres defteriniz olmasından onur duyuyoruz!\n \nKameranıza ve fotoğraflarınıza yalnızca iyi bir profil resmi ayarlamanızı sağlamak için erişiyoruz. Bu resim sizin avatarınız veya düzenlediğiniz bir grubun profil resmi olarak görünür. Kurduğunuz alarmlara üye olan diğer Galarm kullanıcıları bu resmi görebileceklerdir.\n\nCihazınızın genel IP'sini ve benzersiz kimliğini tüm taleplerle birlikte gönderiyoruz, örneğin kayıt işlemi sırasında kodu talep ederken ve doğrularken. Bu bilgiler hesabınızla bağlantılı değildir ve yalnızca olası kötü niyetli faaliyetleri belirlemek için kullanılır.\n \nTopladığımız bilgiler ve bunları nasıl kullandığımız hakkında daha fazla ayrıntı için lütfen gizlilik politikasının tamamını inceleyin.",
  termsOfServiceHeader:
    "Galarm uygulamasını kullanarak, bu mobil uygulamaya ve sunduğu özellik ve hizmetlere erişiminizi ve bunları kullanımınızı düzenleyen Hizmet Koşullarımızı kabul etmiş olursunuz. \n\nGalarm'ın sloganı basit -- hiçbir etkinliği kaçırmamanıza yardımcı olmak!  İster uyanma uyarıları, randevulara zamanında yetişme ve ilaçları zamanında alma gibi faaliyetler için hatırlatıcılar ayarlamak üzere Kişisel Alarmlar kurun, ister sinema gezileri, spor etkinlikleri ve partiler gibi grup etkinliklerini organize etmek için Grup Alarmları oluşturun, Galarm birbirinize hatırlatmak, birbirinizin durumunu takip etmek ve iletişim kurmak için sosyal bir alarm saatine sahip olmanızı sağlar.\n\nLütfen Galarm'ı yalnızca bu şartları kabul ediyorsanız kullanın. Aşağıda bir bağlantı bulunmaktadır.",
  acknowledgedPersonalAlarm:
    'Alarmı "Bitti" olarak işaretlediniz {{durationString}} önce.',
  skippedPersonalAlarm: 'Alarmı {{durationString}} önce atladın.',
  authenticatingWithServer: 'Bağlanıyorum.',
  selectParticipantsForPersonalAlarm:
    'Kişisel alarmınız için yedek olarak hareket eden bir grup veya bir dizi kişi seçin.',
  selectParticipantsForGroupAlarm:
    'Grup faaliyetiniz için bir grup veya bir grup insan seçin.',
  acknowledgedGroupAlarm:
    'Bu alarmı {{acknowledgedAsString}} {{durationString}} önce vermiştiniz.',
  acknowledgedExpiredGroupAlarm:
    'Bu alarmın süresi {{durationString}} önce doldu. Bu alarmı {{acknowledgedAsString}}.',
  acknowledgedPersonalAlarmForParticipant:
    '{{creatorName}} alarmı "Bitti" olarak işaretledim {{durationString}} önce.',
  acknowledgedExpiredPersonalAlarmForParticipant:
    'Bu alarmın süresi {{durationString}} önce doldu. {{creatorName}} alarmı "Bitti" olarak işaretledi.',
  entityNotFound:
    'Oops! Seçilen {{entityType}} adresini bulamadık. Hala geri alıyor olabiliriz veya kaldırılmış olabilir.',
  goBack: 'Geri Dön',
  uploadingImageToServer: 'Sunucuya görüntü yükleniyor.',
  deletingImageFromServer: 'Sunucudan görüntü silme',
  errorUploadingImageToServer:
    'Resim sunucuya yüklenirken hata oluştu. Lütfen daha sonra tekrar deneyin.',
  unableToRemoveGroup: 'Grup kaldırılamıyor. {{error}}',
  addingGroup: 'Grup ekleniyor.',
  editingGroup: 'Düzenleme grubu.',
  unableToAddGroup: 'Grup eklenemiyor. {{error}}',
  unableToEditGroup: 'Grup düzenlenemiyor. {{error}}',
  thanksForFeedback: 'Gelişmemize yardımcı olduğunuz için teşekkür ederiz.',
  licensesHeader:
    'Galarm üçüncü taraflarca lisanslanmış yazılımlar içerir. İlgili atıf ve lisanslama bilgileri için lütfen Üçüncü Taraf Lisanslama sayfamıza bakın.',
  alarmAlreadyInSnooze: '{{durationString}} adresinde size hatırlatılacaktır.',
  carrierChargesMayApply: 'Taşıyıcı ücretleri uygulanabilir.',
  verficationCodeInfo:
    'Size 4 haneli bir kod içeren bir kısa mesaj veya telefon araması gönderilecektir.',
  verficationCodeInfoWhatsApp:
    'Size 4 haneli bir kod içeren bir WhatsApp mesajı gönderilecektir.',
  selectCascadingInterval:
    'İlk katılımcı alarm saatinden {{firstParticipantDurationString}} sonra uyarılacak, ikinci katılımcılar alarm saatinden {{secondParticipantDurationString}} sonra uyarılacak ve alarmı tamamlandı olarak işaretlemezseniz bu şekilde devam edecektir.',
  reorderParticipantsScreenDescription:
    'Katılımcılar gösterilen sırada uyarılacaktır.',
  noMembers: 'Üye yok',
  selectedGroupDescription: {
    zero: '{{numActiveMembers}} Katılımcılar',
    one: '{{numActiveMembers}} aktif ve {{numInactiveMembers}} inaktif katılımcı',
    other:
      '{{numActiveMembers}} aktif ve {{numInactiveMembers}} inaktif katılımcılar'
  },
  groupAlarmWillRingAtSameTime:
    'Tüm katılımcılar {{timeString}} adresinden uyarılacaktır.',
  welcomeToGalarm: "Galarm'a Hoş Geldiniz",
  checkingConnection: 'Bağlantı kontrolü',
  deletePastAlarmsTitle: "'den daha eski aktif olmayan alarmları silin.",
  deletePastAlarmsOption: {
    zero: '{{option}} (0 alarm)',
    one: '{{option}} (1 alarm)',
    other: '{{option}} ({{count}} alarmlar)'
  },
  deletePastAlarmsNotificationMessage:
    'Çok sayıda etkin olmayan alarmınız var. Lütfen artık ihtiyacınız olmayan alarmları silin.',
  chooseSnoozeInterval: 'Bana tekrar hatırlat',
  personalAlarmDescription:
    'Uyanmak, ilaç almak veya kendiniz için başka herhangi bir görev için kişisel bir alarm kullanın. İsteğe bağlı olarak, bir alarmı kaçırdığınızda size hatırlatabilmeleri için uyarılan katılımcılar ekleyebilirsiniz. Alarmı tamam olarak işaretlediğinizde katılımcılar da bilgilendirilir.',
  groupAlarmDescription:
    'Geziler, partiler veya başka herhangi bir etkinlik gibi grup etkinlikleri için bir grup alarmı kullanın. Alarm tüm katılımcılar için aynı anda çalar ve katılımlarını onaylayabilirler.',
  instantAlarmDescription:
    'Bu alarmı, bir acil durum tatbikatı, bir oyunun başlangıcı, acil bir görev/toplantı ve acil dikkat gerektiren diğer olaylar için bir kişiyi veya kişi grubunu uyarmak için kullanın.',
  recipientAlarmDescription:
    'Başka birine ("arkadaş") yapması gereken şeyleri hatırlatmak için alarmlar oluşturun. Alarmı kaçırması durumunda arkadaşınıza hatırlatmak için uyarılırsınız. Ayrıca, arkadaşınız alarmın tamamlandığını işaretlediğinde de bilgilendirileceksiniz.\n  \nAlarmların sizin saat diliminizde oluşturulduğunu unutmayın.',
  whatsThis: 'Bu da ne?',
  alarmCurrentlyDisabled: 'Bu alarm şu anda devre dışıdır',
  alarmCurrentlyRejected: 'Bu alarm şu anda reddedilmiştir',
  currentlyTypingUsers: {
    one: '{{currentlyTypingUsers}} yazıyor.',
    other: '{{currentlyTypingUsers}} yazıyor.'
  },
  noSearchResultsFound: '{{type}} bulunamadı',
  noGroupsCreated: 'Herhangi bir grup oluşturmadınız.',
  noGroupsWeb: {
    one: 'Herhangi bir grup oluşturmadınız.',
    other:
      'Grup oluşturmaya ve alarmlara eklemeye başlamak için lütfen mobil uygulamadan kaydolun.'
  },
  internalErrorDuringRegistration:
    'Kullanıcı kaydı sırasında dahili bir hata oluştu. Lütfen birkaç dakika sonra tekrar deneyin',
  selectRecipientAlarmInterval: {
    zero: 'Alıcı ile aynı anda uyarı alacaksınız',
    one: "Alıcı alarmı 'Bitti' olarak işaretlemezse alarm saatinden sonra {{durationString}} adresine uyarı gönderilir.",
    other:
      "Alıcı alarmı 'Bitti' olarak işaretlemezse alarm saatinden sonra {{durationString}} adresine uyarı gönderilir."
  },
  selectRecipient: 'Alıcı Seçin',
  acknowledgedExpiredRecipientAlarm:
    'Bu alarmın süresi {{durationString}} önce doldu. Bu alarmı "Bitti" olarak işaretlediniz.',
  skippedExpiredRecipientAlarm:
    'Bu alarmın süresi {{durationString}} önce doldu. Bu alarmı atladınız.',
  expiredRecipientAlarm:
    'Bu alarmın süresi {{durationString}} önce dolmuştur. Alarmı tamamlamak ve {{creatorName}} adresine bildirmek için "Bitti "ye dokunun.',
  acknowledgedRecipientAlarm:
    'Bu alarmı {{durationString}} adresinde "Bitti" olarak işaretlediniz.',
  skippedRecipientAlarm: 'Bu alarmı {{durationString}} önce atladınız.',
  acknowledgedExpiredRecipientAlarmForCreator:
    'Bu alarmın süresi {{durationString}} önce doldu. {{recipientName}} alarmı "Bitti" olarak işaretledi.',
  skippedExpiredRecipientAlarmForCreator:
    'Bu alarmın süresi {{durationString}} önce doldu. {{recipientName}} alarmı atladı.',
  expiredRecipientAlarmForCreator:
    'Bu alarmın süresi {{durationString}} önce doldu. Lütfen {{recipientName}} adresini hatırlatın.',
  acknowledgedRecipientAlarmForCreator:
    '{{recipientName}} alarmı "Bitti" olarak işaretledim {{durationString}} önce.',
  selectRecipientForRecipientAlarm: 'Alarm için bir alıcı seçin',
  selectAtLeastOneParticipantForGroupAlarm:
    'Alarma en az bir katılımcı ekleyin',
  addAtLeastOneMemberToGroup: 'Gruba en az bir üye ekleyin',
  atTheSameTime: 'Aynı zamanda',
  myself: 'Kendim',
  group: 'Grup',
  someoneElse: 'Başka Biri',
  participantsAreNotified: 'Katılımcılar bilgilendirilir.',
  creatorIsNotified: '{{creatorName}} bildirilir.',
  membersAddedToGroup: {
    one: '{{memberNames}} {{groupName}} grubuna eklenir.',
    other: '{{memberNames}} {{groupName}} grubuna eklenir.'
  },
  memberRemovedFromGroup:
    '{{memberName}} {{groupName}} grubundan kaldırılmıştır, bu da bazı alarmlarınızı etkilemiş olabilir.',
  youRemovedFromGroup:
    'Bazı alarmlarınızı etkilemiş olabilecek {{groupName}} grubundan çıkarıldınız.',
  memberLeftGroup:
    '{{memberName}} {{groupName}} grubundan ayrıldı, bu da bazı alarmlarınızı etkilemiş olabilir.',
  youLeftGroup:
    '{{groupName}} grubundan ayrıldınız, bu da bazı alarmlarınızı etkilemiş olabilir.',
  groupLeft: '{{groupName}} grubundan ayrıldınız.',
  memberMovedToADifferentTimezone:
    '{{memberName}} farklı bir saat dilimine taşındı, bu da bazı alarmlarınızı etkilemiş olabilir.',
  memberDstChanged: {
    zero: '{{memberName}} yaz saati uygulamasını durdurmuştur. İlgili alarmlar güncellenmiştir.',
    one: '{{memberName}} yaz saati uygulamasına başladı. İlgili alarmlar güncellenmiştir.'
  },
  impactedAlarms: 'Etkilenen alarmlar:',
  alwaysRingParticipantAlarmsOn:
    'Siz reddetmediğiniz sürece başkalarından gelen alarmlar çalacaktır.',
  alwaysRingParticipantAlarmsOff:
    'Siz kabul etmediğiniz sürece başkalarından gelen alarmlar çalmayacaktır.',
  agreeToTermsOfServiceAndPrivacyPolicy:
    "Devam ederek, Galarm'ın Hizmet Koşullarını ve Gizlilik Politikasını kabul etmiş olursunuz.",
  deleteAccountWarningHeader:
    'Uyarı: Bu işlem geri alınamaz. Hesabınızı silerseniz:',
  deleteAccountDeleteAlarms: '- Oluşturduğunuz tüm alarmları silin',
  deleteAccountDeleteRecipientAlarms:
    '- Alıcısı olduğunuz tüm arkadaş alarmlarını silin',
  deleteAccountRemoveFromGroups: '- Sizi tüm gruplardan çıkarın',
  cancelSubscriptionWarning:
    'Aktif bir premium aboneliğiniz var. Hesabınızı silmek bunu otomatik olarak iptal etmez. Gelecekteki ücretlerden kaçınmak için aboneliğinizi iptal edin.',
  deleteAccountWarningFooter: {
    zero: 'Telefon değiştiriyorsanız, uygulamayı yeni telefonunuza yükleyebilir ve aynı numarayı kullanarak kayıt olabilirsiniz. Bu telefondaki uygulamayı kaldırabilirsiniz.\n\nHesabınızı sildikten sonra geri yükleyemezsiniz.',
    one: 'Telefon değiştiriyorsanız, uygulamayı yeni telefonunuza yükleyebilir ve aynı numarayı kullanarak kayıt olabilirsiniz. Bu telefondaki uygulamayı kaldırabilirsiniz.\n\nHesabınızı sildikten sonra geri yükleyemezsiniz. Aktif Galarm aboneliğinizi Play Store üzerinden yönetebilirsiniz.',
    other:
      'Telefon değiştiriyorsanız, uygulamayı yeni telefonunuza yükleyebilir ve bu telefondaki uygulamayı silebilirsiniz.\n\nHesabınızı sildikten sonra geri yükleyemezsiniz. Aktif Galarm aboneliğinizi App Store üzerinden yönetebilirsiniz.'
  },
  typeConfirmationStringToDeleteAccount:
    'Hesabınızı silmek için {{confirmationString}} yazın',
  unableToDeleteAccount: 'Hesap silinemiyor. {{error}}',
  impactedGroups: 'Etkilenen gruplar:',
  memberDeletedAccount:
    '{{memberName}} hesaplarını silmiş ve bu durum bazı alarmlarınızı ve gruplarınızı etkilemiş olabilir.',
  confirmCountryCodeAndEnterNumber:
    'Lütfen ülke kodunuzu onaylayın ve telefon numaranızı girin.',
  confirmCountryCodeAndEnterNumberForExistingUser:
    'Lütfen ülke kodunuzu onaylayın ve daha önce kayıt olurken kullandığınız telefon numarasını girin.',
  requiredPermissionsDisabledWarningIos:
    'Bildirimler devre dışı bırakılır. Alarmlar çalmayacaktır. Düzeltmek için dokunun.',
  requiredPermissionsDisabledWarningAndroid:
    'Galarm alarm çalmak için gerekli izinlere sahip değil. Düzeltmek için dokunun.',
  notificationChannelPopupDisabledWarningAndroid:
    'Alarm bildirimleri ekranda açılmıyor. Düzeltmek için dokunun.',
  alarmLockScreenNotificationDisabledWarningAndroid:
    'Alarm bildirimleri kilit ekranında görünmez. Düzeltmek için dokunun.',
  contactPermissionNotGranted:
    "Galarm'ın kişilerinize erişim izni yok. Telefonunuzun adres defterine eklenen yeni kişiler Galarm ile senkronize edilmiyor. Düzeltmek için dokunun.",
  why: 'Neden',
  how: 'Nasıl',
  registrationRequired: 'Kayıt Gerekli',
  phoneNumberRequired: 'Telefon Numarası Gerekli',
  fewSeconds: 'birkaç saniye',
  lessThanMinute: 'bir dakikadan az',
  updateUnsupportedVersion:
    "Galarm'ı kullanmaya devam etmek için uygulamanın güncellenmiş bir sürümü gereklidir.",
  update: 'Güncelleme',
  back: 'Geri',
  unableToMarkAlarmDone:
    'Şu anda alarm tamamlandı olarak işaretlenemiyor. Lütfen birkaç dakika içinde tekrar deneyin.',
  unableToMarkAlarmUndone:
    'Şu anda alarm geri alındı olarak işaretlenemiyor. Lütfen birkaç dakika içinde tekrar deneyin.',
  unableToMarkAlarmUnskipped:
    'Şu anda alarm atlanmamış olarak işaretlenemiyor. Lütfen birkaç dakika içinde tekrar deneyin.',
  unableToSkipAlarm:
    'Şu anda alarm atlanamıyor. Lütfen birkaç dakika içinde tekrar deneyin.',
  unableToSetGroupAlarmResponse:
    'Grup alarmı şu anda {{response}} adresinden alınamıyor. Lütfen birkaç dakika içinde tekrar deneyin.',
  unableToDeleteAlarm:
    'Şu anda alarm silinemiyor. Lütfen birkaç dakika içinde tekrar deneyin.',
  unableToSetAlarmResponse:
    'Şu anda yanıtınız ayarlanamıyor. Lütfen birkaç dakika içinde tekrar deneyin.',
  unableToSnoozeAlarm: 'Alarm ertelenemiyor.',
  unableToStopSnoozeForAlarm: 'Alarm için erteleme durdurulamıyor.',
  unableToUpdateParticipantAlarmRingerSettings:
    'Zil ayarları şu anda güncellenemiyor. Lütfen birkaç dakika içinde tekrar deneyin.',
  updateParticipantPreReminderDuration:
    'Şu anda ön hatırlatma süresi güncellenemiyor. Lütfen birkaç dakika içinde tekrar deneyin.',
  unableToUpdateAlarmRingerSettings:
    'Zil ayarları şu anda güncellenemiyor. Lütfen birkaç dakika içinde tekrar deneyin.',
  unableToUpdateAlarmPreReminderDuration:
    'Şu anda ön hatırlatma süresi güncellenemiyor. Lütfen birkaç dakika içinde tekrar deneyin.',
  retrievingAlarmsFromServer: 'Sunucudan alarmlar alınıyor...',
  startApp: 'Başlat >',
  phoneNumberRequiredGroupListHeaderText:
    'Grup, Galarm kişilerinden oluşan bir koleksiyondur ve bu kişilerle hızlı bir şekilde alarm oluşturmanızı sağlar.\n\nGalarm kullanan kişilerinizi bulmak için lütfen telefon numaranızı kullanarak kaydolun. Onları gruplara ekleyebilirsiniz.',
  phoneNumberRequiredBuddyAlarmHeaderText:
    'Buddy alarm, arkadaşlarınıza ve ailenize yapmaları gereken şeyleri hatırlatmak için alarm kurmak için kullanılabilir.\n\nBu ve diğer birçok harika uygulama özelliğini kullanmak için lütfen telefon numaranızı kullanarak kaydolun.',
  phoneNumberRequiredInstantAlarmHeaderText: `Anlık uyardılar, acil durumlar veya bazı acil görevler için bir kişiyi veya grubu anlık olarak uyarmak için kullanılabilir.

Bu ve diğer pek çok harika uygulama özelliğini kullanmak için lütfen telefon numaranla kaydol.`,
  phoneNumberRequiredContactListHeaderText:
    'Kişiler, alarmlara katılımcı olarak eklenebilen kişilerdir.\n\nGalarm kullanan kişilerinizi görüntülemek için lütfen telefon numaranızı kullanarak kaydolun. Onları alarmlarınıza katılımcı olarak ekleyebilirsiniz.',
  phoneNumberRequiredGroupAlarmHeaderText:
    'Grup alarmı, bir grup insan için bir hatırlatıcı ayarlamak için kullanılabilir.\n\nBu ve diğer birçok harika uygulama özelliğini kullanmak için lütfen telefon numaranızı kullanarak kaydolun.',
  phoneNumberRequiredParticipantsHeaderText:
    'Katılımcılar bu alarmın yedekleri olarak hareket ederler. Alarmı kaçırırsanız hatırlatılırlar.\n\nBu ve diğer birçok harika uygulama özelliğini kullanmak için lütfen telefon numaranızı kullanarak kaydolun.',
  youHaveNotRegistered:
    'Alarmlarınız şu anda yedeklenmiyor.\n\nLütfen telefon numaranızı kullanarak kaydolun. Kaydolduktan sonra alarmlarınız bulutta yedeklenir. Bu, telefon değiştirdiğinizde alarmlarınızı ve diğer ayarlarınızı geri yüklemenizi sağlar.\n',
  registerNow: 'Şimdi Kaydolun',
  hoursAndMinutes: 'Saatler ve dakikalar',
  days: 'Günler',
  weeks: 'Haftalar',
  months: 'Aylar',
  years: 'Yıllar',
  daysOfWeek: 'Haftalık (belirli günler)',
  monthly: 'Aylık',
  yearly: 'Yıllık',
  everyDay: 'Günlük',
  selectDaysOfWeek: 'Haftanın günlerini seçin',
  alarmRingMessageForSpecificDates:
    'Bu alarm yalnızca en az {{dayOfMonth}} günü olan aylarda çalacaktır. Devam etmek istiyor musunuz?',
  alarmRingMessageForSpecificYear:
    'Bu alarm sadece artık yıllarda çalacaktır. Devam etmek istiyor musunuz?',
  alarmRingMessageForSpecificDayOfWeekInMonth:
    'Bu alarm yalnızca {{weekNumberOfDayInMonth}} {{dayName}} s adresinin bulunduğu aylarda çalacaktır. Devam etmek istiyor musunuz? ',
  alarmRepetitionAdjustedBasedOnNewDate:
    'Alarm tekrarı yeni tarihe göre güncellenmiştir.',
  inviteFriendsToInstallGalarm:
    "Kişiler, alarmlarınıza katılımcı olarak eklenebilecek kişilerdir. Kişileri şu şekilde davet edebilirsiniz:\n\n1. Adres defterinizden\n\n2. Adlarını ve numaralarını manuel olarak girerek.\n\nKayıt olduktan sonra Galarm kişilerini yeniden yüklemek için sağ üstteki Yenile'ye dokunun.",
  whyCreateNewGroup:
    'Gruplar, alarmlarınıza katılımcı olarak eklenebilen kişi koleksiyonlarıdır.\n  \nHerhangi bir grup oluşturmadınız.',
  noNotifications: 'Yeni bildiriminiz yok.',
  createGroup: 'Grup Oluştur',
  galarmRequiresAccessToContactsPermission:
    'Galarm kişilerinize erişmek için izin ister. Bu bilgiler, Galarm kullanan kişilerinizi tanımlamak için sunucularına gönderilir. Bu kullanıcılar alarmlarınıza katılımcı olarak eklenebilir.',
  galarmRequiresAccessToAudioFilesPermission:
    'Bazı alarmlar zil sesi olarak telefon müziği kullanmaktadır. Bu alarmları seçilen zil sesi ile çalmak için lütfen cihazınızdaki ses dosyalarına erişim izni verin.',
  galarmRequiresAccessToContactsSelectScreen:
    "Galarm'ın kişilere erişim izni yok. Bu özelliği kullanmak istiyorsanız lütfen kişilere erişime izin verin.",
  allow: 'İzin ver',
  deny: 'Reddet',
  galarmRequiresAccessToContacts:
    'Kişiler, alarmlarınıza katılımcı olarak eklenebilecek kişilerdir. Kişileri şu şekilde ekleyebilirsiniz:\n\n1. Telefon rehberinden otomatik olarak içe aktarma. "Erişime İzin Ver "e dokunun ve "Kişiler "i etkinleştirin.\n\n2. İsimlerini ve numaralarını manuel olarak ekleyin. Başlamak için "Kişi Ekle "ye dokunun.',
  galarmRequiresAccessToAlarmAndRemindersPermission:
    'Galarm, alarmları tam olarak belirtilen zamanlarda çalabilmesi için "Alarmlar ve hatırlatıcılar" iznine ihtiyaç duyar. Lütfen bir sonraki ekranda etkinleştirin.',
  accessToContactsPermissionRequiredAndroid:
    'Galarm\'ın telefon rehberinize erişim izni yok.\n\nErişime izin verdiğinizde, telefon rehberinizde Galarm kullanan kişiler Galarm kişileri olarak görünecektir. Bu kişiler alarm katılımcıları olarak eklenebilir. "Erişime İzin Ver" öğesine dokunun, "İzin" öğesini seçin ve "Kişiler" öğesini etkinleştirin.\n\nKişileri Galarm\'a manuel olarak eklemeye devam edebilirsiniz.',
  accessToContactsPermissionRequiredIos:
    'Galarm\'ın telefon rehberinize erişim izni yok.\n\nErişime izin verdiğinizde, telefon rehberinizde Galarm kullanan kişiler Galarm kişileri olarak görünecektir. Bu kişiler alarm katılımcıları olarak eklenebilir. "Erişime İzin Ver "e dokunun ve "Kişiler "i etkinleştirin.\n\nKişileri Galarm\'a manuel olarak eklemeye devam edebilirsiniz.',
  giveAccess: 'Erişime İzin Ver',
  enterValidMobileNumber:
    'Kayıt olmak için lütfen geçerli bir telefon numarası girin.',
  proceedAnyway: 'Yine de devam edin',
  checkInvalidPhoneNumber:
    '{{mobileNumber}} olarak geçersiz bir numara girdiğinizi düşünüyoruz.',
  checkInvalidCountryCode:
    '{{countryCode}} olarak belirtilen geçersiz ülke kodu. Birden fazla ülke kodu mevcutsa, geçerli ülke kodunu korumak için alanı düzenleyin.',
  editNumber: 'Numarayı düzenle',
  editCountryCode: 'Ülke Kodunu Düzenle',
  sendingCodeOnCall: 'Seni kodla arıyorum.',
  sendCodeOnCall: 'Beni Kodla Ara',
  sendCodeOnSms: 'SMS ile Kod Gönderme',
  sendCodeOnWhatsApp: 'WhatsApp ile Kod Gönderin',
  registrationLandingScreenRegisterText:
    'Telefon numaranızı kullanarak kaydolmak için Devam öğesine dokunun.\n\nKayıt olarak\n1) Alarmlarınıza katılımcı ekleyebilecek ve onlarla sohbet edebileceksiniz.\n2) Alarmlarınız bulutta yedeklenecek, böylece telefon değiştirdiğinizde alarmlarınız yeni telefonda görünecektir.',
  continue: 'Devam et',
  registerLater: 'Kaydı Atla',
  cancelRegistration: 'Kayıt İptali',
  welcome: 'Hoş geldiniz',
  haventReceivedCodeYet: {
    one: 'Kodu henüz almadınız mı? Kodu 1 saniye içinde tekrar talep edebilirsiniz.',
    other:
      'Kodu henüz almadınız mı? Kodu {{count}} saniye içinde tekrar talep edebilirsiniz.'
  },
  storagePermissionDenied:
    'Depolama izni reddedildiği için müzik dosyalarına erişilemiyor.',
  havingTroubleRegisteringMessage:
    'Galarm birden fazla denemeden sonra kodu doğrulayamıyor.\n\nKayıt işlemini atlayıp uygulamayı kullanmaya başlamak ister misiniz?',
  autoDetectVerificationCode:
    "Kaydı basitleştirmek için, Galarm'ın SMS mesajlarını görüntülemesine izin verirseniz Galarm doğrulama kodunu otomatik olarak algılayabilir.",
  notNow: 'Şimdi değil',
  verifyNumberText:
    'adresinden doğrulama kodunu içeren bir SMS göndereceğiz:\n\n{{formattedMobileNumber}}',
  verifyNumberWhatsApp:
    'adresinden doğrulama kodunu içeren bir WhatsApp mesajı göndereceğiz:\n\n{{formattedMobileNumber}}',
  verifyNumberCall:
    'adresinden doğrulama kodunu içeren bir telefon araması alacaksınız:\n\n{{formattedMobileNumber}}',
  addToContacts: 'Kişilere Ekle',
  todayString: 'Bugün',
  tomorrowString: 'Yarın',
  backups: 'Yedeklemeler',
  acintyoTrademark:
    "© 2026 Acintyo, Inc. Tüm hakları saklıdır.\nGalarm, Acintyo, Inc.'in tescilli ticari markasıdır.\nABD Patentleri 10382613, 10867286 ile korunmaktadır.\nDiğer patentler beklemededir.",
  acintyoTrademarkWeb:
    "© 2026 Acintyo, Inc. Tüm hakları saklıdır. Galarm, Acintyo, Inc.'in tescilli ticari markasıdır.\nABD Patentleri 10382613, 10867286 ile korunmaktadır. Diğer patentler beklemededir.",
  acintyoTrademarkEnterprise: '© 2026 Acintyo, Inc.\nTüm hakları saklıdır.',
  markAlarmDone: 'Alarmı Bitti Olarak İşaretle',
  skipAlarm: 'Alarmı Atla',
  confirmGroupAlarm: 'Katılımı Onaylayın',
  declineGroupAlarm: 'Katılımı Reddet',
  snoozeAlarm: 'Erteleme Alarmı',
  deleteAlarmQuickAction: 'Alarmı Sil',
  disableAlarm: 'Alarmı Devre Dışı Bırak',
  confirmDisableAlarm: 'Alarmı Devre Dışı Bırak?',
  saveToCalendar: 'Takvime Aktar',
  stillRingGroupAlarmAfterConfirmingInAdvance:
    'Grup alarmını önceden onaylıyorsunuz.  Hala alarm saatinde hatırlatma istiyor musunuz?',
  updateNow: 'Şimdi güncelleyin',
  nParticipants: {
    one: '1 diğer katılımcı',
    other: '{{count}} diğer katılımcılar'
  },
  details: 'Detaylar',
  changeParanthesis: '(değiştir)',
  loadMoreHistory: 'Daha fazla görüntüle',
  alarmSummaryForHistory:
    '{{alarmName}} için geçmiş yanıtlar.\nTekrarlar {{alarmRepetitionString}}\n{{previousOccurrencesString}}',
  alarmSummaryForHistoryWeb: 'Geçmiş yanıtlar {{alarmName}}',
  alarmSummaryForHistoryRepetitionWeb: 'Tekrarlar {{alarmRepetitionString}}',
  dontSeeCompleteHistory: 'Geçmişi tam olarak göremiyor musunuz?',
  dontSeeCompleteHistoryExplanation:
    'Alarm geçmişi, alarmın oluşturulduğu andan itibaren kaydedilir. Alarmın tekrarına bağlı olarak her alarm için yalnızca sınırlı bir geçmiş tutarız. Örneğin, alarm her gün tekrar ediyorsa, 30 günlük bir geçmiş tutarız.\n\nAlarm zamanının veya tekrarının değiştirilmesi alarm geçmişini sıfırlar.',
  noActionAvailableForAlarmOccurrence:
    'Bu olay için herhangi bir eylem mevcut değildir.',
  enterEmailIdForFeedback:
    'Güncellemeleri yanıtlamak ve paylaşmak için kullanılır',
  noPreviousOccurrences: 'Henüz alarm geçmişi yok',
  nMissedOccurrencesOfAlarmInLastNDays: {
    zero: 'Henüz alarm geçmişi yok',
    one: '{{missedAlarmOccurrences}} sonunculuğu kaçırdı {{count}}',
    other: '{{missedAlarmOccurrences}} sonunculuğu kaçırdı {{count}}'
  },
  soundAndVibrationSummaryString: {
    zero: '{{volume}}% hacim, {{ringtoneName}}',
    one: '{{volume}}% hacim, {{ringtoneName}}, Duyuru Başlığı'
  },
  soundAndVibrationSummaryStringIos: {
    zero: '{{ringtoneName}}',
    one: 'Kritik, {{volume}}% hacim, {{ringtoneName}}'
  },
  previousOccurrences: 'Alarm Geçmişi',
  retrieving: 'Geri alma...',
  startTimeOfDay: 'Şuradan başlar',
  endTimeOfDay: 'Şurada bitiyor',
  ringEveryHours: 'Her yüzük',
  everyNHours: 'Saatlik',
  everyMHoursNMinutes: 'Saatler ve Dakikalar',
  selectHourlyRepetition: 'Saatlik tekrarı seçin',
  everyNHoursRepetitionString: {
    one: 'Her saat başı {{startTimeString}} ile {{endTimeString}} arasında {{daysString}}',
    other:
      'Her {{count}} saat {{startTimeString}} ile {{endTimeString}} arasında her {{daysString}}'
  },
  everyNHoursAndMinutesRepetitionString:
    '{{startTimeString}} adresinden {{endTimeString}} adresine kadar her {{hoursAndMinutes}} {{daysString}}',
  everyMHoursAndNMinutesRepetitionString: 'Her {{repeatString}}',
  everyNHoursRepetitionStringForCalendar: {
    one: 'Her saat başı {{startTimeString}} ile {{endTimeString}}',
    other: 'Her {{count}} saat {{startTimeString}} ile {{endTimeString}}'
  },
  everyNHoursAndMinutesRepetitionStringForCalendar:
    'Her {{hoursAndMinutes}} {{startTimeString}} adresinden {{endTimeString}}',
  everyNHoursAndMinutesRepetitionStringForAlarmSummary:
    'Her {{hoursAndMinutes}} kadar {{endTimeString}}',
  everyNHoursRepetitionStringForAlarmSummary: {
    one: 'Her saat başı {{endTimeString}}',
    other: 'Her {{count}} saatine kadar {{endTimeString}}'
  },
  daysRepetitionOddString: {
    other: 'Tüm tek sayılı tarihler',
    one: 'Tek sayılı tarihler ({{daysString}})'
  },
  daysRepetitionEvenString: {
    other: 'Tüm çift sayılı tarihler',
    one: 'Çift numaralı tarihler ({{daysString}})'
  },
  oddNumberedRepetitionPreviewString: {
    one: 'Alarm, {{daysString}} adresine denk gelen tek sayılı tarihlerde belirtilen saatte çalacaktır.',
    other: 'Alarm tüm tek sayılı tarihlerde belirtilen saatte çalacaktır.'
  },
  evenNumberedRepetitionPreviewString: {
    one: 'Alarm, {{daysString}} adresine denk gelen çift numaralı tarihlerde belirtilen saatte çalacaktır.',
    other: 'Alarm tüm çift sayılı tarihlerde belirtilen saatte çalacaktır.'
  },
  hourlyRepetitionPreviewString: {
    one: 'Bu alarm her {{daysString}} adresinde bir kez çalacaktır:',
    other: 'Bu alarm her {{daysString}} adresinde {{count}} kez çalacaktır:'
  },
  daysRepetitionPreviewString: {
    one: 'Bu alarm her gün çalacaktır.',
    other: 'Bu alarm her {{count}} günde bir çalacaktır.'
  },
  weeksRepetitionPreviewString: {
    one: 'Alarm her hafta {{daysString}} tarihinde çalacaktır.',
    other: 'Alarm, {{count}} haftada bir {{daysString}} adresinde çalacaktır.'
  },
  weeksRepetitionPreviewStringEveryDay: {
    one: 'Alarm her gün çalacaktır.',
    other: 'Alarm her gün {{count}} haftada bir çalacaktır.'
  },
  specifyNumberOfWeeksAndChooseDays:
    'Tekrar sayısı için hafta sayısını belirtin ve günleri seçin.',
  everyNDays: {
    one: 'Her gün',
    other: 'Her {{count}} günde bir'
  },
  everyNWeeks: {
    one: '{{daysString}} her hafta',
    other: '{{count}} haftada bir {{daysString}}'
  },
  everyNMonths: {
    one: 'Her ay',
    other: 'Her {{count}} ayda bir'
  },
  everyNYears: {
    one: 'Her yıl',
    other: 'Her {{count}} yılda bir'
  },
  cantSetEndTime: 'Bitiş zamanı ayarlanamıyor',
  endTimeShouldBeGreater: 'Bitiş zamanı başlangıç zamanından büyük olmalıdır.',
  cantSetStartTime: 'Başlangıç saati ayarlanamıyor',
  startTimeShouldBeLess: 'Başlangıç zamanı bitiş zamanından daha az olmalıdır.',
  everyDaySmall: 'gün',
  everyGivenDay: '{{day}}',
  everyGivenDays: '{{days}}',
  adjustingAlarmsAfterTimezoneChange:
    'Farklı bir saat dilimine geçtiğinizi tespit ettik. Alarmlarınızı ayarlıyoruz.',
  ringOnDays: 'Yüzükler açık',
  yourAlarmsMayNotRing: 'Alarmlarınız çalmayabilir',
  yourAlarmsMayNotRingTapToFix:
    'Alarmlarınız çalmayabilir. Düzeltmek için dokunun.',
  unsyncedAlarmsWarning:
    'Bazı alarmlar sunucuyla senkronize edilmedi. İnternete bağlanın ve şimdi kaydetmek için dokunun.',
  pendingActionFailed:
    'Bir alarm değişikliği ({{actionName}}) birden fazla denemeden sonra kaydedilemedi ve iptal edildi. Lütfen alarmlarınızı kontrol edin veya veriler eksik görünüyorsa destekle iletişime geçin.',
  pendingActionFailedWithRef:
    'Bir alarm değişikliği ({{actionName}}) birden fazla denemeden sonra kaydedilemedi ve iptal edildi. Referans ID: {{referenceId}}. Bunu geri yüklemeye yardımcı olmak için bu ID ile destekle iletişime geçin.',
  xiaomiSetupInstructions:
    'Alarmlarınızın her zaman çalması için bu talimatları izleyin:\n\n - "Otomatik Başlatmayı Etkinleştir" seçeneğine dokunun ve alarmlarınızın her zaman çalması için "Galarm" seçeneğine izin verin. \n\nDaha fazla bilgi için www.galarmapp.com/setup-mi adresini ziyaret edin.',
  oppoSetupInstructions:
    'Alarmlarınızın her zaman çalması için bu talimatları izleyin:\n\n - "Otomatik Başlatmayı Etkinleştir "e dokunun ve "Otomatik Başlatmaya İzin Ver "i etkinleştirin.\n\n - Telefonunuzdaki "Son Uygulamalar" düğmesine dokunun, Galarm uygulama simgesini aşağı kaydırın ve "Kilitle" üzerine dokunun.  \n\nDaha fazla bilgi için www.galarmapp.com/setup-oppo adresini ziyaret edin.',
  oppo8AndLowerSetupInstructions:
    'Alarmlarınızın her zaman çalması için bu talimatları izleyin:\n\n - "Otomatik Başlatmayı Etkinleştir "e dokunun ve "Otomatik Başlatmaya İzin Ver "i etkinleştirin.\n\n - Telefonunuzdaki "Son Uygulamalar" düğmesine dokunun, Galarm uygulama simgesini aşağı kaydırın ve "Kilitle" üzerine dokunun.\n\nDaha fazla bilgi için www.galarmapp.com/setup-oppo-8-and-lower adresini ziyaret edin.',
  vivo9And10SetupInstructions:
    'Alarmlarınızın her zaman çalması için bu talimatları izleyin:\n\n - "Otomatik Başlatmayı Etkinleştir "e dokunun ve "Galarm "a izin verin.\n\n - "Pil Kullanımı "na dokunun, "Yüksek arka plan güç tüketimi "ni seçin ve "Galarm "a izin verin.\n\nDaha fazla bilgi için www.galarmapp.com/setup-vivo adresini ziyaret edin.',
  vivo11SetupInstructions:
    'Alarmlarınızın her zaman çalması için bu talimatları izleyin:\n\n- "Otomatik Başlatmayı Etkinleştir "e dokunun ve "Galarm "a izin verin.\n\n- "Pil Kullanımı "na dokunun, "Yüksek arka plan güç tüketimi "ni seçin ve "Galarm "a izin verin.\n\nDaha fazla bilgi için www.galarmapp.com/setup-vivo-11 adresini ziyaret edin.',
  vivoSetupInstructions:
    'Alarmlarınızın her zaman çalması için bu talimatları izleyin:\n\n- "Telefon Ayarları > Uygulamalar > Özel uygulama erişimi > Otomatik başlat" öğesini açın ve Galarm için otomatik başlatmayı etkinleştirin.\n\n- "Telefon Ayarları > Pil > Arka plan güç tüketimi yönetimi > Galarm "ı açın ve "Arka plan güç kullanımını kısıtlama "yı seçin.\n\nDaha fazla bilgi için www.galarmapp.com/setup-vivo-12-and-above adresini ziyaret edin.',
  vivo8AndLowerSetupInstructions:
    'Alarmlarınızın her zaman çalması için bu talimatları izleyin:\n\n - "Otomatik Başlatmayı Etkinleştir "e dokunun ve "Galarm "a izin verin.\n\n - "Pil Kullanımı "na dokunun, "Yüksek arka plan güç tüketimi "ni seçin ve "Galarm "a izin verin.\n\nDaha fazla bilgi için www.galarmapp.com/setup-vivo-8-and-lower adresini ziyaret edin.',
  huawei7AndLowerAdditionalSetupInstructions:
    'Alarmlarınızın her zaman çalması için bu talimatları izleyin:\n\n - "Korumalı Uygulamalar "a dokunun ve "Galarm "a izin verin.\n\nDaha fazla bilgi için www.galarmapp.com/setup-huawei-7-and-lower adresini ziyaret edin.',
  huaweiAdditionalSetupInstructions:
    'Alarmlarınızın her zaman çalması için bu talimatları izleyin:\n\n - "Uygulama Başlatmayı Yönet "e dokunun ve "Elle yönet" için "Galarm "ı kapatın. Takip eden komut isteminde, "Otomatik Başlat" ve "Arka planda çalıştır" seçeneklerinin etkin olduğundan emin olun.\n\nDaha fazla bilgi için www.galarmapp.com/setup-huawei adresini ziyaret edin.',
  meizuSetupInstructions:
    'Alarmlarınızın her zaman çalması için aşağıdaki bağlantıdaki talimatları izleyin: https://dontkillmyapp.com/meizu',
  asusSetupInstructions:
    'Alarmlarınızın her zaman çalması için bu talimatları izleyin:\n\n - "Otomatik Başlatmayı Etkinleştir "e dokunun ve "Otomatik başlatma yöneticisi "ne tıklayın. "Otomatik başlatma yöneticisi "nde "Galarm "ı etkinleştirin.\n\nDaha fazla bilgi için www.galarmapp.com/setup-asus adresini ziyaret edin.',
  nokia8AndLowerAdditionalSetupInstructions:
    'Alarmlarınızın her zaman çalması için bu talimatları izleyin:\n\n - "Otomatik Başlatmayı Etkinleştir "e dokunun ve "Galarm "a izin verin.\n\nDaha fazla bilgi için www.galarmapp.com/setup-nokia-8-and-lower adresini ziyaret edin.',
  nokiaAdditionalSetupInstructions:
    'Alarmlarınızın her zaman çalması için bu talimatları izleyin:\n\n - "Kısıtlı Uygulamalar "a dokunun ve "Galarm "ı devre dışı bırakın.\n\nDaha fazla bilgi için www.galarmapp.com/setup-nokia adresini ziyaret edin.',
  lenovoSetupInstructions:
    'Alarmlarınızın her zaman çalması için bu talimatları izleyin:\n\n - Telefonunuzdaki "Son Uygulamalar" düğmesine dokunun, Galarm uygulamasını bulun ve sağ üst köşedeki "Kilit" simgesine dokunun.\n  \nDaha fazla bilgi için https://dontkillmyapp.com/lenovo adresini ziyaret edin.',
  samsungAdditionalSetupInstructions:
    'Alarmlarınızın her zaman çalması için bu talimatları izleyin:\n\n - "İzlenmeyen Uygulamalar "a dokunun ve "Galarm "a izin verin.\n\nDaha fazla bilgi için www.galarmapp.com/setup-samsung adresini ziyaret edin.',
  tecnoSetupInstructions:
    'Alarmlarınızın her zaman çalması için aşağıdaki bağlantıdaki talimatları izleyin: https://www.galarmapp.com/setup-tecno',
  infinixSetupInstructions:
    'Alarmlarınızın her zaman çalması için aşağıdaki bağlantıdaki talimatları izleyin: https://www.galarmapp.com/setup-infinix',
  samsungAdditionalSetupInstructionsAndroid11AndAbove:
    'Varsayılan olarak, Samsung hızlı bir şekilde kaybolan "Kısa" bildirimler gösterir. "Ayrıntılı" alarm bildirimlerini görüntülemek için bu talimatları izleyin.\n\n - Telefon ayarlarını açın ve "Bildirimler "i seçin\n - "Ayrıntılı" bildirim stilini seçin\n  \nDaha fazla bilgi için www.galarmapp.com/setup-samsung-android11-and-above adresini ziyaret edin.',
  iosSetupInstructions:
    'Bildirimler için iOS banner stili varsayılan olarak "Geçici" olarak ayarlanmıştır ve bu da bildirimlerin hızlı bir şekilde kaybolmasına neden olur. Afiş stilini "Kalıcı" olarak ayarlamak için bu talimatları izleyin.\n\n- Telefon ayarlarını açın ve Galarm\'a ilerleyin\n- Bildirimler\'i seçin ve Banner Stili\'ni Kalıcı olarak ayarlayın\n\nDaha fazla bilgi için www.galarmapp.com/setup-ios adresini ziyaret edin.',
  iosSetupInstructions15AndBelow:
    'Bildirimler için iOS banner stili varsayılan olarak "Geçici" olarak ayarlanmıştır ve bu da bildirimlerin hızlı bir şekilde kaybolmasına neden olur. Afiş stilini "Kalıcı" olarak ayarlamak için bu talimatları izleyin.\n\n- Telefon ayarlarını açın ve Galarm\'a ilerleyin\n- Bildirimler\'i seçin ve Banner Stili\'ni Kalıcı olarak ayarlayın\n\nDaha fazla bilgi için www.galarmapp.com/setup-ios-15-below adresini ziyaret edin.',
  setNotificationsStyle: 'Bildirim Stilini Ayarla',
  setNotificationsStyleToDetailed:
    'Bildirim Stilini "Ayrıntılı" olarak ayarlayın',
  setBannerStyle: 'Banner Stilini Ayarla',
  setBannerStyleToPersistent: 'Banner Stilini "Kalıcı" olarak ayarlayın',
  selectAtleastOneDay: 'Bu alarmın çalacağı günleri seçin.',
  selectAtLeastOneHourOrMinute:
    'Ya saat ya da dakika sıfır olmayan bir değer olmalıdır',
  hourlyAlarmDefaultStartTimeSetAlert:
    'Alarm başlangıç saati sabah 8 olarak ayarlanmıştır.',
  batteryUsage: 'Pil Kullanımı',
  dontShowAgain: 'Bir Daha Gösterme',
  alarmWillRingEveryHourTillSeen:
    'Siz bir işlem yapana kadar alarm her saat ertelenir.',
  unknown: 'Bilinmiyor',
  alarmMarkedDone: '{{name}} alarmı "Bitti" olarak işaretlemiştir.',
  alarmMarkedSkipped: '{{name}} alarmı atladı.',
  alarmIsMarkedDone: '{{alarmName}} tamamlandı olarak işaretlenir.',
  alarmIsSkipped: '{{alarmName}} atlanır.',
  alarmIsConfirmed: '{{alarmName}} onaylandı.',
  alarmIsDeclined: '{{alarmName}} reddedildi.',
  alarmIsSnoozed: '{{alarmName}} ertelenir.',
  alarmIsAccepted: '{{alarmName}} kabul edilir.',
  alarmIsRejected: '{{alarmName}} reddedilir.',
  dismissingCalendarEvent: '{{title}} için takvim etkinliğini silme',
  newContactInfo:
    'Lütfen irtibat kurulacak kişinin adını ve telefon numarasını belirtin.\n\nYalnızca kayıtlı kullanıcılar kişi olarak eklenebilir. Eğer kullanıcı kayıtlı bir Galarm kullanıcısı değilse, "Ayarlar > Bu Uygulamayı Paylaş" seçeneğini kullanarak davet edebilirsiniz. Telefon numaralarını kullanarak kayıt olduktan sonra onları kişi olarak ekleyebilirsiniz. ',
  cantEditContactMobileNumber:
    'Telefon numarasını düzenleyemezsiniz. Numarayı değiştirmek istiyorsanız kişiyi silin ve tekrar ekleyin.',
  phoneContactsNotSyncedPermissionDenied:
    "Galarm'ın telefon kişilerine erişim izni yok. Telefon kişileri senkronize edilmeyecektir.",
  inviteContactMessage:
    "Merhaba {{contactName}}, Galarm'ı kullanarak sizi alarmlarıma ve hatırlatıcılarıma dahil etmek istiyorum. Uygulamayı {{downloadLink}} adresinden indirin. Lütfen bu numarayı kullanarak kayıt olun ve alarmları paylaşmaya başlayın.",
  noRepeat: 'Tekrar etmiyor',
  deepLinkNoLongerValidTitle: 'Oops!',
  deepLinkNoLongerValidMessage:
    'Alarm oluşturulmadı. Eski bir bağlantı veya geçersiz bir bağlantı olabilir.',
  inviteContact: 'Kişiyi Davet Et',
  fromPhoneBook: 'Adres Defterinden',
  addFromPhoneBook: 'Adres Defterinden Davet Et',
  manually: 'Manuel olarak',
  addManualContact: 'Manuel Davet Et',
  noOtherContactsFound: 'Adres defterinizdeki tüm kişiler Galarm kullanıyor.',
  cantAddPhoneContactPermissionDenied:
    "Galarm'ın telefon kişilerine erişim izni yok. Kişilere erişim izni verin.",
  alarmWillRingWithRandomRingtone:
    'Alarm için rastgele bir zil sesi seçilecektir.',
  alarmWillRingWithRandomRingtoneGlobal:
    'Alarmlar için rastgele bir zil sesi seçilecektir.',
  createdAlarmFromDeepLinkTitle: 'Her şey hazır!',
  createdAlarmFromDeepLinkMessage:
    '"{{alarmName}}" {{alarmTime}} adresinde size hatırlatılacaktır. {{alarmDate}}',
  createdRepeatingAlarmFromDeepLinkMessage: {
    zero: 'Size "{{alarmName}}" hatırlatılacaktır. {{repetitionString}}',
    one: '"{{alarmName}}" {{repetitionString}} {{alarmTime}} adresinden başlayarak size hatırlatılacaktır. {{alarmDate}}'
  },
  deleteCategoryAlertTitle: 'Kategori Silinsin mi?',
  deleteCategoryAlertMessage: {
    zero: '',
    one: '1 alarm bu kategoriye aittir. Bu kategorinin silinmesi o alarmdaki kategoriyi sıfırlayacaktır.',
    other:
      '{{count}} alarmlar bu kategoriye aittir. Bu kategorinin silinmesi bu alarmlardaki kategoriyi sıfırlayacaktır.'
  },
  updateReadyToInstallAlertTitle: 'Güncellemeyi Yükle?',
  updateReadyToInstallAlertMessage:
    'Güncellemeler yüklenmeye hazır. Güncellemeyi şimdi yüklemek ister misiniz? ',
  hideCategoryAlertTitle: 'Kategori Gizle?',
  hideCategoryAlertMessage: {
    zero: 'Bu kategoriyi gelecekte kullanamayacaksınız.',
    one: '1 alarm bu kategoriye aittir. Bu kategorinin gizlenmesi o alarmdaki kategoriyi sıfırlayacaktır.\n  \nBu kategoriyi gelecekte kullanamayacaksınız.',
    other:
      '{{count}} alarmlar bu kategoriye aittir. Bu kategorinin gizlenmesi, bu alarmlardaki kategoriyi sıfırlayacaktır.\n  \nBu kategoriyi gelecekte kullanamayacaksınız.'
  },
  alarmCategoryDeleteAllAlarmsPrompt: {
    one: '1 alarm bu kategoriye aittir. Silmek istiyor musun?\n\nKatılımcı alarmlarının silinmediğini unutmayın.',
    other:
      '{{count}} alarmlar bu kategoriye aittir. Onları silmek istiyor musun?\n\nKatılımcı alarmlarının silinmediğini unutmayın.'
  },
  enterNameForGroup: 'Grup için bir ad girin',
  enterMobileNumber: 'Telefon numaranızı girin',
  enterNotesForAlarm: 'Alarm için notlar girin',
  enterUserName: 'Adınızı girin',
  enterEmailId: 'Opsiyonel',
  enterFeedback: 'Nasıl daha iyi olabiliriz?',
  describeProblem: 'Probleminizi tanımlayın',
  invited: 'Davetli',
  resend: 'Yeniden Gönder',
  addContact: 'İletişim Ekle',
  inviteAgain: 'Tekrar Davet Et',
  contactNotRegistered:
    "{{contactName}} henüz Galarm'ı yüklemedi. Yükledikten ve telefon numaralarını kullanarak kayıt olduktan sonra onları alarmlara ekleyebileceksiniz.",
  registration: 'Kayıt',
  verify: 'Doğrulama',
  profile: 'Profil',
  profileImage: 'Profil Görüntüsü',
  addProfileImage: 'Profil resmi ekle',
  groupDetails: 'Grup Detayları',
  newGroup: 'Yeni Grup',
  uploadImage: 'Görüntü Değiştir',
  removeImage: 'Resmi Kaldır',
  selectParticipants: 'Katılımcıları Seçin',
  selectMembers: 'Seçilmiş Üyeler',
  selectTimezone: 'Saat dilimini seçin',
  searchForATimezone: 'Bir saat dilimi arayın',
  timezone: 'Saat Dilimi',
  deviceTimezone: 'Cihaz saat dilimi',
  useDeviceTimezone: 'Cihaz saat dilimini kullan',
  specifyTimezoneForAlarm: 'Alarmlar için saat dilimi belirleme',
  defaultTimezoneForAlarm: 'Alarmlar için varsayılan saat dilimi',
  changeDefaultTimezoneForAllExistingAlarms: {
    zero: 'Mevcut tüm alarmlar için saat dilimini sıfırlamak istiyor musunuz?',
    one: 'Mevcut tüm alarmlar için saat dilimini bu saat dilimine değiştirmek istiyor musunuz? Alarmlar yeni saat diliminde yapılandırılan saatte çalacaktır.'
  },
  changeDefaultRingerSettingsForAllExistingAlarms:
    "Mevcut alarmlar için ses ve titreşim ayarlarını değiştirmek istiyor musunuz?\n\nEvet'i seçerseniz, mevcut alarmlar yeni ayarlarla çalacaktır. Hayır'ı seçerseniz, mevcut alarmlar eski ayarlarla çalmaya devam eder.",
  defaultTimezoneChangedForAllAlarms:
    'Tüm alarmlar için saat dilimi değiştirildi.',
  ringerSettingsChangedForAllAlarms:
    'Mevcut alarmlar için Ses ve Titreşim ayarları değiştirildi.',
  editName: 'Adı Düzenle',
  groupImage: 'Grup Görüntüsü',
  addGroupImage: 'Grup resmi ekleme',
  selectAlarmType: 'Şunlar için bir alarm oluşturun',
  contactDetails: 'İletişim Bilgileri',
  commonAlarms: 'Alarmlar',
  commonGroups: 'Gruplar',
  groupAlarmsTitle: 'Alarmlar',
  selectRingtone: 'Zil Sesi Seçin',
  selectMusic: 'Müzik Seçin',
  select: 'Seçiniz',
  personalAlarm: 'Kişisel Alarm',
  groupAlarm: 'Grup Alarmı',
  newPersonalAlarm: 'Yeni Kişisel Alarm',
  newGroupAlarm: 'Yeni Grup Alarmı',
  editPersonalAlarm: 'Kişisel Alarmı Düzenle',
  editTaskAlarm: 'Alarmı Düzenle',
  editGroupAlarm: 'Grup Alarmını Düzenle',
  rearrangeParticipants: 'Katılımcıları Yeniden Düzenle',
  alarmConversation: 'Alarm Sohbeti',
  timezoneMismatchDetected:
    "İçimizden bir ses Galarm'ı son kullandığınız zamandan farklı bir zaman diliminde olduğunuzu söylüyor.\n\nEski saat dilimi: {{oldTimezone}}\nYeni saat dilimi: {{newTimezone}}\n\nBu, konumunuzdaki bir değişiklikten veya cihazınızdaki saat dilimindeki bir değişiklikten kaynaklanıyor olabilir.\n\nYeni saat dilimine uyum sağlayabilmemiz için lütfen Galarm'ı yeniden başlatın.",
  deviceRestartRequired: 'Uygulama Yeniden Başlatılmalı',
  disabledAlarm: 'Devre dışı alarm {{name}}',
  newContact: 'Yeni İletişim',
  contactName: 'İletişim Adı',
  contactMobileNumber: 'İletişim Telefon Numarası',
  enterNameForContact: 'Kişinin adını girin',
  pickCountryForContact: 'İrtibat Kişisinin Ülkesi',
  enterMobileNumberForContact: 'Kişinin telefon numarasını girin',
  specifyNameForContact: 'Kişi adı gereklidir',
  specifyValidPhoneNumberForContact: 'Geçerli telefon numarası gereklidir',
  addingContact: 'Kişi ekleme',
  deletingContact: 'Temasın kaldırılması',
  editingContact: 'İletişim düzenleme',
  pending: 'Beklemede',
  deleteContact: 'Kişiyi Kaldır',
  galarmContact: 'Manuel olarak eklendi',
  phoneContact: 'Telefon rehberinden eklendi',
  confirmDeleteContactTitle: '{{name}} adresini kaldıralım mı?',
  confirmDeleteContact: 'Onları alarmlarınıza ekleyemezsiniz.',
  contactAdded:
    'Harika! Artık {{name}} adresini alarmlarınıza katılımcı olarak ekleyebilirsiniz.',
  contactInvited:
    "{{name}} adresine Galarm'ı kullanmaya davet eden bir kısa mesaj gönderilmiştir.",
  changeSnoozeDuration: 'Değişim Süresi',
  durationOfEvent: 'Etkinlik süresi',
  upgradeToPremium: "Premium'a Yükseltme",
  premium: 'Premium',
  alarmLimitReached: 'Alarm Limitine Ulaşıldı',
  unableToConnectToGooglePlay:
    "Google Play'e bağlanılamıyor. Google hesabınıza giriş yaptığınızdan emin olun.",
  cantLoadVideo: 'Video Yüklenemiyor',
  cantUpgradeToPremium: "Premium'a Yükseltilemiyor",
  unableToConnectToIapAndroid:
    "Play Store'a bağlanılamıyor. Lütfen Play Store uygulamasını açın ve oturum açtığınızdan emin olun.",
  unableToConnectToIapIos:
    "App Store'a bağlanılamıyor. Lütfen App Store uygulamasını açın ve oturum açtığınızdan emin olun.",
  premiumFeaturesIos:
    'Premium kullanıcı olarak, {{maxLimit}} eşzamanlı alarm limitine sahip olursunuz.\n\nSatın alma işleminiz daha fazla özellik geliştirmemize de yardımcı oluyor.',
  premiumFeaturesAndroid:
    "Premium'a yükselterek sınırsız alarm oluşturun.\n\nSatın alma işleminiz daha fazla özellik geliştirmemize de yardımcı oluyor.",
  upgrade: 'Yükseltme',
  rvInternalError:
    'Dahili bir hata nedeniyle videoyu yükleyemedik. Ancak, alarm limitinizi 1 artırdık.',
  rvNetworkError:
    'Lütfen iyi bir internet bağlantınız olduğundan emin olun ve tekrar deneyin.',
  rvNotFoundError:
    'Şu anda uygun bir video bulamadık. Ancak, alarm limitinizi 1 artırdık.',
  dontRemindMe: 'Hatırlatma bana.',
  sameTimeAsBuddy: 'Dostumla aynı zamanda',
  noAlertForBuddyAlarm: 'Bu alarm için uyarılmamayı seçtiniz.',
  noAlertRecipientIntervalDescription: 'Uyarı almayacaksınız.',
  chooseHours: 'Saatleri seçin',
  chooseMins: 'Dakikaları seçin',
  changeHours: 'Saatleri değiştir',
  moreOptions: 'Daha fazla seçenek...',
  specificDates: 'Belirli Tarihler',
  specificDatesRepetition: {
    one: 'Belirli Tarihler (1 kez)',
    other: 'Belirli Tarihler ({{count}} oluşumlar)'
  },
  specificDatesRepetitionSummary:
    'Belirli tarihler ({{remaining}}/{{total}} kalan)',
  nOccurrences: {
    one: '1 Oluşum',
    other: '{{count}} Oluşumlar'
  },
  addOrRemoveAlarmOccurrences:
    'Olayları istediğiniz sırada ekleyebilirsiniz. Değiştirmek için herhangi bir tarih veya saate dokunabilirsiniz.',
  chooseTime: 'Bir Zaman Seç...',
  set: 'Set',
  chooseNumberOfDays: 'Gün sayısını girin',
  chooseNumberOfWeeks: 'Hafta sayısını girin',
  numberOfDaysShouldBeAtLeastOne: 'Gün sayısı en az 1 olmalıdır',
  numberOfWeeksShouldBeAtLeastOne: 'Hafta sayısı en az 1 olmalıdır',
  numberOfMonthsShouldBeAtLeastOne: 'Ay sayısı en az 1 olmalıdır',
  numberOfYearsShouldBeAtLeastOne: 'Yıl sayısı en az 1 olmalıdır',
  frequency: 'Frekans',
  configuration: 'Konfigürasyon',
  endDate: 'Alarm Bitiş Tarihi',
  noEndDate: 'Bitiş Tarihi Yok',
  alarmEndDateSetOnAlarm:
    'Alarm bitiş tarihi {{endDateString}} olarak ayarlanmıştır.',
  noAlarmDateSetForAlarm:
    'Bu alarm için herhangi bir bitiş tarihi belirlenmemiştir.',
  noOccurrenceForThisAlarmAsPerEndDate:
    'Bitiş tarihi alarm için herhangi bir oluşuma izin vermez.',
  alarmDateShouldBeBiggerThanAlarmStartDate:
    'Alarm bitiş tarihi alarm başlangıç tarihinden sonra olmalıdır.',
  aWeek: 'Bir Hafta',
  aMonth: 'Bir Ay',
  allInactiveAlarms: 'Tüm Etkin Olmayan Alarmlar',
  chooseAlarmEndDate: 'Alarm Bitiş Tarihini Seçin',
  next: 'Sonraki',
  next7Days: 'Bugünden 7 Gün Sonra',
  next30Days: 'Bugünden 30 Gün Sonra',
  next12Months: 'Bugünden 12 Ay Sonra',
  next10Years: 'Bugünden 10 Yıl Sonra',
  chooseDate: 'Bir tarih seç...',
  learnMore: 'Daha fazla bilgi edinin',
  repeatEvery: 'Her tekrarlar',
  repeatEveryDays: 'gün(ler)',
  repeatEveryWeeks: 'hafta(lar)',
  repeatEveryMonths: 'ay(lar)',
  repeatEveryYears: 'yıl(lar)',
  repeatOnce: 'Bir kez tekrarla',
  repeatEveryDay: 'Her gün tekrarla',
  repeatEveryWeek: 'Her hafta tekrarla',
  repeatEveryMonth: 'Her ay tekrarla',
  repeatEveryYear: 'Her yıl tekrarla',
  selectRepeatOption: 'Tekrarlama seçeneğini seçin',
  autoSnooze: 'Alarmları Otomatik Olarak Ertele',
  autoSnoozePerAlarm: 'Alarmı Otomatik Olarak Ertele',
  unableToUploadGroupAvatar:
    'Grup resmi şimdi yüklenemiyor. Lütfen daha sonra tekrar deneyin',
  addNewMembersToExistingAlarms:
    'Bu grupla aşağıdaki alarmlara sahipsiniz:\n\n{{alarmNames}}\n    \nYeni üyeleri bu alarmlara eklemek istiyor musunuz?',
  removeGroupMemberAlert:
    'Üyenin çıkarılması aşağıdaki alarmları etkileyecektir:\n\n{{alarmNames}}\n\nHala üyeyi çıkarmak istiyor musunuz?',
  leaveGroupAlert:
    'Gruptan ayrılmak aşağıdaki alarmları etkileyecektir:\n\n{{alarmNames}}\n\nHala gruptan ayrılmak istiyor musun?',
  updateAppAfterFeedback:
    'Uygulamanın eski bir sürümünü kullandığınızı fark ettik. Daha iyi bir deneyim için lütfen güncelleyin.',
  changesAreLost:
    'Kaydedilmemiş değişiklikleriniz var.\n\nAyrılmadan önce tasarruf etmek ister misiniz?',
  recipientAlarmIntervalGreaterThanRepetitionInterval:
    '"Hatırlat" aralığı tekrarlama aralığından daha az olmalıdır.',
  cascadingAlarmIntervalGreaterThanRepetitionInterval:
    '"Katılımcı uyarıları arasındaki süre" aralığı tekrarlama aralığından daha az olmalıdır.',
  subscriptionCanceled:
    'Premium aboneliğiniz iptal edildi. Aboneliğinizi yenileyene kadar premium özellikler kullanılamayacaktır.',
  unableToRenewSubscription:
    'Premium aboneliğinizi yenilerken bir sorun oluştu. Lütfen ödeme bilgilerinizin güncel olduğundan emin olun.',
  notice: 'Uyarı',
  ringerSettingsWillApplyToNewAlarms:
    'Ses ve titreşim ayarlarında yaptığınız değişiklikler yalnızca yeni alarmlar için geçerli olacaktır.\n\nMevcut alarmlarda, ses ve titreşim ayarlarını değiştirmek için alarmı düzenleyebilirsiniz.',
  renew: 'Yenileme',
  galarmPremium: 'Galarm Premium',
  payMonthly: 'Aylık {{price}} adresinden aylık ödeme yapın',
  payYearly: 'Yıllık ödeme {{price}} yıllık',
  free: 'Ücretsiz',
  unlimited: 'Sınırsız',
  personalAlarms: 'Kişisel Alarmlar',
  groupAlarms: 'Grup Alarmları',
  buddyAlarms: 'Buddy Alarmları',
  alarmRepetitions: 'Tekrarlar',
  ringtones: 'Zil Sesleri',
  alarmHistory: 'Alarm Geçmişi',
  base: 'Temel',
  advanced: 'Gelişmiş',
  complete: 'Tam',
  alarmHistoryFree: 'Sınırlı',
  phoneMusicAsRingtone: 'Zil Sesi Olarak Telefon Müziği',
  startFreeTrial: '14 Günlük Ücretsiz Denemeye Başlayın',
  chargedAtEndOfFreeTrial:
    'Aboneliğinizi iptal etmediğiniz sürece 14 günlük ücretsiz deneme süresi sona erdikten sonra ücretlendirilirsiniz.',
  chargedAtPurchase:
    'Satın alma sırasında ücretlendirileceksiniz. Fiyata %20 tanıtım indirimi dahildir.',
  lookingForLifetimePlan: 'Ömür boyu plan için buraya tıklayın >',
  monthlySubscription: 'Aylık',
  yearlySubscription: 'Yıllık',
  premiumRingtoneRequiresUpgrade: 'Bu zil sesi Premium abonelik gerektirir.',
  defaultPremiumFeaturesDescription:
    "Bu harika özellikleri etkinleştirmek için Premium'a yükseltin.",
  groupAlarmsPremiumFeaturesDescription:
    "1'den fazla grup alarmı oluşturmak için premium aboneliğe ihtiyacınız vardır.",
  instantAlarmsPremiumFeaturesDescription:
    "5'ten fazla anlık alarm oluşturmak için premium aboneliğe ihtiyacınız vardır.",
  buddyAlarmsPremiumFeaturesDescription:
    'Bir başkası ("arkadaş") için 1\'den fazla alarm oluşturmak için premium aboneliğe ihtiyacınız vardır.',
  shareableAlarmLinksPremiumFeaturesDescription:
    'Daha fazla paylaşılabilir alarm bağlantısı oluşturmak için premium aboneliğe ihtiyacınız var.',
  viewPremiumFeaturesDescription:
    'Premium kullanıcı olduğunuz için teşekkürler. Premium planınız bu özellikleri sunar.',
  accessToPremiumFeatures: 'Premium planlar size aşağıdaki özellikleri sunar:',
  alarmCategoryPremiumFeaturesDescription:
    'Yeni kategoriler oluşturmak için premium aboneliğe ihtiyacınız var.',
  galarmWebMovedToToolsTab:
    "Galarm Web, Araçlar sekmesine taşındı. Gelecek bir sürümde Ayarlar'dan kaldırılacak.",
  linkedAccountsMovedToToolsTab:
    "Bağlı Takvimler, Araçlar sekmesine taşındı. Gelecek bir sürümde Ayarlar'dan kaldırılacak.",
  galarmWebPremiumFeaturesDescription:
    "Galarm'ı bir web tarayıcısında kullanmak için premium aboneliğe ihtiyacınız vardır.",
  personalAlarmsFeatureDescription:
    'Uyanmak, ilaç almak veya kendiniz için başka herhangi bir görev için kişisel bir alarm kullanın. İsteğe bağlı olarak, bir alarmı kaçırdığınızda size hatırlatabilmeleri için uyarılan katılımcılar ekleyebilirsiniz. Alarmı tamam olarak işaretlediğinizde katılımcılar da bilgilendirilir.',
  groupAlarmsFeatureDescription:
    'Geziler, partiler veya başka herhangi bir etkinlik gibi grup etkinlikleri için bir grup alarmı kullanın. Alarm tüm katılımcılar için aynı anda çalar ve katılımlarını onaylayabilirler.',
  instantAlarmsFeatureDescription:
    'Bu alarmı, bir acil durum tatbikatı, bir oyunun başlangıcı, acil bir görev/toplantı ve acil dikkat gerektiren diğer olaylar hakkında bir kişiyi veya bir grup kişiyi uyarmak için kullanın.',
  buddyAlarmsFeatureDescription:
    'Başka birine ("arkadaş") yapması gereken şeyleri hatırlatmak için alarmlar oluşturun. Alarmı kaçırması durumunda arkadaşınıza hatırlatmak için uyarılırsınız. Arkadaşınız alarmı tamamladığında da size bildirim gönderilir.',
  unlimitedAlarmsFeatureDescription:
    'Daha fazla grup ve arkadaş alarmı oluşturun.',
  instantAlarmsPremiumFeature: 'Acil durum uyarıları gönder',
  alarmRepetitionsFeatureDescription:
    'Her 30 dakikada bir, her 2 saat 45 dakikada bir, gün aşırı, iki haftada bir ve çok daha fazlası gibi gelişmiş tekrarlara sahip alarmlar oluşturun.',
  ringtonesFeatureDescription:
    'Alarmlarınız için çok çeşitli premium zil sesleri arasından seçim yapın. Premium teklife sürekli olarak daha fazla zil sesi ekliyoruz.',
  phoneMusicAsRingtoneFeatureDescription:
    'Telefonunuzdaki herhangi bir şarkıyı/müziği alarm zil sesi olarak seçin.',
  shareableAlarmLinksFeatureDescription:
    'Bir bağlantı kullanarak alarmları başkalarıyla paylaşabilirsiniz.\n\nÖrneğin, bir öğretmen sınıf alarmı bağlantısını e-posta, WhatsApp veya herhangi bir mesajlaşma uygulaması kullanarak öğrencileriyle paylaşabilir. Öğrenciler bağlantıya dokunduklarında, telefonlarında sınıf alarmının bir kopyası oluşturulacaktır. Tüm öğrenciler belirtilen saatte sınıfa katılmaları için uyarılacaktır.',
  instantAlarmFeatureDescription:
    'Bir düğmeye tıklayarak bir grup insanı anında uyarın.\n\nBu alarmı acil durum tatbikatı, oyun başlangıcı, acil bir görev/toplantı ve acil dikkat gerektiren diğer olaylar hakkında onları uyarmak için kullanın.',
  alarmHistoryFeatureDescription:
    'Tekrar eden her alarm için tüm geçmiş yanıtları görüntüleyin. Bu sayede spor dersinizi ne zaman kaçırdığınızı, annenizin ilaçlarını ne zaman almadığını vb. kolayca öğrenebilirsiniz.',
  announceAlarmTitleFeatureDescription:
    'Alarm çaldığında alarm başlığını duyurun.',
  exportToCalendarPremiumFeaturesDescription:
    'Takvime daha fazla alarm aktarmak için premium aboneliğe ihtiyacınız var.',
  exportToCalendarFeatureDescription:
    'Alarmları takviminize aktarabilirsiniz. Bu, alarmlarınızı cihaz takviminizde kolayca görüntülemenizi ve müsaitlik durumunuzu daha iyi yansıtmanızı sağlar.',
  galarmWebFeatureDescription:
    "Alarmları oluşturmak, düzenlemek ve silmek için bir web tarayıcısında Galarm'ı kullanın.",
  preReminderFeatureDescription:
    'Yaklaşan alarmlar hakkında uyarı almak için ön hatırlatıcılar ayarlayın. Gerçek alarm zamanından 30 dakika önce, 1 gün önce vb. gibi önce uyarı almak için göreceli süreyi yapılandırabilirsiniz.',
  autoSnoozeCountUpgradeTitle:
    "Erteleme sayısını 2'den fazla ayarlamak için premium abonelik gereklidir",
  higherAutoSnoozeCountPerAlarm:
    'Her alarm için daha yüksek bir erteleme sayısı ayarlayabilirsiniz. Bir alarm oluştururken veya düzenlerken "Ses ve Titreşim" ayarlarını düzenleyin.',
  calendarViewFeatureDescription:
    'Herhangi bir gün için alarmlarınızı kolayca görmek için alarmları bir takvimde görüntüleyin.',
  updatePhoneNumberFeatureDescription:
    'Bu hesap için kullanılan telefon numaranızı değiştirebilirsiniz. Tüm alarmlarınız, kişileriniz, gruplarınız ve diğer ayarlarınız yeni telefon numarasına taşınacaktır.',
  alarmPhotoFeatureDescription:
    'Bir ilacın fotoğrafı, bir görev için talimatlar, bir eşya vb. gibi hızlı görsel ipuçları için bir alarma fotoğraf ekleyin. Alarm çaldığında fotoğraf görüntülenecektir.',
  taskListFeatureDescription:
    'İlgili görevleri bir arada tutmak için görev listeleri oluşturun.',
  taskAlarmPremiumFeature: 'Görev Alarmları',
  taskAlarmFeatureDescription:
    'Doğru zamanda hatırlatılmak için bireysel görevler veya tüm görev listeleri için alarmlar ayarlayın.',
  duplicateAlarmPremiumFeature: 'Mükerrer Alarm',
  duplicateAlarmFeatureDescription:
    'Aynı ayarlara sahip bir alarmın kopyalarını hızlıca oluşturun ve kaydetmeden önce değişiklikleri yapın.',
  calendarViewPremiumFeature: 'Takvim Görünümü',
  showingAlarmsForDate: 'Şunlar için alarmlar gösteriliyor {{date}}',
  updatePhoneNumberPremiumFeature: 'Telefon Numarasını Değiştir',
  alarmNotFound: 'Alarm Bulunamadı',
  alarmNotFoundMessage:
    'Bu alarm yakın zamanda silinmiş olabilir. Bu alarmla ilgili diğer bildirimleri devre dışı bırakmak için "Kaldır" üzerine dokunun.',
  alarmExistsWithDeepLinkTitle: 'Mükerrer Alarm',
  alarmExistsWithDeepLinkMessage:
    'Bu bağlantı kullanılarak oluşturulan bir alarm telefonunuzda zaten mevcuttur.',
  errorCreatingSharedAlarmLink:
    'Paylaşılan alarm bağlantısı oluşturulamadı. Lütfen tekrar deneyin.',
  alarmDoesntHaveNextDate: 'Alarmın geçerli bir sonraki tarihi yok.',
  sharePersonalAlarmDeepLinkDescription:
    'Bu etkinlik için {{dateString}} adresinde bir alarm oluşturmak için bu bağlantıya dokunun.',
  joinGroupAlarmDeepLinkDescription:
    'adresindeki bu grup etkinliğine katılmak için bu bağlantıya dokunun {{dateString}}',
  subscribedAlarmEdited:
    '{{alarmCreatorName}} {{alarmName}} adresini güncelledi. Alarmınızı güncellemek ister misiniz?',
  subscribedAlarmDeleted:
    '{{alarmCreatorName}} {{alarmName}} adresini sildi. Alarmınızı silmek istiyor musunuz?',
  responseReceivedForTicket:
    '{{ticketId}} adresindeki biletinize yanıt verdik: {{email}}. Gelen Kutunuzda yoksa, lütfen spam klasörlerinizde support@galarm.zendesk.com adresinden gelen bir e-posta olup olmadığını kontrol edin.',
  newTicketReceived:
    'Bize yazdığınız için teşekkür ederiz. Talebinizi takip etmek için{{ticketId}} numaralı bileti oluşturduk.\n\nVerdiğiniz e-posta adresinden yanıt vereceğiz: {{email}}. Bu doğru değilse, lütfen geri bildiriminizi doğru e-posta adresiyle tekrar gönderin.\n\nYanıtlarımızın düzgün bir şekilde iletilmesini sağlamak için lütfen support@galarm.zendesk.com adresini e-posta adres defterinize ekleyin. Talebinize yanıt verdiğimizde buradan da bir bildirim göndereceğiz.',
  sentAccountBackup:
    'Alarm verilerinizi {{email}} adresine gönderdik. Gelen Kutunuzda yoksa, lütfen noreply@acintyo.com adresinden gelen bir e-posta için spam klasörlerinizi kontrol edin.',
  alarmDoesntExist: 'Alarm diye bir şey yok.',
  shareAlarm: 'Alarm Bağlantısını Paylaş',
  shareAlarmDescription:
    'Bu alarmı, kişi olarak eklemeden bir bağlantı kullanarak herhangi biriyle paylaşabilirsiniz. Herhangi biri telefonundaki bağlantıya dokunduğunda, alarmın bir kopyası oluşturulur.',
  shareLink: 'Bağlantı Paylaş',
  joinedGroupAlarmFromDeepLinkMessage:
    '"{{alarmName}}" {{alarmTime}} adresinde size hatırlatılacaktır. {{alarmDate}}',
  joinedRepeatingGroupAlarmFromDeepLinkMessage: {
    zero: 'Size "{{alarmName}}" hatırlatılacaktır. {{repetitionString}}',
    one: '"{{alarmName}}" {{repetitionString}} {{alarmTime}} adresinden başlayarak size hatırlatılacaktır. {{alarmDate}}'
  },
  youHaveSubscribedToThisAlarm:
    'Bu alarmı {{creatorName}} adresinden takip ediyorsunuz.',
  alreadySharedAlarmDescription: {
    zero: 'Bu alarm için hiç takipçiniz yok.\n\nBir bağlantı kullanarak bu alarmı daha fazla kişiyle paylaşmaya devam edebilirsiniz. Bağlantıya dokunduklarında, bu alarmın bir kopyası telefonlarında oluşturulacaktır.',
    one: '{{count}} kişi bu alarmı takip ediyor.\n\nBir bağlantı kullanarak bu alarmı daha fazla kişiyle paylaşmaya devam edebilirsiniz. Bağlantıya dokunduklarında, bu alarmın bir kopyası telefonlarında oluşturulacaktır.',
    other:
      '{{count}} insanlar bu alarmı takip ediyor.\n\nBir bağlantı kullanarak bu alarmı daha fazla kişiyle paylaşmaya devam edebilirsiniz. Bağlantıya dokunduklarında, bu alarmın bir kopyası telefonlarında oluşturulacaktır.'
  },
  shareParentAlarmDescription:
    'Bu alarmı {{creatorName}} adresinden takip ediyorsunuz.\n\nBu alarmı bir bağlantı kullanarak başkalarıyla da paylaşabilirsiniz. Bağlantıya dokunduklarında, bu alarmın bir kopyası telefonlarında oluşturulur ve onlar da bu alarmı takip etmeye başlayabilirler.',
  shareableAlarmLinks: 'Paylaşılabilir Bağlantılar',
  nPeopleFollowingAlarm: {
    zero: 'Bu alarm için hiç takipçiniz yok.',
    one: '{{count}} kişi bu alarmı takip ediyor.',
    other: '{{count}} insanlar bu alarmı takip ediyor.'
  },
  likeUsOnFacebook: 'Facebook',
  followUsOnTwitter: 'X (eski adıyla Twitter)',
  followUsOnInstagram: 'Instagram',
  youtube: 'YouTube',
  mediumBlog: "Medium'daki Bloglar",
  howtoVideos: 'Nasıl Yapılır Videoları',
  followGalarmOnSocialMedia: "Galarm'ı Sosyal Medyada Takip Edin",
  galarmOnSocialMedia: 'Sosyal Medyada Galarm',
  followGalarmOnSocialMediaDescription:
    'Uygulama güncellemeleri, özellik kullanımı, gelecek özellikler ve önemli uygulama incelemeleriyle ilgili heyecan verici haberleri görüntüleyin. Buradan Galarm ekibiyle de etkileşime geçebilirsiniz.',
  sharedAlarm: 'Paylaşılan Alarmı Düzenle',
  editingPublishedAlarm: {
    one: 'Daha önce bir bağlantı kullanarak paylaştığınız bir alarmı düzenliyorsunuz. {{count}} kişi şu anda bu alarmı takip ediyor.\n\nBu alarmda herhangi bir düzenleme yaptığınızda, değişiklikler hakkında bilgilendirileceklerdir.',
    other:
      'Daha önce bir bağlantı kullanarak paylaştığınız bir alarmı düzenliyorsunuz. {{count}} kişi şu anda bu alarmı takip ediyor.\n\nBu alarmda herhangi bir düzenleme yaptığınızda, değişiklikler hakkında bilgilendirileceklerdir.'
  },
  editingSubscribedAlarm:
    'Bu alarmı {{creatorName}} adresinden takip ediyorsunuz. Alarmı düzenledikten sonra bu alarm için herhangi bir güncelleme almayacaksınız.',
  viewAlarm: 'Alarmı Görüntüle',
  view: 'Görünüm',
  editAlarm: 'Alarmı Düzenle',
  editTimeForNextOccurrence: 'Sonraki Olay için Zamanı Düzenle',
  editedNextOccurrenceConfirmation:
    'Bu alarm, düzenlenen olaydan sonra çalacak şekilde güncellendi ve düzenlenen olay için ayrı bir alarm oluşturuldu.',
  thanksForTryingPremiumTitle: 'Her şey hazır!',
  thanksForTryingPremiumMessage:
    'Premium özellikleri beğeneceğinizi umuyoruz.\n\nHerhangi bir sorunuz varsa lütfen "Ayarlar > Geri Bildirim" üzerinden destek ekibiyle iletişime geçin veya galarm@acintyo.com adresinden bize e-posta gönderin.',
  subscribedAlarmEditedInAlarmDetails:
    '{{creatorName}} alarmını değiştirdi.\nAlarmınızı güncellediniz mi?',
  subscribedAlarmDeletedInAlarmDetails:
    '{{creatorName}} alarmlarını sildi.\nAlarmınızı mı sildiniz?',
  updateSubscribedAlarm: 'Evet, güncelle',
  deleteSubscribedAlarm: 'Evet, silin',
  ignoreSubscribedAlarm: 'Hayır, görmezden gel.',
  customRepetitionPremiumScreenDescription:
    'Özel tekrarlama premium bir özelliktir.\n\nBu özelliği, gelişmiş tekrarlara sahip alarmlar oluşturmak için kullanabilirsiniz. Örnekler şunları içerir:\n',
  specificDatesRepetitionPremiumScreenDescription:
    'Bu tekrarı kullanarak belirli tarihlerde çalması için bir alarm ayarlayabilirsiniz.',
  repeatAlternateDate: 'Alternatif günlerde tekrarlayın',
  repeatEveryNDay: '✅ Her 3 günde bir tekrarlayın',
  repeatEveryNHoursAndMMinutes: '✅ Her 2 saat 30 dakikada bir tekrarlayın',
  repeatEveryNMinutes: '✅ Her 45 dakikada bir tekrarlayın',
  repeatBiweekly: '✅ Her 2 haftada bir tekrarlayın',
  repeatEveryNWeeks: '✅ Her 6 haftada bir tekrarlayın',
  repeatEveryNMonths: '✅ Her 3 ayda bir (üç ayda bir) tekrarlayın',
  repeatEveryLastDayOfMonth: '✅ Her ayın son günü tekrarlayın',
  repeatDayOfWeekOfMonth: '✅ Her ayın 2. Cumartesi günü tekrarlanır',
  repeatLastDayOfWeekOfMonth: '✅ Her ayın son Cuma günü tekrarlayın',
  customRepetition: 'Özel Tekrarlama',
  lastDayOfMonth: 'Her ayın son günü',
  dayOfWeekInMonth: '{{weekNumberOfDayInMonth}} {{dayName}} her ayın',
  lastDayOfWeekInMonth: 'Her ayın son {{dayName}} ',
  dayOfWeekInMonthInYearSummary:
    '{{weekNumberOfDayInMonth}} {{dayName}} . {{monthName}}',
  lastDayOfWeekInMonthInYearSummary: 'Son {{dayName}} of {{monthName}}',
  lastDayOfMonthInYearSummary: 'Son gün {{monthName}}',
  dayOfWeekInMonthInYear:
    '{{weekNumberOfDayInMonth}} {{dayName}} her yıl {{monthName}} adresinden',
  lastDayOfWeekInMonthInYear: "Her yıl {{monthName}} 'un son {{dayName}} 'u",
  lastDayOfMonthInYear: 'Her yıl {{monthName}} adresinin son günü',
  chooseAMonthsConfiguration: 'Lütfen bir konfigürasyon seçin.',
  chooseADaysConfiguration: 'Lütfen bir yapılandırma seçin',
  chooseAYearsConfiguration: 'Lütfen bir konfigürasyon seçin.',
  chooseAtLeastOneOccurrence: 'Lütfen en az bir olay seçiniz.',
  sendCodeAgain: 'Kodu Tekrar Gönder',
  didntGetCodeNewUser:
    'Kodu almadın mı?\n\nKodu tekrar talep edebilir veya şimdilik kayıt işlemini atlayabilirsiniz. Daha sonra kayıt olabilirsiniz.',
  didntGetCodeExistingUser:
    'Kodu almadın mı?\n\nKodu tekrar talep edebilir veya kaydı iptal edebilirsiniz. Daha sonra kayıt olabilirsiniz.',
  didntGetCodeUpdatePhoneNumber:
    'Kodu almadın mı?\n\nKodu tekrar talep edebilir veya daha sonra tekrar deneyebilirsiniz.',
  alreadySentCodeAgain:
    'Kodu size yeniden gönderdik. Kodu almakta zorluk yaşıyorsanız, lütfen şimdilik kayıt işlemini atlayın ve daha sonra kayıt olun.',
  appearance: 'Görünüm',
  accentColor: 'Vurgu rengi',
  theme: 'Tema',
  announceAlarmName: 'Alarm Başlığını Duyur',
  ttsHelperText:
    'Alarm çaldığında alarm başlığı duyurulacaktır. Bir önizleme dinlemek için alarm başlığının önündeki oynat düğmesine dokunabilirsiniz.',
  initializingTts: 'Metinden konuşmaya başlatma',
  errorSpeakingAlarmName:
    'Alarm başlığı söylenemiyor. Lütfen "Ayarlar > Geri Bildirim" bölümünden destek ekibiyle iletişime geçin.',
  entityAlarm: 'alarm',
  entityGroup: 'Grup',
  entityContact: 'İletişim',
  admin: 'Yönetici',
  specifyAlarmTitleToSpeak: 'Konuşmak için alarm başlığını belirtin',
  wakeup: 'Uyan',
  ttsPremiumScreenDescription:
    'Alarm başlığını duyurmak premium bir özelliktir.\n\nEtkinleştirildiğinde, alarm çaldığında alarm başlığı duyurulacaktır.\n\nÖnizleme yapmak için bir alarm başlığı girin ve oynat öğesine dokunun.',
  unknownAlarmCategory: 'Bilinmeyen alarm kategorisi',
  cantAnnounceAlarmTitle: 'Alarm başlığı açıklanmayacak',
  ringtoneDurationIsSmall:
    'Alarm başlığının duyurulabilmesi için zil sesi süresi en az 5 saniye olmalıdır.\n\nBu ayarlarla devam etmek istiyor musunuz?',
  noActionItems: 'Eylem maddesi yok.',
  personNotInContacts: 'Bu kişi Galarm kişilerinizde bulunmuyor.',
  light: 'Işık',
  dark: 'Karanlık',
  systemDefault: 'Cihaz Ayarını Kullan',
  chooseTheme: 'Tema Seçin',
  dontSeeAllYourContacts: 'Tüm kişilerinizi göremiyor musunuz?',
  lastContactsSyncedAt: 'Son senkronizasyon {{dateString}}',
  refresh: 'Yenile',
  forever: 'Sonsuza dek',
  autoSnoozeConfiguration: 'Ertelemeyi Yapılandırma',
  autoSnoozeConfigurationSummary:
    '{{autoSnoozeDurationLabel}}, {{autoSnoozeCountLabel}}',
  uncategorizedCategoryName: 'Kategorize Edilmemiş',
  uncategorizedCategoryScreenTitle: 'Uncategorized',
  setAlarmCategory: 'Alarm Kategorisini Ayarla',
  changeAlarmCategory: 'Alarm Kategorisini Değiştir',
  viewAlarmHistory: 'Alarm Geçmişini Görüntüle',
  computingAlarmHistory: 'Alarm geçmişi için bilgi işlem özeti...',
  alarmByCategories: '{{name}} Alarmlar',
  alarmCategories: 'Kategoriler',
  editAlarmCategory: 'Kategori Düzenle',
  deleteAlarmCategory: 'Kategori Sil',
  newAlarmCategoryTitle: 'Yeni Kategori',
  newAlarmCategoryNamePlaceholder: 'Bir ad belirtin',
  editAlarmCategoryTitle: 'Kategori Düzenle',
  alarmCategorySummary: {
    zero: '{{alarmsSummary}}',
    one: '{{alarmsSummary}}, {{count}} cevapsız',
    other: '{{alarmsSummary}}, {{count}} cevapsız'
  },
  numAlarms: {
    zero: 'Alarm yok',
    one: '{{count}} alarm',
    other: '{{count}} alarmlar'
  },
  numIncidents: {
    zero: 'Olay yok',
    one: '{{count}} olay',
    other: '{{count}} Olaylar'
  },
  openedIncidents: 'Açılan olaylar',
  closedIncidents: 'Kapatılan olaylar',
  incidentChart: 'Olaylar Tablosu (Son 30 gün)',
  incidentCalendar: 'Olay Takvimi',
  incidentDistribution: 'Olay Dağılımı (Son 30 gün)',
  noIncidentsOpenedClosedInLast30Days:
    'Son 30 gün içinde açılan veya kapanan vaka yok',
  noIncidentsOpenedInLast30Days: 'Son 30 gün içinde açılan vaka yok',
  color: 'Renk',
  createNewAlarmCategory:
    'Sağ alttaki + düğmesine dokunarak yeni bir kategori oluşturun',
  setValidName: 'Geçerli bir ad belirleyin',
  specifyTimezoneForAlarmMessage:
    'Alarmları oluştururken bir saat dilimi belirleyebilirsiniz. Alarmlar belirtilen saat dilimine göre çalacaktır. \n\n"Cihaz saat dilimi "ni seçerseniz, alarmlar cihazınızın saat dilimine göre çalacaktır.',
  selectDefaultTimezoneForAlarmDefaultTooltipMessage:
    'Alarmlarınız için varsayılan bir saat dilimi seçin. Alarmlar için saat dilimini alarmları oluştururken değiştirebilirsiniz.',
  alarmCategoryFeatureDescription:
    'Alarmlar için kendi kategorilerinizi oluşturun. Kategoriler alarmlarınızı kolayca organize etmenizi sağlar.',
  markAlarmDoneInAdvance: 'Alarmı "Bitti" olarak erken mi işaretleyeyim?',
  skipAlarmInAdvance: '"Alarmı erken mi atlayayım?',
  markAlarmDoneInAdvanceMessageRepeatingAlarm:
    'Şimdi "Bitti" olarak işaretlerseniz alarm {{dateTimeString}} adresinde çalmayacaktır.',
  skipAlarmInAdvanceMessageRepeatingAlarm:
    'Şimdi atlarsanız alarm {{dateTimeString}} adresinde çalmayacaktır.',
  markAlarmDoneInAdvanceMessageOneTimeAlarm:
    'Şimdi "Bitti" olarak işaretlerseniz alarm {{dateTimeString}} adresinde çalmayacaktır.',
  skipAlarmInAdvanceMessageOneTimeAlarm:
    'Şimdi atlarsanız alarm {{dateTimeString}} adresinde çalmayacaktır.',
  alarmsByCategories: 'Kategorilere Göre Alarmlar',
  workAlarmCategory: 'İş',
  homeAlarmCategory: 'Ev',
  birthdaysAlarmCategory: 'Doğum Günleri',
  more: 'Daha fazla',
  alarmCategory: 'Alarm Kategorisi',
  editAlarmCategoryColor: 'Renk Düzenle',
  editAlarmCategoryColorTitle: 'için Renk Düzenle {{name}}',
  allUserCategoriesDeleted:
    'Premium abonelik iptal edildiği için sizin tarafınızdan oluşturulan tüm alarm kategorileri kaldırılmıştır. Bu kategorilerdeki alarmlar "Kategorize Edilmemiş" olarak görünecektir.',
  calendar: 'Takvim',
  eventExportedFromGalarm:
    '" {{dateString}} adresindeki Galarm\'dan {{timeString}} adresine aktarıldı."',
  unableToExportEventToCalendar:
    'Etkinlik takvime aktarılamıyor. Lütfen cihazdaki takvime erişim izni verdiğinizden emin olun. Lütfen uygulamayı yeniden başlatın ve izin verdiyseniz tekrar deneyin. Sorun devam ederse "Ayarlar > Geri Bildirim" seçeneğini kullanarak bize geri bildirim gönderin.',
  scanQrCode:
    "Galarm'a bir tarayıcı üzerinden erişmek için web.galarm.app adresine gidin ve QR kodunu tarayın.",
  logOut: 'Çıkış Yap',
  useHere: 'Burada Kullanın',
  appRunningElsewhere:
    'Bu oturumdan çıkış yaptınız. Bu oturuma devam etmek ister misiniz?',
  dateTime: 'Tarih ve Saat',
  selectAtLeastOneDayForRepetition:
    'Alarmın tekrarlanacağı en az bir gün seçin.',
  chooseNumberOfDaysForAlarmRepetition:
    'Alarmın kaç gün sonra tekrar edeceğini girin.',
  chooseNumberOfWeeksForAlarmRepetition:
    'Alarmın tekrar etmesi gereken hafta sayısını girin.',
  chooseNumberOfMonthsForAlarmRepetition:
    'Alarmın kaç ay sonra tekrar etmesi gerektiğini girin.',
  chooseNumberOfYearsForAlarmRepetition:
    'Alarmın kaç yıl sonra tekrar etmesi gerektiğini girin.',
  previouslySelectedContactsAreUnselected:
    'Önceden seçilen kişi(ler)in seçimi kaldırılır.',
  previouslySelectedGroupIsUnselected:
    'Önceden seçilen grubun seçimi kaldırılır.',
  galarmWebInstructions:
    '1. Telefonunuzda Galarm uygulamasını açın\n2. "Ayarlar" sekmesine gidin ve "Galarm Web" üzerine dokunun\n3. Eğer bu seçeneği göremiyorsanız lütfen en son uygulamayı çalıştırdığınızdan emin olun\n4. Sağ taraftaki QR kodunu tarayın',
  likeToCreateAlarm: 'İçin bir alarm oluşturun...',
  payUtilityBills: 'Faturaları ödeyin',
  wakeupAlarmName: 'Uyan',
  exerciseAlarmName: 'Egzersiz',
  drinkWaterAlarmName: 'Su içmek',
  everyNHoursRepetitionStringShortSummary: {
    one: '{{startTimeString}} {{endTimeString}} adresine Her saat',
    other:
      '{{startTimeString}} {{endTimeString}} adresine Her {{count}} saatte bir'
  },
  firstTimeManagementQuote:
    '"Kötü haber, zaman uçup gidiyor. İyi haber ise sen pilotsun."',
  firstTimeManagementQuoteAuthor: 'Michael Altshuler',
  secondTimeManagementQuote: '"Tüm zaman yönetimi planlama ile başlar."',
  secondTimeManagementQuoteAuthor: 'Tom Greening',
  thirdTimeManagementQuote:
    '"Bugün yapabileceğiniz bir şeyi asla yarına bırakmayın."',
  thirdTimeManagementQuoteAuthor: 'Benjamin Franklin',
  fourthTimeManagementQuote:
    '"Zaman en çok istediğimiz ama en kötü kullandığımız şeydir."',
  fourthTimeManagementQuoteAuthor: 'William Penn',
  fifthTimeManagementQuote:
    '"Bundan bir yıl sonra bugün başlamış olmayı dileyebilirsiniz."',
  fifthTimeManagementQuoteAuthor: 'Karen Lamb',
  sixthTimeManagementQuote: '"Siz gecikebilirsiniz, ama zaman gecikmeyecek."',
  sixthTimeManagementQuoteAuthor: 'Benjamin Franklin',
  tapToGetStarted: 'Başlamak için "+" üzerine dokunun.',
  allCategories: 'Tüm Kategoriler',
  createAlarmWithContact: 'ile bir alarm oluşturun {{name}}',
  createAlarmWithGroup: 'ile bir alarm oluşturun {{name}}',
  editGroup: 'Grubu Düzenle',
  discardChanges: 'Mevcut değişiklikler atılacaktır. Devam etmek mi?',
  alarmWillRingEveryNDays: {
    zero: 'Alarm her gün çalacak.',
    one: 'Alarm alternatif günlerde çalacaktır.',
    other: 'Alarm her {{dayWithOrdinal}} günde bir çalacaktır.'
  },
  hoursString: {
    zero: '',
    one: '1 saat',
    other: '{{count}} saatler'
  },
  minutesString: {
    zero: '',
    one: '1 dakika',
    other: '{{count}} dakika'
  },
  alarmWillRingEveryMHoursAndNMinutes:
    'Alarm {{dayString}} adresinden başlayarak her {{repeatString}} adresinden sonra çalacaktır. Bundan sonra, {{otherDaysString}} ve böyle devam eder.',
  alarmWillRingEveryNWeeks: {
    zero: 'Alarm her hafta çalacak.',
    one: 'Alarm iki haftada bir çalacaktır.',
    other: 'Alarm her {{weekWithOrdinal}} haftada bir çalacaktır.'
  },
  alarmWillRingEveryNMonths: {
    zero: 'Alarm her ay çalacak.',
    one: 'Alarm iki ayda bir çalacaktır.',
    other: 'Alarm her {{monthWithOrdinal}} ayda bir çalacaktır.'
  },
  alarmWillRingEveryNYears: {
    zero: 'Alarm her yıl çalacak.',
    one: 'Alarm iki yılda bir çalacaktır.',
    other: 'Alarm her {{yearWithOrdinal}} yılda bir çalacaktır.'
  },
  ringParticipantAlarmsByDefaultTooltipMessage:
    'Bu tercih etkinleştirildiğinde, başkalarından gelen alarmlar kabul edilmeden çalacaktır. Yine de, alarmı oluşturana alarma katılmak istediğinizi bildirmek için alarmı kabul etmelisiniz.\n\nBu tercih devre dışı bırakıldığında, siz açıkça kabul etmediğiniz sürece başkaları tarafından sizin için eklenen alarmlar telefonunuzda çalmaz.',
  specifyTimezoneForAlarmDefaultTooltipMessage:
    'Bu tercih etkinleştirildiğinde, alarmları oluştururken bir saat dilimi belirtebilirsiniz. Alarmlar belirtilen saat dilimine göre çalacaktır.\n\nBu tercih devre dışı bırakıldığında, alarmlar cihazınızın saat dilimine göre çalacaktır.',
  ringOnEarphoneOnlyTooltipTitle: 'Kulaklık bağlandığında alarm davranışı',
  ringOnEarphoneOnlyTooltipMessage:
    'Kulaklık bağlandığında, alarmlarınızı yalnızca kulaklıkta veya hem telefon hoparlöründe hem de kulaklıkta çalacak şekilde yapılandırabilirsiniz.\n\nKulaklık bağlı olmadığında, alarmlar telefon hoparlöründen çalacaktır.',
  gestureOptionsTooltipTitle: 'Bir alarmı kapatmak için hareket',
  gestureOptionsTooltipMessage:
    'Kilit ekranında bir alarm çaldığında, bir düğmeye dokunarak veya bir düğmeyi kaydırarak alarmı kapatabilirsiniz.\n\nBu ayar, bir alarmı nasıl kapatmak istediğinizi seçmenize olanak tanır.',
  notificationSettingsTooltipTitle: 'Bildirim Ayarları',
  notificationSettingsTooltipMessage:
    'Almak istediğiniz bildirimleri etkinleştirin ve bildirim almak istemediklerinizi devre dışı bırakın.',
  messagesForAlarm: 'İçin mesajlar {{name}}',
  systemNotificationsTooltipMessage:
    "Aşağıdaki gibi olaylar için uygulama tarafından oluşturulan bildirimler:\n  - temaslıların saat dilimlerini değiştirmesi nedeniyle alarmlar etkilendiğinde\n  - Davet edilen bir kişi Galarm'a kaydolduğunda\n  - Birinin hesabını silmesi nedeniyle alarmlar etkilendiğinde",
  galarmWebNotificationsTooltipMessage:
    "Galarm Web'den size gönderilen bildirimler.",
  alarmsfromOthersNotificationsTooltipMessage:
    'Bir alarma katılımcı olarak eklendiğinizde gönderilen bildirimler.',
  alarmChatNotifictionsTooltipMessage:
    'Bir alarmdaki sohbet mesajları için gönderilen bildirimler.',
  groupNotificationsTooltipMessage:
    'Bir gruba eklendiğinizde, gruptan çıkarıldığınızda veya bir başkası gruba eklendiğinde/ gruptan çıkarıldığında gönderilen bildirimler.',
  alarmAcknowledgementNotificationsTooltipMessage:
    'Bir katılımcı sizin de katılımcı olduğunuz bir alarmı onayladığında gönderilen bildirimler.',
  sharedAlarmNotificationsTooltipMessage:
    'Gönderilen bildirimler:\n  - Birisi sizin tarafınızdan paylaşılan bir alarma bir bağlantı aracılığıyla abone olduğunda\n  - abone olduğunuz bir alarm değiştirildiğinde',
  pinMode: 'Pin Modu',
  pinModeTooltipMessage:
    "Android'in Uygulama Sabitleme özelliğini kullanarak uygulamayı ekranınızın en üstüne sabitlediğinizde bu tercihi etkinleştirin.",
  sleepTimer: 'Uyku Müziği',
  sleepTimerTitle: 'İçin Müzik Çal',
  ongoingSleepTimer: 'Uyku Müziği Devam Ediyor',
  stopSleepTimer: 'Mevcut müziği durdurmak ister misiniz?',
  restartSleepTimer:
    'Mevcut müziği durdurmak ve yeni bir müzik başlatmak mı istiyorsunuz?',
  play: 'Oyun',
  youAreOffline:
    'Şu anda çevrimdışı durumdasınız. Herhangi bir işlem gerçekleştirmek için çevrimiçi olun.',
  alarmLinkRelativeToTimezone: '{{timeString}} kendi zaman dilimlerinde.',
  alarmLinkNotRelativeToTimezone:
    'Herkesin alarmı şu saatte çalacak {{timeString}}',
  alarmShouldRingAt: 'Herkesin alarmı şu saatte çalacak:',
  sleepMusicTooltip:
    'Vücudunuzu ve zihninizi rahatlatmak için doğal sesler çalın. Müzik, belirtilen süreden sonra çalmayı durdurur.',
  alarmLinkCopiedToClipboard: 'Alarm bağlantısı panoya kopyalandı.',
  confirmLogOut: 'Oturumu kapatmak istiyor musunuz?',
  appNotRunningMessage:
    "Galarm'ın telefonunuzda çalışmadığını tespit ettik. Galarm'ı başlatmak için dokunun, böylece önemli alarmları kaçırmazsınız.",
  tapToEnterNotesForAlarm: 'Not girmek için dokunun',
  accountAlreadyExists: 'Mevcut Hesap Bulundu',
  accountsMerged:
    'Bu cep telefonu numarasıyla ilişkili mevcut bir hesap bulduk. İki hesabı birleştirdik.',
  upgradeToPremiumToAssignUserDefinedCategory:
    "Kullanıcı tanımlı kategoriyi seçmek için Premium'a yükseltin.",
  userDefinedCategoryNotSetForAlarm:
    "Kullanıcı tanımlı kategoriyi otomatik atamak için Premium'a yükseltin. Kategori alarm için ayarlanmamış.",
  alarmDetails: 'Alarm Detayları',
  profileDetails: 'Profil',
  activeWebSession:
    'Zaten aktif bir web oturumunuz var. Bu oturumdan çıkış yapabilir veya yeni bir oturum başlatabilirsiniz.\n\nYeni bir oturum başlattığınızda o anda etkin olan web oturumundan otomatik olarak çıkarsınız.',
  startNewSession: 'Yeni Bir Oturum Başlatın',
  confirmWebSessionLogout:
    'Bu, mevcut web oturumunuzdan çıkış yapmanızı sağlayacaktır. Kodu tekrar tarayarak yeni bir oturum başlatabilirsiniz.',
  defaultInstantAlarmTitleForGroup: '{{groupName}} Gelen uyarı {{creatorName}}',
  defaultInstantAlarmTitleForContact: 'Gelen uyarı {{creatorName}}',
  atleastOneMemberShouldBeActive: 'En az bir katılımcı aktif olmalıdır.',
  activeParticipants: 'Aktif Katılımcılar',
  acceptAlarm: 'Alarmı Kabul Et',
  rejectAlarm: 'Alarmı Reddet',
  nConfirmed: '{{count}} onaylandı',
  nDeclined: '{{count}} reddedildi',
  nPending: '{{count}} beklemede',
  everyoneConfirmed: 'Herkes onayladı',
  everyoneDeclined: 'Herkes reddetti',
  appTagline: 'Hiçbir Şeyi Kaçırmayın',
  usePreviousBackup: 'Ben kayıtlı bir kullanıcıyım >',
  viewAlarmsByCategories: 'Kategorilere Göre Alarmları Görüntüle',
  viewAllAlarms: 'Tüm Alarmları Görüntüle',
  switchToSummaryView: 'Özet Görünümüne Geçin',
  switchToListView: 'Liste Görünümüne Geç',
  hideHourlyAlarms: 'Saatlik alarmları gizle',
  showHourlyAlarms: 'Saatlik alarmları göster',
  calendarView: 'Galarm Takvimi',
  viewRecentlyDeletedAlarms: 'Son Silinen Alarmları Görüntüle',
  deletedOnDate: 'Silindi {{alarmDate}}',
  recentlyDeletedAlarmFooterText:
    'Bu alarm şu tarihte silinmiştir {{alarmDate}}',
  noRecentlyDeletedAlarms: 'Yakın zamanda silinmiş alarm yok',
  restoreAlarmsFromMobileApp:
    'Bu alarmlar silindikten 30 gün sonra otomatik olarak silinecektir. Bunlardan herhangi birini geri yüklemek isterseniz, lütfen mobil uygulamanızın "Son Silinen Alarmlar" ekranına gidin ve geri yükleme simgesine dokunun.',
  deleteExpiredAlarms: 'Kaçırılan Alarmları Sil',
  deleteInactiveAlarms: 'Etkin Olmayan Alarmları Sil',
  deleteAlarms: 'Alarmları Sil',
  enableAlarms: 'Alarmları Etkinleştir',
  disableAlarms: 'Alarmları Devre Dışı Bırak',
  noItemsToDisplay: 'Görüntülenecek öğe yok',
  sent: 'Gönderildi',
  received: 'Alındı',
  defaultConfigurationUpdated: 'Varsayılan yapılandırma güncellendi.',
  notAlerted: '(hariç)',
  alarmKeepsRingingHelp: 'Yardım edin! Alarmım çalmaya devam ediyor',
  alarmKeepsRingingHelpMessage:
    'Alarmlarınızı yeniledik ve sorun raporunu gönderdik.',
  alarmKeepsRingingHelpAlert:
    'Alarmlarınızı yenileyeceğiz ve artık bu sorunu gözlemlememelisiniz. Ayrıca, daha fazla inceleme için destek ekibimize bir sorun raporu göndereceğiz.\n\n  Sorun devam ederse, lütfen "Ayarlar > Geri Bildirim" seçeneğini kullanarak bizimle iletişime geçin.',
  sendingFeedback: 'Geri bildirim gönderme',
  sendingProblemReport: 'Sorun raporu gönderme',
  fixingAlarms: 'Alarmlarınızı yenileme',
  existingAccountFound: 'Yedekleme Geri Yüklendi',
  existingAccountDataRestored: {
    zero: 'Tebrikler, tüm veriler yedekten geri yüklendi.',
    one: 'Tebrikler, tüm veriler yedekten geri yüklendi.',
    other: 'Tebrikler, tüm veriler yedekten geri yüklendi.'
  },
  noExistingAccountFound: 'Yedekleme Bulunamadı',
  createdNewAccount:
    "Bu telefon numarası Galarm'a kayıtlı değil. Bu telefon numarasını kullanarak yeni bir hesap oluşturduk.",
  iosCloseToAllowedNumNotificationsScheduled:
    'Zamanlanmış bildirimler için iOS sistem sınırına yaklaştınız.\n\nAlarmlarınızın zamanında çalmasını sağlamak için, "Ayarlar (sekme) → Gelişmiş Ayarlar"da "Gelişmiş Alarm Teslimatı"nı etkinleştirin.\n\nBu premium özellik, iOS sistem sınırlarına ulaşıldığında alarm bildirimlerini güvenilir bir şekilde iletmek için Galarm sunucularını kullanır. Etkin bir internet bağlantısı gerektirir.',
  acknowledgeAlarmToScheduleNextOccurrence:
    'Bu, bu alarm için son bildirimdir. Bu bildirime uzun basın ve bu alarmın bir sonraki oluşumunu planlamak için bir işlem yapın.',
  lastNotificationForOneTimeAlarm: 'Bu, bu alarm için son bildirimdir.',
  criticalAlertsMessageTitle: 'Telefonunuz sessizdeyken alarmları çaldırın',
  criticalAlertsMessageDescription:
    '\nGalarm\'ı, telefonunuz sessizdeyken alarmları çaldırmak için iOS Kritik Uyarıları kullanacak şekilde yapılandırabilirsiniz. Tüm alarmlar için etkinleştirmek ister misiniz?\n\nAyrıca "Ses ve Titreşim > Kritik Uyarılar" ayarlarını düzenleyerek bazı alarmlar için seçerek etkinleştirebilirsiniz.',
  allowCriticalAlerts: 'Kritik Uyarılara İzin Ver',
  criticalAlertsPermissionDenied:
    'Galarm, kritik uyarıları göstermek için telefonunuzdan izin gerektirir. Lütfen telefon ayarlarınızdan bu izni etkinleştirin.',
  enableCriticalAlertsForAllAlarms: 'Evet, tüm alarmlar için etkinleştirin',
  selectivelyEnableCriticalAlerts: 'Hayır, seçerek etkinleştireceğim',
  firstName: 'İlk İsim',
  lastName: 'Soyadı',
  email: 'E-posta',
  password: 'Şifre',
  confirmPassword: 'Şifreyi Onayla',
  signup: 'Kaydolun',
  login: 'Giriş',
  alreadySignedUp: 'Çoktan kaydoldunuz mu?',
  notAUser: 'Kullanıcı değil misiniz?',
  subscribe: 'Abone Olun',
  configurePlan: 'Planı Yapılandır',
  choosePlan: 'Plan Seç',
  billingCycle: 'Faturalama Döngüsü',
  needHelpToGetStarted: 'Başlamak için yardıma mı ihtiyacınız var?',
  browser: 'Tarayıcı: {{name}}',
  deviceOs: 'Cihaz: {{name}}',
  lastActive: 'Son aktif: {{timestamp}}',
  signUp: 'Kaydolun',
  useGalarmOnWeb: "Galarm'ı Web'de Kullanın",
  welcomeUser: 'Hoş geldiniz {{name}}',
  changePassword: 'Şifre Değiştir',
  saveAlarm: 'Alarmı Kaydet',
  galarmUserTip: 'Biliyor muydunuz?',
  sendAlarm: 'Alarm Gönder',
  saveGroup: 'Grup Kaydet',
  webAppBestViewedOnDesktop:
    "URL (web.galarm.app), dizüstü veya masaüstü bilgisayarınızdaki bir web tarayıcısında bir Galarm arayüzü başlatmak içindir.\n\nGalarm'ı bu mobil cihazda kullanmak için lütfen aşağıdaki bağlantılardan birini kullanarak Google Play'den Android uygulamasını veya App Store'dan iOS uygulamasını yükleyin:",
  scanQrCodeMessage: 'QR Kodunu Tarayın',
  reloadQrCode: 'QR kodunu yeniden yüklemek için tıklayın',
  invalidQrCodeScanned: 'Geçersiz QR kodu tarandı.',
  unableToScanCode: 'Kod taranamıyor',
  unableToScanCodeMessage:
    'Kod taranırken bir sorun oluştu. Lütfen tekrar deneyin. Sorun yaşamaya devam ederseniz, lütfen mobil uygulamadan "Ayarlar > Geri Bildirim" seçeneğini kullanarak bize bir geri bildirim gönderin.',
  problemWithEnterpriseAccountSetup:
    'Galarm Pro hesabınızın kurulumunda bir sorun oluştu. Lütfen teknik destek ile iletişime geçin.',
  problemWithCreatingCheckoutSession:
    'Ödeme oturumu oluştururken bir sorun oluştu. Lütfen teknik destek ile iletişime geçin.',
  unableToLoadPremiumPlans:
    'Premium planlar yüklenemiyor. Lütfen daha sonra tekrar deneyin.',
  noPlanSelected: 'Devam etmeden önce lütfen bir plan seçin.',
  problemWithCreatingCustomerPortalSession:
    'Müşteri portalı oturumu oluştururken bir sorun oluştu. Lütfen teknik destek ile iletişime geçin.',
  problemWithCreatingApiKey:
    'API anahtarı oluştururken bir sorun oluştu. Lütfen teknik destek ile iletişime geçin.',
  creatingAnAccount: 'Hesap oluşturma',
  currentPlan: 'Mevcut plan: {{name}} ({{quantity}} koltuklar)',
  myAccount: 'Hesap Bilgileri',
  new: 'Yeni',
  deleteAllAlarmHistoryAlertTitle: 'Alarm Geçmişini Sil',
  deleteAllAlarmHistoryAlertMessage:
    'Bu alarmın geçmişini silmek için "Devam" düğmesine dokunun. Bu eylem geri alınamaz.',
  ageOutInactiveAlarmsMessage:
    '60 günden uzun süredir etkin olmayan {{count}} alarmlarınız var. Çok sayıda etkin olmayan alarmın olması uygulamanın performansını etkileyebilir.\n\nBu alarmları silmek istiyor musunuz?',
  duplicateAlarm: 'Mükerrer Alarm',
  graduallyIncreaseVolume: 'Hacmi kademeli olarak artırın',
  graduallyIncreaseVolumeTooltipMessage:
    'Bu tercih etkinleştirildiğinde, alarm sesi kademeli olarak yapılandırılan zil sesi seviyesine yükselir. Bu, alarmı çok yüksek olmadan önce durdurmanızı sağlar.\n\nBu tercih devre dışı bırakıldığında, alarmlar tüm zil sesi süresi boyunca yapılandırılan zil sesi seviyesinde çalar.',
  shakeToStopAlarm: 'Alarmı durdurmak için salla',
  shakeToStopAlarmTooltipMessage:
    'Bu tercih etkinleştirildiğinde, çalan alarmı durdurmak için telefonunuzu sallayabilirsiniz. Otomatik erteleme yapılandırılmışsa, sallama alarmı bunun yerine erteleyecektir.',
  shakeToStopAlarmNotAvailable:
    'Alarmı durdurmak için sallama bu cihazda mevcut değildir.',
  shakeSensitivity: 'Sallama hassasiyeti',
  shakeSensitivityVeryHigh: 'Çok yüksek',
  shakeSensitivityHigh: 'Yüksek',
  shakeSensitivityMedium: 'Orta',
  shakeSensitivityLow: 'Düşük',
  shakeSensitivityVeryLow: 'Çok düşük',
  shakeTestInstructions:
    'Test etmek için telefonunuzu sallayın. Hareket algılandığında çubuk dolar; yeşil, alarmın duracağını gösterir. Alarm durduğunda bir titreşim de hissedeceksiniz.',
  teams: 'Takımlar',
  alerts: 'Uyarılar',
  listeners: 'Dinleyiciler',
  noMembersConfiguredInEnterpriseAccount: `Henüz üye eklemediniz.

Üyeler, kuruluşunuzda olaylar meydana geldiğinde uyarılabilecek kullanıcılardır. Bu kişilerin zaten Galarm'a kayıtlı olması gerekir.`,
  noMembersConfiguredInBusinessAccount: `Henüz üye eklemediniz.

Üyeler, Galarm premium özelliklerini vermek istediğiniz kullanıcılardır. Bu kişilerin zaten Galarm'a kayıtlı olması gerekir.`,
  noTeamsConfiguredInEnterpriseAccount: `Henüz takım oluşturmadınız.

Takımlar, kuruluşunuzda olaylar meydana geldiğinde birlikte uyarılabilecek üye gruplarıdır.`,
  noAlertsConfiguredInEnterpriseAccount: `Henüz dinleyici oluşturmadınız.

Dinleyiciler, kuruluşunuzdaki olayları izler. Bir olay tespit edildiğinde hangi üyelerin veya takımların bilgilendirileceğini tanımlayabilir ve zamanında kabul edilmezse yükseltme kuralları belirleyebilirsiniz.

Her dinleyici, koşullar karşılandığında olayları otomatik olarak tetiklemek için izleme araçlarınızla entegre edebileceğiniz bir webhook sağlar. Ayrıca, dikkat gerektiren bir durum olduğunda uygulamadan manuel olarak olaylar oluşturabilirsiniz.`,
  noShiftsConfiguredInEnterpriseAccount:
    'Henüz herhangi bir vardiya yapılandırması oluşturmadınız.',
  noRotationsConfiguredInEnterpriseAccount:
    'Henüz herhangi bir rotasyon oluşturmadınız.',
  rotations: 'Rotasyonlar',
  addRotation: 'Rotasyon Ekle',
  editRotation: 'Rotasyonu Düzenle',
  enterRotationName: 'Rotasyon adını girin',
  rotationType: 'Rotasyon Tipi',
  numberOfHoursInRotation: 'Rotasyondaki saat sayısı',
  numberOfDaysInRotation: 'Rotasyondaki gün sayısı',
  numberOfWeeksInRotation: 'Rotasyondaki hafta sayısı',
  specify: 'Belirtiniz...',
  noIntegrationsConfiguredInEnterpriseAccount:
    'Henüz herhangi bir entegrasyon yapılandırması yapmadınız.',
  loadingUser: 'Kullanıcı bilgileri yükleniyor',
  addMember: 'Üye Ekle',
  add: 'Ekle',
  noUserFoundWithMobileNumber:
    'Bu telefon numarasına sahip kayıtlı bir Galarm kullanıcısı bulunamadı. Lütfen telefon numarasını ülke koduyla birlikte parantez, tire, boşluk gibi özel karakterler olmadan girdiğinizden emin olun.',
  memberWithPhoneNumberAlreadyAdded:
    'Bu telefon numarasına sahip üye zaten eklenmiştir.',
  memberWithEmailAlreadyAdded: 'Bu e-postaya sahip üye zaten eklenmiştir.',
  assignKeyToMember: 'Lisans anahtarı atama',
  revokeKeyFromMember: 'Lisans anahtarını iptal et',
  cantAssignKeyToMember: 'Üyeye Anahtar Atanamıyor',
  noEnterpriseLicenseKeyAvailable:
    'Lisans anahtarı mevcut değil. Lütfen planınızı yükseltin.',
  addTeam: 'Takım Ekle',
  enterTeamName: 'Bir takım adı girin',
  addAlert: 'Dinleyici Ekle',
  critical: 'Kritik',
  low: 'Düşük',
  medium: 'Orta',
  high: 'Yüksek',
  severity: 'Ciddiyet',
  enterAlertName: 'Dinleyici için ad girin',
  organization: 'Organizasyon',
  startTime: 'Başlangıç Zamanı',
  endTime: 'Bitiş Zamanı',
  shiftName: 'Vardiya {{index}}',
  addShift: 'Vardiya Ekle',
  assignees: 'Atananlar',
  shiftStartEndTime: '{{startTime}} - {{endTime}}',
  assignee: 'Devralan',
  specifyAssigneeForShift: 'Vardiya için atanan kişiyi belirtin',
  selectAtLeastOneMember: 'En az bir üye seçin',
  editMember: 'Üye Düzenle',
  editTeam: 'Düzenleme Ekibi',
  cantRemoveMemberAssignedToTeamsOrAlerts:
    'Üye bir ekibin parçası veya bir dinleyiciye atanmış. Lütfen silmeden önce üyeyi bu ekiplerden/dinleyicilerden çıkarın.\nTakımlar: {{teams}}\nDinleyiciler: {{alerts}}',
  cantRevokeKeyFromMemberAssignedToTeamsOrAlerts:
    'Üye bir ekibin parçası veya bir dinleyiciye atanmış. Lütfen anahtarı iptal etmeden önce üyeyi bu ekiplerden/dinleyicilerden çıkarın.\nTakımlar: {{teams}}\nDinleyiciler: {{alerts}}',
  cantDeleteTeamAssignedToAlerts:
    'Ekip bir dinleyicinin parçasıdır. Lütfen silmeden önce ekibi dinleyiciden kaldırın.\nDinleyiciler: {{alerts}}',
  cantDeleteRotationAssignedToAlerts:
    'Rotasyon bir dinleyicinin parçasıdır. Lütfen silmeden önce ekibi dinleyiciden kaldırın.\nDinleyiciler: {{alerts}}',
  editAlert: 'Dinleyiciyi Düzenle',
  timezoneDisplayString: '(GMT{{offset}}) {{timezone}}',
  apiKey: 'API Anahtarı',
  viewApiKey: 'API Anahtarını Görüntüle',
  apiKeyWarningMessage:
    'API anahtarınızı her zaman güvende tutun. Hiçbir kurumla paylaşmayın. API anahtarınızın ele geçirildiğini düşünüyorsanız, değiştirmek için yukarıdaki "Değiştir" düğmesine dokunun. Anahtarı değiştirdikten sonra, REST API kullanarak olayları tetiklediğiniz tüm yerlerde yeni anahtarı belirtmeniz gerekecektir',
  integrationConfigs: 'Entegrasyon Yapılandırmaları',
  addIntegrationConfig: 'Entegrasyon Yapılandırması Ekle',
  editIntegrationConfig: 'Entegrasyon Yapılandırmasını Düzenle',
  integrationSource: 'Entegrasyon Kaynağı',
  apiToken: 'API Belirteci',
  integrations: 'Entegrasyonlar',
  selectPlaceholder: 'Seçiniz...',
  chooseRoleForMember: 'Üye için rol seçin',
  zendeskSubdomain: 'Zendesk Alt Alan Adı',
  creatorTimeForBuddyAlarm: '{{timeString}} ({{remindMeAfter}})',
  nextFiveAlarms: 'Sonraki 5 Alarm',
  categories: 'Kategoriler',
  viewingAlarmsDueToday: 'Alarmların görüntülenmesi bugün sona eriyor',
  viewingAlarmsDueTomorrow: 'Alarmların görüntülenmesi yarın sona eriyor',
  expiredAlarms: 'Kaçırılan Alarmlar',
  viewingExpiredAlarms: 'Kaçırılan Alarmları Görüntüleme',
  noAlarmsDueToday: 'Bugün alarm yok',
  noAlarmsDueTomorrow: 'Yarın alarm yok',
  noExpiredAlarms: 'Kaçırılan alarm yok',
  viewingAllAlarms: 'Tüm Alarmları Görüntüleme',
  viewingRecentlyDeletedAlarms: 'Son Silinen Alarmları Görüntüleme',
  alarmsWillBeAutomaticallyDeleted:
    'Alarmlar silindikten 30 gün sonra kalıcı olarak kaldırılacaktır.',
  summaryView: 'Özet Görünümü deneyin?',
  summaryViewDescription:
    'Son tarihlere ve kategorilere göre düzenlenmiş alarmları görün.\n\nSağ üstteki ⋮ düğmesini kullanarak liste görünümüne geri dönebilirsiniz.',
  disableBatteryOptimizationMessageOnStartup:
    "Alarmların güvenilir bir şekilde çalması için Galarm'ın arka planda çalışması gerekir. Lütfen bir sonraki ekranda izin verin.",
  disableBatteryOptimizationMessage:
    "Alarmların güvenilir bir şekilde çalması için Galarm'ın arka planda çalışması gerekir.",
  allowNotificationsToDisplayAlarms:
    "Galarm'ın alarm çaldığında bildirimleri göstermek için izne ihtiyacı var.",
  scheduleExactAlarmsMessage:
    "Galarm'ın kesin alarmları planlamak için izne ihtiyacı vardır.",
  alarmCategoryWithSameNameExists:
    'Bu isimde bir kategori zaten mevcut. Lütfen farklı bir isim belirtiniz.',
  unlimitedAlarmsPremiumFeature: 'Sınırsız Grup ve Arkadaş Alarmı',
  alarmRepetitionsPremiumFeature: 'Gelişmiş Tekrarlama Seçenekleri',
  ringtonesPremiumFeature: 'Daha Fazla Zil Sesi',
  galarmWebPremiumFeature: "Galarm'ı Web'de Kullanın",
  taskListPremiumFeature: 'Birden Fazla Görev Listesi Oluşturma',
  preReminderPremiumFeature: 'Alarmlar için Ön Hatırlatma',
  alarmCategoriesPremiumFeature: 'Özel Alarm Kategorileri',
  shareableAlarmLinksPremiumFeature: 'Paylaşılabilir Alarm Bağlantıları',
  announceAlarmNamePremiumFeature: 'Alarm Başlığını Duyur',
  manageSubscription: 'Aboneliği Yönet',
  modifySubscription: 'Aboneliği Değiştir',
  purchaseRestored: 'Satın alma geri yüklendi.',
  unableToRetrieveSubscriptionPlansAndroid:
    "Yükseltme işlemini gerçekleştirmek için Google Play'e bağlanamıyoruz. Lütfen internete bağlı olduğunuzdan emin olun ve ardından tekrar deneyin. \n\nBu sorun devam ederse, lütfen destek ekibimize bir sorun bildirin.",
  unableToRetrieveSubscriptionPlansIos:
    "Yükseltme işlemini gerçekleştirmek için App Store'a bağlanamıyoruz. Lütfen internete bağlı olduğunuzdan emin olun ve ardından tekrar deneyin. \n\nBu sorun devam ederse, lütfen destek ekibimize bir sorun bildirin.",
  drawOverOtherApps: 'Diğer uygulamaların üzerinde görüntüleme',
  drawOverOtherAppsHelperText:
    "Galarm'ın alarm uyarılarını üstte göstermesine izin verin",
  nTimes: {
    one: '1 kez',
    other: '{{count}} zamanlar'
  },
  learnHowToUseFocus: 'Odaklanmayı Öğrenin',
  enhancedNotificationsDeprecated:
    'Geliştirilmiş Bildirimler Kullanımdan Kaldırıldı',
  enhancedNotificationsDeprecatedMessage:
    "Geliştirilmiş Bildirimlerin güvenilir olmadığını ve aşırı pil tüketimine neden olduğunu tespit ettik. Telefonunuz Rahatsız Etmeyin özelliğindeyken Galarm'ın alarm çalmasına izin vermek için lütfen iOS Focus özelliğini kullanın.",
  usingIosFocus: "iOS Focus'u Kullanma",
  iosFocusModePara1:
    'Telefonun zil düğmesi kapatıldığında veya zil sesi seviyesi 0 olduğunda Galarm çalmayacaktır.\n\nApple, telefonunuzu sessiz tutmak ama yine de bazı uygulamaların size bildirim göndermesine izin vermek istediğinizde "Odak" özelliğini kullanmanızı önerir. Telefonunuzda Odak\'ı ayarlamak için aşağıdaki talimatları kullanın.',
  iosFocusModePara2:
    'Ekran görüntüleriyle birlikte daha ayrıntılı talimatları https://galarm.zendesk.com/hc/en-us/articles/10906890793236-Allow-alarms-to-ring-on-silent-on-iOS adresinde görüntüleyebilirsiniz.',
  settingFocus: 'Odağı Ayarlama:',
  settingFocusFootNotes:
    'Focus\'un iOS 15 ve üzeri sürümlerde kullanılabildiğini lütfen unutmayın.\n\nSorularınız veya geri bildirimleriniz için lütfen "Ayarlar > Geri Bildirim" üzerinden bizimle iletişime geçin.',
  enablingFocus: 'Odaklanmayı Etkinleştirmek:',
  settingFocusInstruction1: '"Telefon Ayarları > Odak" öğesine gidin.',
  settingFocusInstruction2: '"Rahatsız Etmeyin" odak profiline dokunun.',
  settingFocusInstruction3:
    '"Uygulamalar" üzerine dokunun ve Galarm\'ı ekleyin.',
  settingFocusInstruction4:
    'Ayarladığınız diğer Odak profilleri için de aynısını yapın.',
  enablingFocusInstruction1:
    'Kontrol Merkezini görüntülemek için sağ üst kenardan aşağı kaydırın.',
  enablingFocusInstruction2: 'Odak üzerine dokunun.',
  enablingFocusInstruction3:
    'Rahatsız Etmeyin öğesine veya etkinleştirmek istediğiniz başka bir Odak profiline dokunun.',
  enablingFocusInstruction4:
    'Şu anda etkin olan Odak seçili olarak görünür. Devre dışı bırakmak için üzerine tekrar dokunabilirsiniz.',
  startDateForRotation: 'Rotasyon için başlangıç tarihi',
  startTimeForRotation: 'Rotasyon için başlangıç zamanı',
  member: 'Üye',
  multipleShiftsInADay: 'Bir günde birden fazla vardiya',
  escalationPolicy: 'Eskalasyon Politikası',
  atTimeOfEvent: 'Etkinlik sırasında',
  afterNMinutes: 'Sonra {{count}} dakika',
  afterNHours: {
    one: '1 saat sonra',
    other: '{{count}} saatinden sonra'
  },
  afterDuration: 'Sonra {{durationString}}',
  addTrigger: 'Tetikleyici Ekle',
  viewCode: 'Kodu Görüntüle',
  apiCodes: 'API Kodları',
  viewIncidents: 'Olayları Görüntüle',
  viewInstantAlarms: 'Anlık Alarmları Görüntüle',
  viewTasks: 'Görevleri Görüntüle',
  incidentsForAlert: 'Dinleyici için olaylar {{alertName}}',
  timestamp: 'Zaman Damgası',
  notAcknowledged: 'Açık',
  acknowledged: 'Onaylandı',
  closed: 'Kapalı',
  recovered: 'Otomatik Kurtarıldı',
  noIncidentsForAlert: 'Bu dinleyici için henüz bir olay yok',
  errorClosingIncident: 'Hata kapatma olayı',
  errorClosingIncidents: 'Hata kapatma olayları',
  apiCodeCopiedToClipboard: 'API Kodu panoya kopyalandı.',
  triggerName: 'Tetikleyici {{index}}',
  delay: 'Gecikme',
  chooseAssigneePlaceholder: 'Atanacak Kişiyi Seçin...',
  delayForTrigger: 'Tetikleme için Gecikme',
  assigneeWillBeAlertedAfterDelay:
    'Alıcı {{durationString}} adresinden sonra uyarılacaktır.',
  escalationForIncidentsForAlert:
    'Dinleyici için {{incidentDate}} adresinde olay için eskalasyon {{alertName}}',
  alertIncidentAcknowledged:
    '{{memberName}} adresinden alınmıştır. {{dateString}}',
  alertIncidentClosed: '{{memberName}} tarafından kapatıldı. {{dateString}}',
  alertIncidentAutoClosed: 'Otomatik kapanma {{dateString}}',
  alertIncidentRecovered: "'de otomatik olarak kurtarılır {{dateString}}",
  alertedAssignees: 'Uyarıldı {{assigneesString}}',
  acknowledgedBy: 'Tarafından onaylandı {{memberName}}',
  closedBy: 'Tarafından kapatıldı {{memberName}}',
  alertIncidents: 'Olaylar',
  viewingAlertIncidents: 'Olayları Görüntüleme',
  createOrganization: 'Organizasyon Oluşturun',
  youAreNotPartOfAnyOrganization:
    'Herhangi bir organizasyonun parçası değilsiniz. Başlamak için bir organizasyon oluşturun.',
  tellUsAboutYourOrganization: 'Bize kuruluşunuzdan bahsedin',
  noActiveSubscription: 'Aktif bir aboneliğiniz yok.',
  chooseOrganization: 'Devam etmek için bir kuruluş seçin.',
  noTriggersForIncident:
    'Bu olay için herhangi bir tetikleyici bulunamamıştır.',
  role: 'Rol',
  viewer: 'Görüntüleyici',
  viewerNoLogin: 'Görüntüleyici (Giriş Yok)',
  incidentCoordinator: 'Olay Koordinatörü',
  assignedListeners: 'Atanan Dinleyiciler',
  assignedLabels: 'Atanan Etiketler',
  noListenersAssignedToCoordinator:
    'Lütfen Olay Koordinatörüne en az bir dinleyici veya etiket atayın.',
  recipientRole: 'Alıcı Rolü',
  editor: 'Editör',
  recipientRoleTooltipMessage: `Alıcının alarmın tarih ve saatini değiştirmesine izin verebilirsiniz.

Alıcının alarmın tarih ve saatini değiştirebilmesi için Galarm Premium abonesi olması gerekir.`,
  recipientChangeDateTimePremiumDescription:
    "Bir arkadaş alarmının tarih ve saatini değiştirmek premium bir özelliktir. Bu alarmın tarih ve saatini değiştirmek için Galarm Premium'a yükseltin.",
  recipientUpdatedAlarmDateAndTime:
    'Alarm saati {{dateTimeString}} olarak değiştirildi. Oluşturucuya bildirildi.',
  recipientChangedAlarmTimeChatMessage:
    "{{username}}, alarm saatini {{originalTime}}'den {{newTime}}'e değiştirdi",
  allowRecipientToChangeTime: 'Alıcının alarm saatini değiştirmesine izin ver',
  enterpriseViewerRoleDescription:
    'Görüntüleyici rolüne sahip kullanıcılar, olay alarmlarını almak için dinleyicilere eklenebilir. Ayrıca web uygulamasına giriş yaparak olayları ve dinleyicileri görüntüleyebilirler, ancak değişiklik yapamazlar.',
  enterpriseViewerNoLoginRoleDescription:
    'Görüntüleyici (Giriş yok) rolüne sahip kullanıcılar, olay alarmlarını almak için dinleyicilere eklenebilir. Olayları ve dinleyicileri görmek için web uygulamasına giriş yapamazlar.',
  enterpriseAdminRoleDescription:
    'Yönetici rolüne sahip kullanıcılar, olay alarmlarını almak için dinleyicilere eklenebilir. Ayrıca web uygulamasına giriş yaparak olayları ve dinleyicileri görüntüleyebilir ve değişiklik yapabilirler.',
  enterpriseIncidentCoordinatorRoleDescription:
    'Olay Koordinatörü rolüne sahip kullanıcı, kendilerine atanan dinleyiciler için olayları görüntülemek üzere uygulamaya giriş yapabilir. Ayrıca, bu dinleyiciler için olayları kontrol panelinden kapatabilirler.',
  findAppleOrder: 'Apple Siparişini Bul',
  incidentCoordinatorListenerLimitWarning:
    "Size 30'dan fazla dinleyici atanmış. Burada yalnızca ilk 30'un olayları gösterilmektedir. Lütfen yöneticinizle iletişime geçin.",
  newOrganization: 'Yeni Organizasyon',
  switchOrganization: 'Kuruluşu Değiştir',
  usageAnalytics: 'Kullanım Analitiği',
  incidentsOpened: 'Toplam Açılan Olaylar',
  incidentsOpen: 'Açık',
  incidentsAcknowledged: 'Kabul Edildi',
  incidentsClosed: 'Kapalı',
  incidentsAutoClosed: 'Otomatik Kapandı',
  alarmsSent: 'Gönderilen Alarmlar',
  avgTimeToAcknowledge: 'Ortalama Kabul Süresi',
  avgTimeToResolve: 'Ortalama Çözüm Süresi',
  noAnalyticsData:
    'Henüz analiz verisi yok. Veriler, olaylar ve diğer olaylar meydana geldikçe kaydedilir.',
  dailyTrend: 'Günlük Eğilim (Son 30 Gün)',
  daily: 'Günlük',
  weekly: 'Haftalık',
  numbersView: 'Sayılar',
  chartView: 'Grafik',
  last7Days: 'Son 7 Gün',
  last30Days: 'Son 30 Gün',
  last90Days: 'Son 90 Gün',
  last6Months: 'Son 6 Ay',
  lastYear: 'Son Yıl',
  noOrganizations: 'Herhangi bir organizasyonun parçası değilsiniz.',
  maxOrganizationsReached: 'Kullanıcı en fazla 10 kuruluşun parçası olabilir.',
  yourOrganizations: 'Organizasyonlar',
  urlNotFound: 'URL desteklenen herhangi bir rota ile eşleşmiyor.',
  triggerAlert: 'Tetikleyici Olay',
  recaptchaFailed: 'reCAPTCHA doğrulaması başarısız oldu. {{error}}',
  loadingAccountInformation: 'Hesap bilgileri yükleniyor',
  loadingAuthInfo: 'Kimlik doğrulama bilgileri yükleniyor',
  allAlerts: 'Tüm Dinleyiciler',
  recentlyTriggeredAlerts: 'Son Tetiklenen Dinleyiciler',
  recentlyClosedIncidents: 'Yakın Zamanda Kapanan Olaylar',
  noRecentlyTriggeredAlerts: 'Son zamanlarda hiçbir dinleyici tetiklenmedi.',
  noRecentlyClosedIncidents: 'Son zamanlarda hiçbir olay kapanmamıştır.',
  closedAt: 'Kapalı {{dateTimeString}}',
  dashboard: 'Gösterge Tablosu',
  loggedIntoOrganizationAccount: 'Org: {{organizationName}}\nRol: {{role}}',
  viewIncidentEscalation: 'Olay Eskalasyonunu Görüntüle',
  closeIncident: 'Yakın Olay',
  closingIncident: 'Kapanış olayı',
  unableToRefreshEnterpriseAccount: 'Hesabınız yenilenemiyor.',
  viewAuthToken: "Auth Token'ı Görüntüle",
  problemWithCreatingAuthToken:
    'Kimlik doğrulama belirteci oluştururken bir sorun oluştu. Lütfen teknik destek ile iletişime geçin.',
  authToken: 'Auth Token',
  authTokenWarningMessage:
    'Bu auth token\'ı her zaman güvende tutun. Hiçbir kurumla paylaşmayın. API anahtarınızın ele geçirildiğini düşünüyorsanız, değiştirmek için yukarıdaki "Değiştir" düğmesine dokunun. Belirteci değiştirdikten sonra, REST API kullanarak olayları tetiklediğiniz tüm yerlerde yeni belirteci belirtmeniz gerekecektir',
  authTokenCopiedToClipboard: 'Auth token panoya kopyalandı.',
  resendVerificationEmail: 'Doğrulama E-postasını Yeniden Gönder',
  loggedInUsingEmail: '{{email}} e-posta adresini kullanarak giriş yaptı.',
  checkingIfMemberIsAppUser:
    'Üyenin bir uygulama kullanıcısı olup olmadığı kontrol ediliyor.',
  settingMemberDetails: 'Üye ayrıntılarını ayarlama.',
  addingTeam: 'Takım ekleniyor.',
  editingTeam: 'Kurgu ekibi.',
  addingRotation: 'Rotasyon ekleniyor.',
  editingRotation: 'Düzenleme rotasyonu.',
  assigningKeyToMember: 'Üyeye anahtar atama.',
  revokingKeyFromMember: 'Üyeden anahtarı iptal etme.',
  deletingTeam: 'Takım siliniyor.',
  deletingRotation: 'Rotasyon silme.',
  addingAlert: 'Dinleyici ekleniyor.',
  editingAlert: 'Dinleyiciyi düzenlemek.',
  deletingAlert: 'Dinleyici siliniyor.',
  triggeringAlert: 'Tetikleyici olay.',
  creatingOrganizationAccount: 'Organizasyon hesabı oluşturma.',
  creatingCheckoutSession: 'Ödeme oturumunuzu başlatma.',
  creatingAnAccountForMember: 'Üye için bir hesap oluşturma.',
  passwordResetEmailSent:
    'Şifrenizi sıfırlamanız için size bir e-posta gönderdik. Şifrenizi değiştirin ve tekrar giriş yapın.',
  changeOwner: 'Sahibi Değiştir',
  changeOrganizationOwner: 'Organizasyon Sahibini Değiştir',
  newOwnerEmail: 'Yeni Sahip E-postası',
  saveOnYearlySubscription: 'Kaydet {{percent}}%',
  annual: 'Yıllık',
  resetAlarms: 'Alarmları Yenile',
  resetAlarmsAlert:
    'Tüm alarmlar yenilenmiştir. Alarmlarla ilgili sorunlar gözlemlemeye devam ederseniz, lütfen "Sorun Bildir" seçeneğini kullanarak bir bilet gönderin.',
  resetAlarmsTooltipMessage:
    'Silinen alarmların telefonda çalması gibi alarmlarla ilgili sorunlar yaşıyorsanız, lütfen bu seçeneği kullanarak alarmları yenileyin. Sorun devam ederse, lütfen "Sorun Bildir" seçeneğini kullanarak bir bilet gönderin.',
  resetTempPassword: 'Geçici Parolayı Sıfırla',
  currPassword: 'Geçerli Şifre',
  tempPassword: 'Geçici Şifre',
  newPassword: 'Yeni Şifre',
  reset: 'Sıfırla',
  loggingIn: 'Oturum açma',
  resettingTempPassword: 'Geçici parolayı sıfırlama',
  changingPassword: 'Şifre değiştirme',
  numSeats: 'Koltuk Sayısı',
  helpMeDecide: 'Karar vermeme yardım et',
  numEnterpriseSeatsHelper:
    'Koltuk sayısını, kuruluşunuzda olayları almak için uygulamayı kullanacak kişi sayısı olarak seçmelisiniz. Bir dinleyiciyi yapılandırırken, onun eskalasyon ilkesini belirleyebilirsiniz. Bir eskalasyon ilkesinde birden fazla seviyeye sahip olabilirsiniz. Örneğin, ilk eskalasyon seviyesinin 3 kişilik bir ekip olduğunu belirtebilirsiniz. İlk eskalasyon seviyesi 5 dakika içinde yanıt vermezse, ikinci eskalasyon seviyesi 5 kişilik bir ekibe yapılır. Bu durumda koltuk sayısını 8 olarak belirleyebilirsiniz.',
  numBusinessSeatsHelper:
    "Alarmları ve hatırlatıcıları almak için Galarm'ı kullanacak kişi sayısına uygun koltuk sayısını seçin.",
  perSeatPrice: '{{price}} koltuk başına {{interval}} ',
  doneForToday: 'Onaylandı',
  getStarted: 'Başlayın',
  firstAlertInstructions: 'İlk Dinleyici Talimatları',
  learnMoreAboutGalarmEnterprise: 'Galarm Pro hakkında daha fazla bilgi edinin',
  home: 'Ev',
  team: 'Takım',
  alert: 'Uyarı',
  listener: 'Dinleyici',
  forgotPassword: 'Şifrenizi mi unuttunuz?',
  forgotPasswordTitle: 'Şifremi Unuttum',
  sendPasswordResetEmail: 'Şifre Sıfırlama E-postası Gönder',
  sendingPasswordResetEmail: 'Parola sıfırlama e-postası gönderme',
  field: 'Saha',
  description: 'Açıklama',
  requestIntegration: 'Başka bir entegrasyon talep edin',
  integrationDetails: 'Entegrasyon Detayları',
  enterIntegrationDetails: 'Entegrasyon ayrıntılarını sağlayın',
  galarmEnterpriseFreeTrial: '14 günlük ücretsiz deneme için kaydolun',
  galarmEnterpriseFreeTrialDescription: 'Olay yönetimini otomatikleştirin',
  bySigningUpYouAgreeToOur:
    'Kaydolarak, aşağıdaki koşullarımızı kabul etmiş olursunuz',
  and: 've',
  alarmSubscribers: 'Alarm Takipçileri',
  otherSubscribersCount: {
    one: 'Rehberinizde olmayan 1 takipçi daha',
    other: '{{count}} rehberinizde olmayan daha fazla takipçi'
  },
  getAccountData: 'Alarm Verilerini Dışa Aktar',
  getAccountDataPrompt:
    'Tüm alarmlarınızı içeren bir metin dosyasını göndereceğimiz bir e-posta adresi sağlayın.',
  getAccountDataConfirmation:
    'Lütfen {{email}} adresinden tüm alarmlarınızı içeren bir metin dosyasını size e-posta ile göndereceğimizi unutmayın.',
  sendingAccountData: 'Alarm verilerini dışa aktarma...',
  sentAccountData: 'Alarm verileri {{email}} adresine gönderilir.',
  errorSendingAccountData:
    'Alarm verileri dışa aktarılırken hata oluştu: {{error}}',
  sendingEmailVerificationLink: 'E-posta doğrulama bağlantısı gönderme',
  viewLogs: 'Günlükleri Görüntüle',
  message: 'Mesaj',
  billing: 'Faturalandırma',
  newIncidentForAlert: 'Dinleyici için yeni olay {{alertName}}',
  triggerFailureForAlert:
    '{{alertName}} dinleyicisi tetiklenemedi: {{error}}',
  clickNextAfterAddingMembers: 'Üyeleri ekledikten sonra "İleri "ye tıklayın',
  clickDoneAfterAddingAlerts:
    'Kurulumu tamamlamak ve Dashboard\'a gitmek için "Bitti "ye tıklayın.',
  alertCreatedSuccessfully:
    'Dinleyici başarıyla oluşturuldu. Bu dinleyiciyi, dinleyici adının önündeki üç noktalı menü simgesinden tetikleyebilirsiniz.',
  fixSubscription: 'Aboneliği Düzelt',
  fixSubscriptionDescription:
    'Aboneliğinizle ilgili bir sorun tespit ettik. Aboneliğiniz {{numSeats}} koltuk(lar) içeriyor ancak {{numSeatsAssigned}} üye(ler)ine anahtar atadınız. En fazla {{numSeats}} anahtar(lar)ı atayabilirsiniz.',
  fixSubscriptionChooseOption:
    'Lütfen aşağıdaki seçeneklerden birini kullanarak aboneliğinizi düzeltin.',
  fixSubscriptionContactAdmin: 'Lütfen kuruluş yöneticinizle iletişime geçin.',
  unassignKeysFromMembers:
    'Üyelerden en az {{extraKeysAssigned}} anahtar(lar)ının atamasını kaldırın',
  addMoreSeatsToSubscription:
    'Aboneliğinize en az {{extraKeysAssigned}} koltuk(lar) ekleyin',
  revokeMembersKey: 'Üyelerin Anahtarını İptal Etme',
  revokeMembersKeyDescription:
    'Anahtarlarını iptal etmek istediğiniz üyeleri seçin.',
  revoke: 'İptal',
  unableToRevokeMembersKey:
    'Üyelerin anahtarını iptal ederken bir hata oluştu. Lütfen destek ile iletişime geçin.',
  problemWithLoadingProducts: 'Ürün yükleme ile ilgili sorun. {{error}}',
  verificationCompleted: 'Doğrulama Tamamlandı',
  deviceAlreadyRegistered:
    'Bu telefon numarası daha önce bu cihazda doğrulanmıştır.',
  phoneNumberAutoFilled:
    'Galarm, Google hesabınızdan seçilen telefon numarasını kullanacaktır.',
  unableToRegisterPreVerifiedUser:
    'Önceden doğrulanmış kullanıcı kaydedilemiyor.',
  allowNotifications: 'Bildirimlere İzin Ver',
  allowNotificationsDescription: 'Çaldıklarında alarmları görüntülemek için.',
  scheduleExactAlarms: 'Alarmları Planla',
  scheduleExactAlarmsHelperText:
    "Galarm'ın alarmları tam zamanında çalmasına izin verin.",
  scheduleExactAlarmsDescription: 'Alarmları tam zamanında çalmak için.',
  disableBatteryOptimization: 'Pil Optimizasyonunu Yönetme',
  disableBatteryOptimizationDescription:
    "Galarm'ın arka planda çalışmasına izin vermek için.",
  requestRequiredPermissions:
    'Galarm alarm çalmak için aşağıdaki izinleri gerektirir',
  allowDisallowedPermissions: 'İzin vermek için dokunun',
  notificationsAreEnabled:
    'Bildirimleri gösterme iznine zaten izin verilmiştir.',
  connectingToStore: 'Mağazaya bağlanıyor...',
  restartApp: 'Uygulamayı Yeniden Başlat',
  updateAvailable: 'Güncelleme Mevcut',
  english: 'İngilizce',
  russian: 'Rusça',
  german: 'Alman',
  french: 'Fransızca',
  spanish: 'İspanyolca',
  italian: 'İtalyan',
  portuguese: 'Portekizce',
  japanese: 'Japonca',
  korean: 'Korece',
  indonesian: 'Endonezce',
  changeAppLanguage: 'Uygulama Dilini Değiştirme',
  appLanguage: 'Uygulama Dili',
  iosChangeAppLanguagePara1:
    "Galarm, uygulama dilini telefon ayarlarınızdan seçer. Galarm'ın uygulama dilini değiştirmek için lütfen aşağıdaki adımları izleyin:",
  iosChangeAppLanguageInstruction1:
    '"Telefon Ayarları > Genel > Dil ve Bölge" öğesini açın. Galarm için kullanmak istediğiniz dilin tercih edilen diller listesinde bulunduğundan emin olun.',
  iosChangeAppLanguageInstruction2:
    '"Telefon Ayarları "na geri dönün ve alttaki uygulamalar listesinde "Galarm "a dokunun.',
  iosChangeAppLanguageInstruction3:
    '"Dil" üzerine dokunun ve Galarm için ayarlamak istediğiniz dili seçin. Dili seçtikten sonra uygulamaya geri dönün',
  androidChangeAppLanguagePara1:
    "Galarm, uygulama dilini telefon ayarlarınızdan seçer. Galarm'ın uygulama dilini değiştirmek için lütfen aşağıdaki adımları izleyin:",
  androidChangeAppLanguageInstruction1:
    'Aşağıdaki "Uygulama Ayarlarını Aç" düğmesine dokunun.',
  androidChangeAppLanguageInstruction2:
    '"Dil" üzerine dokunun ve Galarm için kullanmak istediğiniz dili seçin.',
  androidChangeAppLanguageInstruction3:
    'Dili seçtikten sonra buraya geri dönün ve aşağıdaki "Uygulamayı Yeniden Başlat" düğmesine tıklayın.',
  problemRetrievingSubscriptionData:
    'Abonelik bilgilerinizi alırken bir sorun oluştu. Sizi hesap sayfasına yönlendiriyoruz. Lütfen abonelik durumunuzu kontrol edin ve sorun yaşamaya devam ederseniz teknik destek ile iletişime geçin.',
  deletingOrganization: 'Organizasyon silme...',
  deleteOrganization: 'Organizasyon Silme',
  deleteOrganizationDescription:
    'Kuruluşunuzu silmek istediğinizden emin misiniz?\n  \n  Bu geri döndürülemez bir işlemdir. Kuruluşunuzun tüm verileri silinecektir.\n  \n  Lütfen organizasyonu silmeden önce aboneliğinizi iptal ettiğinizden emin olun.',
  galarmEnterpriseTrialDescription:
    "Susbcription'ı herhangi bir ücret ödemeden iptal edebileceğiniz 14 günlük ücretsiz deneme süresi vardır.",
  galarmEnterpriseTrialAlreadyAvailed:
    'Zaten 14 günlük ücretsiz deneme sürümünden yararlandınız. Ürünü değerlendirmek için daha fazla zamana ihtiyacınız varsa destek ekibiyle iletişime geçin.',
  signinWithGoogle: 'Google ile oturum açın',
  signinWithGithub: 'GitHub ile oturum açın',
  verifyAccount: 'Hesabı Doğrula',
  verifyAccountMessage:
    'Doğrulama kodu içeren bir e-posta almış olmalısınız. Hesabınızı doğrulamak için aşağıdaki kodu girin. Kodu almadıysanız, "Kodu Yeniden Gönder" düğmesine tıklayarak yeni bir kod talep edebilirsiniz.',
  verificationCode: 'Doğrulama Kodu',
  optionalString: '{{string}}',
  quickReminderTitle: 'Başlık (isteğe bağlı)',
  accountVerified: 'Hesap Doğrulandı',
  accountVerifiedMessage: 'Lütfen kimlik bilgilerinizi kullanarak giriş yapın.',
  multipleUsersWithSameEmail:
    'Aynı e-postaya sahip birden fazla kullanıcı var. Lütfen destek ile iletişime geçin.',
  multipleUsersWithSameMobileNumber:
    'Aynı cep telefonu numarasına sahip birden fazla kullanıcı var. Lütfen destek ile iletişime geçin.',
  startTrial: 'Deneme Başlat',
  nextSteps: 'Sonraki Adımlar',
  firstTimeSetupComplete:
    'Galarm Enterprise için ilk kurulumu tamamladınız ve ilk dinleyicinizi oluşturdunuz. Bundan sonra atabileceğiniz bazı adımlar aşağıda verilmiştir.',
  testTheAlertInstruction:
    'Yeni oluşturduğunuz dinleyiciyi nasıl test edeceğinizi öğrenmek için {{link}} adresindeki talimatları kontrol edin.',
  integrateTheAlertInstruction:
    'Dinleyiciyi çeşitli izleme araçlarıyla entegre etmek için {{link}} adresindeki talimatlara göz atın.',
  createMoreAlertsInstruction:
    'Soldaki "Dinleyiciler" sekmesine giderek daha fazla dinleyici ekleyebilirsiniz.',
  addMoreMembersInstruction:
    'Soldaki "Üyeler" sekmesine giderek daha fazla üye ekleyebilirsiniz.',
  createTeamsInstruction:
    'Üyeleri "Ekipler" halinde gruplayabilir ve bir olay meydana geldiğinde tüm ekipleri uyarabilirsiniz. Soldaki "Ekipler" sekmesine giderek ekipler oluşturun ve bunları dinleyicinin yapılandırmasında kullanın.',
  testTheAlert: 'Dinleyiciyi Test Edin',
  integrateTheAlert: 'Dinleyiciyi Entegre Edin',
  createMoreAlerts: 'Daha Fazla Dinleyici Yaratın',
  addMoreMembers: 'Daha Fazla Üye Ekleyin',
  createTeams: 'Ekipler Oluşturun',
  docs: 'Dokümantasyon',
  docsSmall: 'Dokümanlar',
  contactSupport: 'İletişim Desteği',
  pastDue: 'Vadesi geçmiş',
  canceled: 'İptal edildi',
  unpaid: 'Ödenmemiş',
  incomplete: 'Tamamlanmamış',
  incomplete_expired: 'Tamamlanmamış Süresi Dolmuş',
  trialing: 'Ücretsiz Deneme',
  paused: 'Duraklatıldı',
  plan: 'Plan',
  status: 'Durum',
  renewsOn: 'Yenileniyor',
  yourRoles: 'Rolleriniz',
  enterprisePlan: '{{quantity}} koltuklar, her {{interval}}',
  currentOrganization: 'Mevcut Organizasyon',
  useThisOrganization: 'Bu organizasyonu kullanın',
  fixPayment: 'Düzeltme Ödemesi',
  fixingPayment: 'Ödeme tespiti',
  addPaymentInformation: 'Ödeme Bilgileri Ekleme',
  noPaymentInformationAvailable:
    'Ödeme bilgisi mevcut değil. Yakın zamanda ödeme bilgisi eklediyseniz lütfen sayfayı yenileyin.',
  openBillingPortal: 'Açık Fatura Portalı',
  openingBillingPortal: 'Faturalama Portalının Açılması',
  startupWizardDescription:
    'Bu sihirbaz, başlamanıza ve ilk dinleyicinizi oluşturmanıza yardımcı olacaktır.',
  userNotFound: 'Kullanıcı bulunamadı',
  wrongPassword: 'Yanlış şifre',
  emailAlreadyInUse: 'E-posta zaten kullanımda',
  restoreDeletedAlarms: 'Silinen Alarmları Geri Yükleme',
  deleteAlarmAlert:
    'Silinen alarmlar "Son Silinen Alarmlar" bölümünden geri yüklenebilir. "Alarmlar" sekmesinin sağ üst köşesindeki üç noktalı menüye (⋮) dokunarak bunları görüntüleyebilirsiniz.\n\nSilinen alarmlar 30 gün boyunca orada kalır ve sonrasında kalıcı olarak silinir.',
  slackVerificationCode: 'Slack Doğrulama Kodunuz {{verificationCode}}.',
  dndAccess: 'Rahatsız Etmeyin Erişimi',
  dndHelperText:
    "Telefonunuz Rahatsız Etmeyin özelliğindeyken Galarm'ın alarm çalmasına izin verin.",
  cantRestoreInstantAlarmMessage:
    'Anlık alarmlar geri yüklenemez. Gerekirse bu alarm için sohbet ve diğer bilgileri görüntüleyebilirsiniz. Bu alarm, silinmesinin üzerinden 30 gün geçtikten sonra kalıcı olarak kaldırılacaktır.',
  upgradeToUnlockAllFeatures: 'Tüm özelliklerin kilidini açmak için yükseltin',
  otherSignupOptions: 'Diğer Kayıt Seçenekleri:',
  renewSubscription: 'Aboneliği Yenile',
  subscriptionOnHold:
    'Beklemede (Planınız {{subscriptionQty}} koltuklarına izin verir\nama size {{numSubscriptionKeys}} koltukları tahsis edilmiş.',
  checklists: 'Görevler',
  checklist: 'Görev Listesi',
  typeToAddTask: 'Görev eklemek için yazın',
  specifyTaskName: 'Görev adını belirtin',
  otherChecklists: 'Görev Listeleri',
  defaultChecklistName: 'isimsiz',
  addTasksToChecklist: 'Alttaki giriş kutusunu kullanarak görev ekleyin',
  addTasksToDefaultChecklist:
    'Alttaki giriş kutusunu kullanarak görev ekleyin... veya sağ üstteki + düğmesine tıklayarak yeni bir görev listesi başlatın',
  createNewChecklist:
    'İlgili görevleri tek bir yerde takip etmek için yeni görev listeleri oluşturabilirsiniz.',
  addNewChecklist: 'Yeni Görev Listesi',
  alarmPhoto: 'Alarm Fotoğrafı',
  alarmPhotoFeatureTitle: 'Alarm Fotoğrafı',
  alarmPhotoFeatureDescriptionPremiumUser:
    'Bu özelliği kullanarak, bir ilacın fotoğrafı, bir görev için talimatlar, bir eşya vb. gibi hızlı görsel ipuçları için bir alarma fotoğraf ekleyebilirsiniz. Alarm çaldığında fotoğraf görüntülenecektir.',
  alarmPhotoFeatureDescriptionFreeUser:
    "Bu özelliği kullanarak, bir ilacın fotoğrafı, bir görev için talimatlar, bir eşya vb. gibi hızlı görsel ipuçları için bir alarma fotoğraf ekleyebilirsiniz. Alarm çaldığında fotoğraf görüntülenecektir.\n  \nBu bir premium özelliktir. Bu özelliği kullanmak için premium'a yükseltmeniz istenecektir.",
  alarmPhotoPremiumFeature: 'Alarm Notlarına Fotoğraf Ekleme',
  installPendingAppUpdate:
    'En son uygulama güncellemesi indirildi ve yüklenmeye hazır.',
  numTasks: {
    zero: 'Görev yok',
    one: '1 görev',
    other: '{{count}} görevler'
  },
  numTasksWithCompleted: {
    one: '1 görev, {{completed}} tamamlandı',
    other: '{{count}} görevler, {{completed}} tamamlandı'
  },
  muteAlarms: 'Alarmların Sesini Kapat',
  unmuteAlarms: 'Alarmların Sesini Aç',
  alarmsAreMuted:
    'Tüm alarmlarınızın sesi şu anda kapalı. Sesi açmak için dokunun.',
  alarmsHaveBeenMuted:
    'Alarmlarınızın sesi kapatıldı. Siz seslerini açana kadar çalmayacaklardır.',
  alarmsHaveBeenUnmuted:
    'Alarmlarınızın sesi açılmıştır. Yapılandırıldıkları gibi çalmaları gerekir.',
  deleteChecklist: 'Görev Listesini Sil',
  confirmDeleteChecklist: 'Görev Listesi Silinsin mi?',
  confirmDeleteCompletedTasks: 'Tamamlanan Görevler Silinsin mi?',
  confirmResetCompletedTasks: 'Tamamlanan Görevleri Sıfırla?',
  confirmDeleteTask: '{{taskName}} adresini silelim mi?',
  showCompletedTasks: 'Tamamlanan Görevleri Göster',
  hideCompletedTasks: 'Tamamlanan Görevleri Gizle',
  deleteCompletedTasks: 'Tamamlanan Görevleri Silme',
  resetCompletedTasks: 'Tamamlanan Görevleri Sıfırla',
  yourGroups: 'Gruplarınız',
  newAlarmWith: 'Yeni Alarm ile {{name}}',
  newGroupWith: 'Yeni Grup ile {{name}}',
  alertContact: 'Uyarı {{name}}',
  alertGroup: 'Uyarı {{name}}',
  instantAlarmMovedToFabNotice:
    'Anlık Alarm özelliği artık bu ekranın sağ alt köşesindeki “+” düğmesinden erişilebilir. “Hoparlör” simgesi gelecekteki bir sürümde sağ üst köşeden kaldırılacaktır.',
  tasksIntroTitle: 'Görevler ve Görev Listeleri',
  tasksIntroDescription:
    'Görevler, son teslim tarihi olmayan yapılacak işlerinizdir. Bunları buradan hızlı bir şekilde ekleyebilir ve yönetebilir, her bir görevi yerine getirirken kontrol edebilirsiniz.\n\nBenzer görevleri gruplamak için görev listeleri de oluşturabilirsiniz. Örneğin, market alışverişiniz için bir görev listesi, iş görevleriniz için başka bir görev listesi vb. oluşturabilirsiniz.',
  groupsMovedToContactsScreen:
    '"Gruplar" bu sekmede birleştirilmiştir. Gruplarınız en üstte "Gruplarınız" altında görünür. Sağ alttaki "+" düğmesine dokunarak yeni gruplar oluşturabilirsiniz.',
  loadingTasks: 'Görevler yükleniyor...',
  tryPremium: "Premium'u deneyin",
  buyPremiumToUnlockFeature:
    'Bu premium bir özelliktir. Bu ve diğer birçok harika özelliğin kilidini 14 günlük ücretsiz deneme ile birlikte gelen premium planımızla açın.',
  newTask: 'Yeni Görev',
  newTaskList: 'Yeni Görev Listesi',
  enterTaskName: 'Görev adını girin',
  enterTaskListName: 'Görev listesi adını girin',
  taskName: 'Görev Adı',
  taskListName: 'Görev Listesi Adı',
  checklistTasks: '{{name}}',
  editTaskListName: 'Görev listesi adını düzenleme',
  editTask: 'Görevi düzenle',
  releaseNotes: 'Son Güncellemeler',
  currentRelease: '(şu anda yüklü)',
  loadingReleaseNotes:
    'Son güncellemeler yükleniyor. Lütfen internete bağlı olduğunuzdan emin olun.',
  id: 'KIMLIK',
  subscriptionData: 'Abonelik Verileri',
  organizations: 'Organizasyonlar',
  showRotationCalendar: 'Rotasyon Takvimini Göster',
  rotationCalendar: 'Rotasyon Takvimi',
  editShift: 'Vardiyayı Düzenle',
  startDateForShift: 'Vardiya için başlangıç tarihi',
  startTimeForShift: 'Vardiya için başlangıç saati',
  endDateForShift: 'Vardiya için bitiş tarihi',
  endTimeForShift: 'Vardiya bitiş saati',
  editingShift: 'Düzenleme vardiyası',
  addingShift: 'Vardiya ekleme',
  products: 'Ürünler',
  prices: 'Planlar',
  planType: 'Plan Türü',
  business: 'İş Dünyası',
  enterprise: 'Kurumsal',
  compare: 'Karşılaştırma',
  apiSupport: 'Hizmetleri izlemek için API Desteği',
  accessToConsoleToViewAndCloseIncidents:
    'Olayları yönetmek için gösterge paneli',
  triggerInstantAlertsFromTheConsole:
    "Olayları Enterprise Console'dan tetikleyin",
  coreFeatures: 'Temel Özellikler:',
  everythingInBusiness: 'İş planındaki her şey ve:',
  updatePlanInstructions:
    'Sağ taraftaki "Fatura Portalını Aç" butonuna tıklayarak ve fatura portalındaki "Planı Güncelle" butonunu seçerek planınızı güncelleyebilirsiniz.',
  membersDescription:
    '{{subscriptionKeysCount}} koltuk satın aldınız -- {{assignedSubscriptionKeysCount}} atanmış ve {{unassignedSubscriptionKeysCount}} müsait. Bir üyenin adının önündeki onay işareti atanmış bir koltuğu gösterir.',
  wizardMembersDescription:
    'Bir uyarı tetiklendiğinde bildirilmesi gereken kişileri ekleyerek başlayın. Bir üye, Galarm uygulaması aracılığıyla telefonlarında olay bildirimleri alması gereken kuruluşunuzdaki herhangi bir kişidir.',
  wizardAlertsDescription:
    "Şimdi, kuruluşunuzda olaylar meydana geldiğinde kime uyarı göndereceğinizi yapılandırmanıza olanak tanıyan bir dinleyici ekleyin. Olaylar zamanında kabul edilmediğinde nasıl yükseltileceğini de yapılandırabilirsiniz. Bir dinleyici oluşturduktan sonra, izleme araçlarınızdan olayları tetiklemek için dinleyici menüsünden webhook URL'sine erişebilirsiniz. Ayrıca dinleyici menüsünden manuel olarak bir olayı tetikleyebilirsiniz.",
  centralBilling: 'Merkezi Faturalandırma',
  saveTwoMonths: '2 ay tasarruf edin',
  owner: 'Sahibi',
  enterpriseAccountSummary:
    'Galarm Pro {{planType}} planına kayıtlı {{organizationName}} kuruluşunun bir parçasısınız.',
  perYearPerUser: 'kullanıcı başına/yıl',
  perMonthPerUser: 'kullanıcı başına/ay',
  creationDate: 'Oluşturulma Tarihi',
  updatePhoneNumber: 'Telefon Numarasını Değiştir',
  confirmCountryCodeAndEnterUpdatedPhoneNumber:
    'Lütfen ülke kodunu onaylayın ve yeni telefon numaranızı girin. Doğrulama işlemini tamamladıktan sonra hesabınız bu telefon numarasına bağlanacaktır.',
  unableToUpdatePhoneNumber:
    'Telefon numarası değiştirilemiyor: {{error}}. Lütfen destek ile iletişime geçin.',
  phoneNumberUpdated: 'Telefon numarası başarıyla değiştirildi.',
  phoneNumberUpdatedMessage:
    'Uygulamayı normal şekilde kullanmaya başlayabilirsiniz. Kişilerinizden adres defterlerindeki telefon numaranızı güncellemelerini isteyin.',
  memberChangedPhoneNumber:
    '{{memberName}} telefon numarasını değiştirdi. Bu kişileri alarmlarınıza eklemeye devam etmek için lütfen adres defterinizi güncelleyin.',
  preferredSourceForIncidents: 'Olaylar için Tercih Edilen Kaynak',
  apiCodesDescription:
    'Dinleyiciyi bir kaynakla bütünleştirmek için aşağıdaki talimatları kullanın',
  rotation: 'Rotasyon',
  noAlarmsForThisDay: 'Bu gün için alarm yok',
  markAlarmsAsComplete: 'Alarmları Tamamlandı Olarak İşaretle',
  markAlarmsAsCompleteExplanation:
    'Tek seferlik alarmlar tamamlandı olarak işaretlenecek ve "Aktif Olmayan" alarmlar bölümünde görünecektir.\n\nTekrar eden alarmlar tamamlandı olarak işaretlenecek ve bir sonraki olaya taşınacaktır.',
  enterIncidentPrefix: 'Maksimum 5 karakter',
  incidentPrefix: 'Olay Öneki',
  incidentPrefixAlreadyExists: 'Olay öneki zaten mevcut',
  removeTask: 'Görevi Kaldır?',
  incidentPrefixLengthExceeded: 'Olay öneki 5 karakterden uzun',
  criticalAlerts: 'Kritik Uyarılar',
  criticalAlertsConfiguration:
    'Telefonunuzun sesi kapalı veya Odak açık olsa bile alarm {{criticalAlertsVolume}}% ses seviyesinde çalacaktır.',
  criticalAlertsDisabledShort:
    'Telefonunuzun sesi kapalıyken alarm çalmayacaktır.',
  criticalAlertsConfigurationGlobal:
    'Telefonunuzun sesi kapalı veya Odak açık olsa bile alarmlar {{criticalAlertsVolume}}% ses seviyesinde çalacaktır.',
  criticalAlertsDisabledShortGlobal:
    'Telefonunuzun sesi kapalıyken alarmlar çalmaz.',
  criticalAlertsEnabled:
    'Kritik Uyarılar etkinleştirildi. Telefonunuzun sesi kapalı veya Odak açık olsa bile alarmlar çalacaktır.',
  criticalAlertsDisabled:
    'Kritik Uyarılar devre dışı bırakılmıştır. Telefonunuzun sesi kapatıldığında alarmlar çalmaz.',
  enableCriticalAlerts: 'Kritik Uyarıları Etkinleştirin',
  showFullScreenIntents: 'Alarmı Tam Ekranda Göster',
  showFullScreenIntentsDescription:
    'Telefon kilitlendiğinde alarm tam ekranda görünecektir.',
  percentVolume: '{{volume}}% hacim',
  selectADate: 'Alarmları görüntülemek için lütfen bir tarih seçin.',
  affiliates: 'İştirakler',
  referralCount: 'Yönlendirme Sayısı',
  addAffiliate: 'Ortaklık Ekle',
  creatingAffiliate: 'Satış Ortaklığı Oluşturma',
  affiliateLink: 'Ortaklık Bağlantısı',
  upgradeRequiredForWeb: 'Yükseltme Gerekli',
  upgradeToPremiumForWeb:
    'Bu özellik premium abonelik gerektirir. Bu özelliği kullanmak için lütfen mobil uygulamadan bir premium abonelik satın alın.',
  accountType: 'Hesap Türü',
  profileAndSettings: 'Profil ve Ayarlar',
  confirmIncidents: 'Olayları Onayla',
  removeIncidents: 'Birden Fazla Olayı Kaldırın',
  incidents: 'Olaylar',
  closeSelectedIncidents: 'Seçilen Olayları Kapatın',
  viewIncidentNotes: 'Olay Notlarını Görüntüle',
  incidentNotes: 'Olay Notları',
  incidentSummary: 'Olay Özeti',
  addNote: 'Not Ekle',
  noAdditionalNotesForIncident: 'Bu olay için ek not bulunmamaktadır.',
  fromIncident: 'Olaydan:',
  fromUsers: 'Kullanıcılardan:',
  chooseFirstDayOfWeek: 'Haftanın ilk gününü seçin',
  firstDayOfWeek: 'Haftanın ilk günü',
  changePlan: 'Değişim Planı',
  currentPremiumSubscriptionStatus: 'Şu anda {{planName}} planına üyesiniz.',
  purchasedLifetimePlan: 'Ömür Boyu Premium planını satın aldınız.',
  currentProSubscriptionStatus: '{{orgName}} kuruluşunun bir üyesisiniz.',
  currentStripePremiumSubscriptionStatus:
    'Şu anda {{planName}} planına abonesiniz.',
  changeToAnnualPlan: 'Yıllık planda değişiklik',
  unableToChangePlan:
    'Güncel plana geçilemiyor. Lütfen "Ayarlar > Geri Bildirim" seçeneğini kullanarak teknik destek ile iletişime geçin.',
  confirmChangeToAnnualPlan: 'Yıllık plana geçmek istiyor musunuz?',
  changeToAnnualPlanDescription:
    'Yıllık plan için {{price}} adresinden ücretlendirileceksiniz. Mevcut planınızda kalan günler yıllık plana göre ayarlanacaktır.',
  alarmTimezoneChanged:
    'Bazı alarmlar cihaz saat dilimini kullanacak şekilde güncellendi çünkü bu alarmlar için kullanılan saat dilimi bu cihaz tarafından desteklenmiyor.',
  defaultTimezoneChanged:
    "{{defaultTimezoneForAlarm}}'ın saat dilimi bu cihaz tarafından desteklenmediğinden, alarmlar için varsayılan saat dilimi cihazın saat dilimine değiştirilmiştir. Gerekirse, bu saat dilimini kullanan mevcut alarmları güncelleyin.",
  invalidEmail: 'Geçersiz e-posta adresi.',
  unableToValidateEmail: 'E-posta doğrulanamıyor. {{error}}',
  havingProblems: 'Sorun mu yaşıyorsunuz?',
  alertData: 'Uyarı Verileri',
  notificationActionBehavior: 'Bildirim Eylemi Davranışı',
  foreground: 'Ön Plan',
  background: 'Arka plan',
  notificationActionBehaviorTooltipMessage:
    '"Ön Plan" olarak ayarlandığında, bir bildirim eylemine dokunulduğunda uygulama ön planda açılır. "Arka Plan" olarak ayarlandığında, bir bildirim eylemine dokunulduğunda uygulama arka planda kalır.',
  getCodeOnWhatsApp: "WhatsApp'ta Kod Alın",
  getCode: 'Kod Alın',
  dontHaveWhatsApp: "WhatsApp'ınız yok mu?",
  unableToSendCodeViaWhatsAppTitle: 'WhatsApp üzerinden kod gönderilemiyor',
  unableToSendCodeViaWhatsAppMessage:
    '{{error}}\n\nLütfen kodu farklı bir kanaldan tekrar talep edin.',
  dataSecurity: 'Veri Güvenliği',
  customSnooze: 'Diğer',
  customSnoozeDuration: 'Diğer ({{durationString}})',
  snoozeDuration: 'Erteleme Süresi',
  action: 'Eylem',
  adsMessage:
    "\nGalarm'a güvendiğiniz için teşekkür ederiz. Gelişimini desteklemek için zaman zaman reklamlar görebilirsiniz.\n\nReklamsız bir deneyim ve daha fazla harika özelliğe erişim için bütçe dostu premium planımıza yükseltin.",
  headsUp: 'Dikkat!',
  unableToAuthenticateUser: 'Kullanıcının kimliği doğrulanamıyor. {{error}}',
  addOccurrence: 'Oluşum Ekle',
  closeIncidents: 'Olayları Kapat',
  closingIncidents: 'Kapanış Olayları',
  olderThanHours: 'Daha eski (saat)',
  errorLoadingRecaptcha:
    'reCAPTCHA meydan okuması yüklenirken bir hata oluştu. Lütfen bir süre sonra tekrar deneyin ve sorun devam ederse teknik destek ile iletişime geçin.',
  completeRecaptcha: 'Kayda devam etmek için aşağıdaki görevi tamamlayın.',
  incidentNotesPlaceholder: 'Bu olay için not ekleyin (isteğe bağlı)',
  incidentSummaryPlaceholder:
    'Bu olay için kısa bir özet ekleyin (isteğe bağlı)',
  rotationMustHaveMembers: 'Rotasyonun en az bir üyesi olmalıdır.',
  listenerMustHaveTriggers: 'Dinleyicinin en az bir tetikleyicisi olmalıdır.',
  rotationExpiresOn: 'Son kullanma tarihi {{dateString}}',
  rotationExpiredOn: '{{dateString}} tarihinde sona erdi',
  editAndSaveRotationToSetExpirationDate:
    'Son kullanma tarihini ayarlamak için rotasyonu düzenleyin ve kaydedin.',
  cantEnableAlarmNoValidNextDate:
    'Alarm etkinleştirilemiyor. Alarm için geçerli bir sonraki tarih yok.',
  noValidNextDateForAlarm: 'Alarm için geçerli bir sonraki tarih yok.',
  lifetimePremium: 'Ömür Boyu Prim',
  buyNow: 'Şimdi Satın Al',
  checkout: 'Ödeme',
  cancelProduct: 'Ürün İptal',
  endTimeForCreatorCrossesMidnightForRecipientAlarm:
    'İçerik oluşturucunun alarmı için bitiş saati gece yarısını geçer. Lütfen geçerli bir bitiş saati ayarlayın.',
  dataRetention: 'Veri Saklama',
  retainIncidentsForDuration: 'Olay saklama süresi',
  retainIncidentsForDurationDescription:
    'Bir olayın kapatıldıktan sonra sistemde kalacağı süreyi belirtir. Ayar "Saklama Yok" olsa bile, olaylar periyodik temizleme döngüsü sırasında kaldırılmadan önce dört saate kadar kalabilir.',
  noRetention: 'Saklama Yok',
  fetchingData: 'Veri getiriliyor...',
  errorFetchingData: 'Veri alınırken hata oluştu: {{message}}',
  incidentsCleanupLevel: 'Olaylar Temizleme Seviyesi',
  incidentsCleanupLevelDescription:
    'Periyodik temizleme döngüsü sırasında olayların hangi duruma kadar temizleneceğini belirtir. Durum "Kapalı" olarak ayarlanırsa, kapatılan tüm olaylar temizlenir. Durum "Onaylandı" olarak ayarlanırsa, onaylanan veya kapatılan tüm olaylar temizlenir.',
  connectedAccounts: 'Bağlantılı Google Hesapları',
  incidentNameTemplate: 'Olay Adı Şablonu',
  invalidIncidentNameTemplate:
    'Geçersiz olay adı şablonu. Lütfen yalnızca "identifier", "name" ve "summary" değişken adlarını kullanabileceğinizi unutmayın. Lütfen şablonu kontrol edin ve tekrar deneyin. Sorun yaşamaya devam ederseniz lütfen destek ile iletişime geçin.',
  preferredSourceForIncidentsDescription:
    'Dinleyiciyi bir web kancası olarak kullanmak veya bir izleme aracından olay almak istiyorsanız, lütfen aşağıdaki listeden kaynağı seçin. Bir kaynak seçtiğinizde, dinleyicinin kaynakla nasıl entegre edileceğine ilişkin talimatları göstereceğiz.\n\nBu isteğe bağlıdır ve herhangi bir kaynak için talimatları daha sonra dinleyici için "Kodu Görüntüle" menü seçeneğini kullanarak da görüntüleyebilirsiniz.',
  noCalendarsFoundForConnectedAccount:
    'Bağlı hesap için takvim bulunamadı. Lütfen hesabı kaldırın ve tekrar ekleyin, Galarm\'ın takvimlerinize erişim izni olduğundan emin olun. Sorun devam ederse, lütfen "Ayarlar > Geri Bildirim" yoluyla teknik destekle iletişime geçin.',
  attachScreenshotsToFeedback:
    'Geri bildiriminizi aldığımızı onaylayan bir e-posta alacaksınız. Sorunu daha iyi anlamamıza yardımcı olması için ekran görüntülerini paylaşmak isterseniz, lütfen e-postayı ekran görüntüleriyle birlikte yanıtlayın.',
  checkFeedbackReceipt:
    'Lütfen gönderiminizi onaylayan bir e-posta için Gelen Kutunuzu kontrol edin. Gelen Kutunuzda göremiyorsanız, lütfen Spam klasörünüzü kontrol edin ve support@galarm.zendesk.com adresini e-posta adres defterinize ekleyin.\n\nSorunu daha iyi anlamamıza yardımcı olmak için ekran görüntülerini paylaşmak isterseniz, lütfen ekran görüntüleriyle birlikte e-postayı yanıtlayın.',
  watchRewardedAdToUnlockMessage: `Şimdi tam ekran bir reklam göreceksiniz. Birkaç saniye sonra kapatabilirsiniz. Günde yalnızca bir kez bu tür bir reklam göreceksiniz. Bu, uygulamayı ücretsiz tutmamıza yardımcı olur.

Reklamları kaldırmak ve ek özelliklerin kilidini açmak için premium planımıza yükseltmeyi düşünün.`,
  watchRewardedAdToUnlockMessageAndroid: `Şimdi 30 saniyeye kadar süren tam ekran bir reklam göreceksiniz. Bittiğinde, üstte "Ödül Verildi" mesajı ve bir X düğmesi görünecek. Reklamı kapatmak ve devam etmek için X'e dokunun.

"Ödül Verildi" mesajı görünmeden önce lütfen geri düğmesine basmayın. Günde yalnızca bir kez bu tür bir reklam göreceksiniz.

Reklamları kaldırmak ve ek özelliklerin kilidini açmak için lütfen premium planımıza yükseltmeyi düşünün.`,
  watchRewardedAdToUnlockMessageIos: `Şimdi 30 saniyeye kadar süren tam ekran bir reklam göreceksiniz. Bittiğinde, üstte "Ödül Verildi" mesajı ve bir X düğmesi görünecek. Reklamı kapatmak ve devam etmek için X'e dokunun.

Günde yalnızca bir kez bu tür bir reklam göreceksiniz. Reklamları kaldırmak ve ek özelliklerin kilidini açmak için lütfen premium planımıza yükseltmeyi düşünün.`,
  dontShowMessageAgain: 'Bu mesajı bir daha gösterme',
  alphabeticalAsc: 'Alfabetik Artan',
  alphabeticalDesc: 'Alfabetik Azalan',
  newestFirst: 'En Yeni İlk',
  oldestFirst: 'En Yaşlı İlk',
  sortChecklistBy: 'Görevleri Şuna Göre Sırala',
  addedTaskToDeleteAlert:
    'Dinleyiciyi silmek için bir görev eklendi. Bu dinleyici artık yeni olayları kabul etmeyecek ve kısa süre içinde kaldırılacaktır. Bu iletişim kutusunu kapatabilir ve uygulamayı kullanmaya devam edebilirsiniz.',
  alertsData: 'Dinleyici Verileri',
  appNotConnectedToServer:
    'Uygulama sunucuya bağlı değildir. Tüm değişiklikler yerel olarak saklanır ve uygulama sunucuya bağlandığında senkronize edilir. Yeniden bağlanmak için dokunun.',
  unableToConnectToServer: 'Sunucuya bağlanılamıyor.',
  pleaseCheckYourInternetConnection:
    'Lütfen internet bağlantınızı kontrol edin.',
  autoCloseIncidents: 'Otomatik Yakın Olaylar',
  autoCloseIncidentsDescription:
    'Belirli bir süreden sonra olayları otomatik olarak kapatın.',
  autoClosed: 'Otomatik Kapalı',
  never: 'Asla',
  dndAccessNotGranted:
    'Rahatsız Etmeyin erişimi verilmemiş. Rahatsız Etmeyin açıkken alarmlar çalmayabilir.',
  deviceTokenExpired:
    "Cihaz belirtecinin süresi dolduğu için cihazınız Galarm'dan anlık bildirimler almıyor. Belirteci yenilemek için lütfen uygulamayı yeniden başlatın.",
  unableToSendRemoteNotification:
    'Cihazınız Galarm\'dan anlık bildirimler almıyor. Hata kodu: {{errorCode}}. Lütfen "Ayarlar > Geri Bildirim" seçeneğini kullanarak teknik destek ile iletişime geçin.',
  cameraNotAvailable: 'Kamera mevcut değil',
  removePhoneContacts: 'Telefon Kişilerini Kaldır',
  removePhoneContactsConfirmation:
    'Bu, telefon rehberinizden senkronize edilen tüm Galarm kişilerini kaldıracaktır. Bu kişileri alarmlara veya gruplara ekleyemezsiniz. Uygulama ayarlarından kişilere erişim izni vererek telefon kişilerini tekrar senkronize edebilirsiniz.',
  allowContactsPermission: 'Kişilere İzin Ver',
  allowContactsPermissionDescription:
    "Bir sonraki ekranda İzinler'e dokunun ve kişilere erişime izin verin.",
  revokeContactsPermission: 'Kişilerin İznini İptal Etme',
  revokeContactsPermissionDescription:
    "Telefon kişilerini kaldırmadan önce, kişilere erişim iznini iptal etmeniz gerekir. Sonraki ekranda, Kişiler'e dokunun ve kişilere erişimi iptal edin.",
  phoneContactsRemoved:
    'Telefon kişilerini kaldırmak için bir görev eklendi. Kişiler birkaç dakika sonra kaldırılmazsa lütfen destek ekibiyle iletişime geçin.',
  specifyDate: 'Tarih belirtin',
  specifyTime: 'Zaman belirtin',
  summer_soft: 'Yaz Yumuşaklığı',
  beeps: 'Bip sesleri',
  bollywood_nights: 'Bollywood Geceleri',
  gentle_reminder: 'Nazik Hatırlatma',
  himalayan_piper: 'Himalaya Kavalı',
  holiday_joy: 'Tatil Sevinci',
  hollywood_adventure: 'Hollywood Macerası',
  melody: 'Melodi',
  morning_rooster: 'Sabah Horozu',
  morning_sunshine: 'Sabah Güneşi',
  sweet_sea: 'Tatlı Deniz',
  old_school_ring: 'Tring Tring',
  horizon: 'Horizon',
  symphony: 'Senfoni',
  chords: 'Akorlar',
  discovery: 'Keşif',
  rainforest: 'Yağmur Ormanı',
  wishes: 'Dilekler',
  natural_marimba: 'Doğal Marimba',
  MyAlarmNotification: '{{alarmName}} - Vakit geldi.',
  ParticipantCascadingAlarmNotification:
    '{{alarmName}} - {{alarmCreatorName}} adresini hatırlatma zamanı geldi.',
  ParticipantSimultaneousAlarmNotification:
    '{{alarmName}}. Katılımınızı teyit etme zamanı geldi.',
  InstantAlarmNotification: '{{alarmName}}. Derhal ilgilenmeniz rica olunur.',
  MyAlarmNotificationShort: 'Vakit geldi.',
  ParticipantCascadingAlarmNotificationShort:
    '{{alarmCreatorName}} adresini hatırlatma zamanı geldi.',
  ParticipantSimultaneousAlarmNotificationShort:
    'Katılımınızı onaylamanın zamanı geldi.',
  InstantAlarmNotificationShort: 'Derhal ilgilenmeniz rica olunur.',
  MyRecipientAlarmNotification:
    '{{alarmName}} - {{alarmRecipientName}} adresini hatırlatma zamanı geldi.',
  MyRecipientAlarmNotificationShort:
    '{{alarmRecipientName}} adresini hatırlatma zamanı geldi.',
  RecipientAlarmNotification:
    '{{alarmName}} ( {{alarmCreatorName}} tarafından) - Vakit geldi.',
  RecipientAlarmNotificationShort:
    'Zamanı geldi -{{alarmCreatorName}} tarafından.',
  adFreeExperiencePremiumFeature: 'Reklamsız Deneyim',
  adFreeExperienceFeatureDescription:
    'Reklamlar olmadan kesintisiz bir deneyimin tadını çıkarın.',
  accountLabel: 'Hesap Etiketi',
  editAccountLabel: 'Hesap Etiketini Düzenle',
  enterAccountLabel: 'Bu hesap için bir etiket girin',
  failedToUpdateLabel: 'Hesap etiketini güncelleyemedi. Lütfen tekrar deneyin.',
  considerEvents: 'Alarmları Ayarla',
  importAllDayEvents: 'Tüm Gün Etkinliklerini İçe Aktar',
  considerEventsStartingWith: 'Etkinlikler için alarmları ayarlayın',
  eventsStartingWith: 'Şu kelimelerle başlayan etkinlikler',
  allEvents: 'Tüm Etkinlikler',
  noEvents: 'Etkinlik yok',
  ringAlarmsForCalendarEvents: 'Etkinlik Hatırlatıcısı',
  durationBefore: '{{duration}} önce',
  durationBeforeEventTime: '{{duration}} etkinlik saatinden önce',
  beforeEventTime: 'etkinlik saatinden önce',
  promptForUpdates: 'Uygulama güncellemelerini yükleme istemi',
  calendarNotifications: 'Takvim Bildirimleri',
  enableEnhancedNotifications: 'Etkinleştir',
  calendarWithSnoozeAt:
    'Etkinlik bir sonraki {{timeString}} adresinde yayınlanacaktır.',
  calendarEventFeedbackHeader:
    'Hata ayıklama amacıyla bu takvim etkinliğinin bilgilerinin bir kısmını göndereceksiniz. Etkinlik adı, açıklaması veya katılımcılar gibi kişisel veriler paylaşılmayacaktır.',
  screenWillCloseAutomatically:
    'Bu ekran {{seconds}} saniye sonra otomatik olarak kapanacaktır.',
  viewingCalendarEvent: '{{title}} için takvim etkinliğini görüntüleme',
  snoozingCalendarEvent: '{{title}} için takvim etkinliğini erteleme',
  calendarGrantExpired:
    '{{connectedAccountName}}, {{userName}} için takvim erişimi süresi doldu. Lütfen Ayarlar -> Bağlı Takvimler bölümüne gidin, hesabı silin ve tekrar deneyin.',
  linkedAccountsPremiumFeaturesDescription:
    "Google hesaplarınızı bağlayabilir ve birincil takviminizdeki etkinlikleri Galarm'a aktarabilirsiniz.",
  instantAlarmPremiumFeaturesDescription:
    'Daha fazla anlık alarm oluşturmak için premium abonelik gereklidir.',
  linkedAccountsPremiumFeatureDescription:
    "Google hesaplarınızı bağlayarak birincil takviminizdeki etkinlikleri Galarm'a aktarın.",
  linkedAccountsPremiumFeature: 'Google Takvimleri Bağla',
  calendarNotificationsTooltipMessage:
    'Bağlantılı takvim etkinlikleri için bildirimler.',
  hideRecentlyDeletedAlarms: 'Son Silinen Alarmları Gizle',
  loadingCalendarEvent: 'Takvim etkinliği yükleniyor...',
  noOpenIncidents: 'Açık olay yok',
  incidentsForMember: '{{name}} ile ilgili olaylar',
  noIncidentsForMember: 'Bu üye için henüz herhangi bir olay yok.',
  noIncidents: 'Olay yok',
  labels: 'Etiketler',
  manageLabels: 'Etiketler Yönet',
  addLabel: 'Etiket Ekle',
  editLabel: 'Etiketi Düzenle',
  labelName: 'Etiket Adı',
  enterLabelName: 'Etiket adını girin',
  existingLabels: 'Mevcut Etiketler',
  noLabelsYet: 'Henüz etiket oluşturulmadı',
  labelNameRequired: 'Etiket adı gereklidir',
  labelAlreadyExists: 'Bu isimde bir etiket zaten var.',
  selectLabels: 'Etiketler seçin',
  filterByMember: 'Üyeye göre filtrele',
  filterByTeam: 'Takımına göre filtrele',
  filterByLabel: 'Etiketle Filtrele',
  deletingLabel: 'Etiket siliniyor...',
  dutch: 'Hollandaca',
  turkish: 'Türkçe',
  ukrainian: 'Ukraynalı',
  appSupportedLanguages:
    'Galarm şu anda İngilizce, Rusça, Almanca, Fransızca, İspanyolca, İtalyanca, Portekizce, Japonca, Korece, Endonezce, Felemenkçe, Türkçe ve Ukraynaca dillerini desteklemektedir.',
  enhancedNotifications: 'Geliştirilmiş Alarm Gönderimi',
  enhancedNotificationsPremiumFeatureDescription:
    'Etkinleştirildiğinde, telefonunuzun işletim sistemi daha fazla alarm programlamaya izin vermese bile ek alarmlar oluşturabilirsiniz. Galarm, alarmları bulutta programlayarak ve alarmların zamanı geldiğinde telefonunuza push bildirimleri göndererek bunu gerçekleştirir.',
  enhancedNotificationsFeatureDescription:
    'Telefonunuzun işletim sistemi daha fazla alarm programlamaya izin vermediğinde bile alarmlar oluşturun.\n\nGalarm, alarmları bulutta programlayarak ve alarmların zamanı geldiğinde telefonunuza push bildirimleri göndererek bu sorunu çözer.',
  appTerminatedNotification: 'Uygulama Sonlandırıldı Bildirimi',
  appTerminatedNotificationTooltipMessage:
    'Uygulama kapatıldığında gösterilen bildirim. Alarmların zamanında çalması için uygulamanın arka planda çalışmaya devam etmesi önerilir.',
  cantChangeSetting: "{{settingName}}'i değiştiremiyorum",
  fetchingAlarm: 'Alarm getiriliyor...',
  viewIncidentAlarms: 'Olayları Görüntüle',
  showingIncidents: {
    zero: 'Olay yok',
    one: "{{startIndex}}'ın gösterilmesi - {{count}} olayının {{endIndex}}'ı",
    other:
      "{{startIndex}}'ın gösterilmesi - {{count}} olaylarının {{endIndex}}'u"
  },
  noIncidentsFound: 'Hiçbir olay bulunamadı',
  noIncidentsInSystem: 'Sistemde henüz herhangi bir olay bildirilmedi.',
  sendTestIncident: 'Test Olayı',
  sendTestIncidentConfirmMessage:
    'Bu, "{{alertName}}" dinleyicisi için bir test olayı tetikleyecektir. Devam edilsin mi?',
  noListenersToSendTestIncident:
    'Bir test olayı göndermeden önce bir dinleyici yapılandırmanız gerekir. Bir tane oluşturmak için Dinleyiciler bölümüne gidin.',
  pageSize: 'Sayfa Boyutu',
  incidentsPerPage: 'Sayfa başına olay sayısı',
  identifier: 'Tanımlayıcı',
  reportedAt: 'Bildirildiği Yer',
  closedAtLabel: 'Kapalı',
  priority: 'Öncelik',
  allListeners: 'Tüm Dinleyiciler',
  allDates: 'Tüm Tarihler',
  allPriorities: 'Tüm Öncelikler',
  allStatuses: 'Tüm Durumlar',
  connectedAccountsDescription:
    "Galarm'daki takvim etkinlikleri için uyarılar almak üzere Google hesabınızı Galarm ile bağlayabilirsiniz. Daha fazla bilgi için https://features.galarmapp.com/calendar-integration adresini ziyaret edin.",
  removeGoogleAccount: 'Google Hesabını Kaldır',
  removeGoogleAccountDescription:
    'Bu Google hesabını silmek istediğinizden emin misiniz?',
  unableToRemoveGoogleAccount: 'Google hesabı kaldırılamıyor',
  googleAccountRemoved: 'Hesap Kaldırıldı',
  googleAccountRemovedDescription: 'Bu Google hesabı kaldırıldı.',
  calendarEvent: 'Takvim Etkinliği',
  connectedAccount: 'Bağlı Hesap',
  linkedCalendars: 'Bağlantılı Takvimler',
  syncedCalendars: 'Senkronize Edilen Takvimler',
  availableCalendars: 'Mevcut Takvimler',
  noSyncedCalendars:
    'Senkronize edilmiş takvim bulunamadı. Aşağıdaki "Mevcut Takvimler" bölümünden takvim ekleyin.',
  noAvailableCalendars: 'Senkronize edilecek takvim yok.',
  removeCalendar: 'Takvimi Kaldır',
  calendarDetails: 'Takvim Ayrıntıları',
  addingCalendar: 'Takvim ekleniyor...',
  calendarAdded: 'Takvim başarıyla eklendi',
  errorAddingCalendar: 'Takvim ekleme hatası: {{error}}',
  duplicateCalendarDetectedTitle: 'Yinelenen Takvim Tespit Edildi',
  removingCalendar: 'Takvim kaldırılıyor...',
  calendarRemoved:
    'Takvimi kaldırmak için bir görev ekledik. Bu iletişim kutusunu kapatabilir ve uygulamayı kullanmaya devam edebilirsiniz. Takvim birkaç dakika sonra kaldırılmazsa lütfen destek ile iletişime geçin.',
  errorRemovingCalendar: 'Takvim kaldırma hatası: {{error}}',
  removeCalendarDescription:
    '"{{calendarName}}" takvimini kaldırmak istediğinizden emin misiniz?',
  default: 'Varsayılan',
  join_meeting_action: 'Toplantıya Katıl',
  view_calendar_event: 'Görünüm',
  snooze_calendar_event: 'Erteleme',
  dismiss_calendar_event: 'Azletmek',
  numEvents: {
    one: '1 etkinlik',
    other: '{{count}} etkinlikler'
  },
  calendarEvents: 'Takvim Etkinlikleri',
  viewingCalendarEvents: 'Takvim Etkinliklerini Görüntüleme',
  calendarEventAlarmName: 'Takvim Etkinliği',
  calendarName: 'Takvim Adı',
  meetingLink: 'Toplantı Bağlantısı',
  attendees: 'Katılımcılar',
  organizer: 'Organizatör',
  addAccount: 'Hesap Ekle',
  accountAlreadyConnected: 'Hesap zaten bağlı',
  unableToSignInWithGoogle: 'Google ile giriş yapılamıyor',
  unableToSignInWithGoogleDescription:
    'Google ile oturum açarken bir sorun oluştu. Lütfen "Ayarlar > Geri Bildirim" bölümünden teknik desteğe başvurun.',
  requiredScopesNotGranted:
    'Galarm, takvimlerinize erişim izni almadığından takviminizdeki etkinlikleri içe aktaramıyoruz. Lütfen hesabı silin ve tekrar ekleyin, Galarm\'ın takvimlerinize erişim izni aldığından emin olun. Sorun devam ederse, lütfen "Ayarlar > Geri Bildirim" seçeneğini kullanarak teknik desteğe başvurun.',
  refreshTokenNotFound:
    'Hesaba erişilemiyor. Lütfen hesabı kaldırıp tekrar ekleyin. Sorun devam ederse, hesabı bir kez daha kaldırın. myaccount.google.com adresine gidin, soldaki "Veri ve Gizlilik" seçeneğine dokunun, aşağı kaydırarak "Üçüncü taraf uygulamalar ve hizmetler"i seçin, Galarm\'ı seçin ve "Galarm ile olan tüm bağlantılarınızı silin" seçeneğine dokunun. Hesabı tekrar ekleyin. Tüm adımları uyguladıktan sonra bu mesajı tekrar görürseniz lütfen teknik destekle iletişime geçin.',
  noCalendarsSyncedForConnectedAccount: 'Senkronize edilmiş takvim yok.',
  calendarsNotSynced:
    'Birincil takvim senkronize edilmedi. Takviminizi senkronize etmek için yenileme düğmesine dokunun.',
  calendarsSynced: 'Takvimler başarıyla senkronize edildi.',
  refreshGoogleAccount: 'Google Hesabını Yenile',
  refreshingGoogleAccount: 'Google hesabı yenileniyor...',
  googleAccountRefreshed: 'Google hesabı başarıyla yenilendi',
  errorRefreshingGoogleAccount: 'Google hesabı yenileme hatası: {{error}}',
  refreshGoogleAccountDescription:
    'Google takviminizden etkinlikleri yeniden içe aktarın ve otomatik güncellemeleri ayarlayın.',
  ignoreEvents: 'Olayları Yoksay',
  ignoreEvent: 'Etkinliği Yoksay',
  unignoreEvent: 'Etkinlik Planla',
  yourIgnoredEvents: 'Göz ardı ettiğiniz etkinlikler',
  ignoredCalendarEvents: 'Yoksayılan Takvim Etkinlikleri',
  noEventsSelected: 'Seçilen etkinlik yok',
  selectEventsToIgnore: 'Yoksayılacak olayları seçin',
  showInCalendar: 'Takvimde göster',
  viewingIgnoredCalendarEvents: 'Yoksayılan Takvim Etkinliklerini Görüntüleme',
  viewIgnoredEvents: 'Yoksayılan Olayları Görüntüle',
  general: 'Genel',
  addMembersAsContacts: 'Galarm Kişileri Olarak Üye Ekle',
  addMembersAsContactsDescription:
    'Senkronize edilmiş üyeler Galarm uygulamasındaki alarmlara ve gruplara eklenebilir. Bu ayarı değiştirdikten sonra yenileme simgesini kullanarak yeniden senkronize edin.',
  resyncMembersPrompt:
    'Üyeleri yeni ayarlarla yeniden senkronize etmek ister misiniz?',
  toAdmins: 'Yöneticilere',
  toEveryone: 'Herkese',
  accountManagers: 'Hesap Yöneticileri',
  accountManager: 'Hesap Yöneticisi',
  viewAccountManagers: 'Hesap Yöneticilerini Görüntüle',
  addAccountManager: 'Hesap Yöneticisi Ekle',
  userAlreadyManager: 'Kullanıcı zaten bir hesap yöneticisidir.',
  noAccountManagersConfigured: 'Hiçbir hesap yöneticisi yapılandırılmamış.',
  addingAccountManager: 'Hesap Yöneticisi Ekleniyor...',
  filterByCalendar: 'Takvim adına göre filtrele',
  calendarEventNotFound: 'Takvim etkinliği bulunamadı',
  calendarEventNotFoundMessage:
    '{{eventId}} kimlik numaralı takvim etkinliği bulunamadı. Silinmiş olabilir veya takvime artık erişilemiyor olabilir.',
  proMemberContact: 'Galarm Pro organizasyonunun üyesi',
  viewCalendarEvents: 'Takvim Etkinliklerini Görüntüle',
  noScheduledCalendarEvents: 'Planlanmış takvim etkinliği yok',
  notSpecified: 'Belirtilmedi',
  addedTaskToRemoveGoogleAccount:
    'Google hesabını silme görevi eklendi. Bu iletişim kutusunu kapatıp uygulamayı kullanmaya devam edebilirsiniz. Birkaç dakika sonra hesap silinmezse lütfen destek ekibiyle iletişime geçin.',
  success: 'Başarı',
  addingTaskToRemoveGoogleAccount: 'Google hesabını kaldırma görevi ekleme...',
  addingGoogleCalendar: "Google Takvim'i senkronize etmek için görev ekleme...",
  googleCalendarAdded:
    'Google hesabınızı bağladık ve birincil takvimden etkinlikleri içe aktarıyoruz. Bağlı hesaba dokunarak ses ve titreşim ayarlarını yapılandırın.\n\nEtkinlikler birkaç dakika sonra içe aktarılmazsa lütfen destek ekibiyle iletişime geçin.',
  googleAccountLinkedSelectCalendars:
    'Google hesabınızı bağladık ve seçilen takvimlerden etkinlikleri içe aktarıyoruz.',
  multipleCalendarsUpgradeMessage:
    'Bir hesaptan birden fazla takvim içe aktarma desteği ekledik. Bu hesaptan birden fazla takvim içe aktarmak istiyorsanız, hesabı kaldırın ve tekrar ekleyin.',
  errorAddingGoogleCalendar: 'Google Takvim ekleme hatası: {{error}}',
  acceptedEvents: 'Kabul ettiğiniz etkinlikler',
  declinedEvents: 'Reddettiğiniz etkinlikler',
  tentativeEvents: '"Belki" olarak işaretlediğiniz etkinlikler',
  needsActionEvents: 'Yanıtınızı bekleyen etkinlikler',
  show: 'Göster',
  hide: 'Gizle',
  showAndRing: 'Gösteri ve Halka',
  chooseBehavior: 'Davranış Seç',
  calendarEventBehavior: 'Davet edildiğiniz etkinliklerin yönetimi',
  lastSyncedAt: 'Son senkronizasyon tarihi{{dateTimeString}}',
  apiConfiguration: 'API Yapılandırması',
  apiVersion: 'API Sürümü',
  apiVersionDescription:
    'API sürümü, uygulama ile sunucu arasında uyumluluğu sağlamak için kullanılır. V2 kullanıyorsanız, mobil uygulamanızın sürümü 9.9.0 veya üstü olmalıdır. API ile ilgili sorunlar yaşarsanız, lütfen teknik destek ile iletişime geçin.',
  reschedulingEventsAsNeeded:
    'Gerektiğinde etkinliklerin yeniden planlanması...',
  failedToUpdateSetting: 'Ayar güncellenemedi: {{error}}',
  selectEventsToSchedule: 'Alarmları planlamak için etkinlikleri seçin',
  scheduleEvents: 'Etkinlikleri Planla',
  unableToRefreshGoogleAccount:
    'Google takviminden etkinlikleri yeniden içe aktarılamıyor',
  calendarEventBehaviorDescription:
    "Galarm'ın davet edildiğiniz etkinlikleri nasıl işleyeceğini seçin.",
  ringAlarmsForCalendarEventsTooltip:
    'Bir etkinliği ne zaman hatırlatılmasını istediğinizi belirtin.\n\n  Ek hatırlatıcılar almak için, "Ses ve Titreşim" ayarlarında otomatik ertelemeyi etkinleştirebilirsiniz.',
  sortAlarmCategories: 'Alarm kategorilerini şuna göre sıralayın',
  byNumAlarms: 'Alarm sayısı',
  byName: 'Ad',
  preReminderRingtone: 'Ön Hatırlatma Zil Sesi',
  timerRingtone: 'Zamanlayıcı Zil Sesi',
  sortAlarmCategoriesTooltipMessage:
    'Alarm kategorilerinizi nasıl sıralamak istediğinizi seçin. Her kategorideki alarm sayısına göre veya alfabetik olarak isme göre sıralayabilirsiniz.',
  resetFilters: 'Filtreleri Sıfırla',
  alarm: 'Kişisel Alarm',
  alarmWithContacts: 'Kişilerle Alarm',
  instantAlarm: 'Anında Uyarı',
  buddyAlarm: 'Arkadaş Alarmı',
  proMembersSyncCompleted: 'Pro üyelerinin senkronizasyonu tamamlandı.',
  errorSyncingProMembers: 'Pro üyelerinin senkronizasyonunda hata: {{error}}',
  label: 'Etiket',
  iosNotificationsLimitReached:
    'Bir uygulama için iOS\'un bildirim sınırına ulaşıyorsunuz.\n\nTüm alarmların çalmasını sağlamak için "Gelişmiş Alarm Gönderimi"ni etkinleştirin. Etkinleştirildiğinde, Galarm izin verilen sınırın üzerindeki alarmları bulutta planlayacak ve bu alarmların zamanı geldiğinde telefonunuza push bildirimleri gönderecektir.',
  notificationLimitReached: 'Bildirim Sınırı Uyarısı',
  remoteAlarmCloudMessage:
    'Bu alarm, bulutta uzaktan programlanır ve alarmın çalacağı anda aktif bir internet bağlantısı gerektirir.',
  signUpForMailingList: 'Önemli Duyurular için Kaydolun',
  signedUpForMailingList: 'Önemli Duyurular için Kaydolundu',
  unsubscribe: 'Aboneliği iptal et',
  confirmUnsubscribeFromMailingList:
    'Önemli duyurulardan aboneliğinizi iptal etmek istediğinizden emin misiniz?',
  unsubscribingFromMailingList:
    'Önemli duyurulardan abonelik iptal ediliyor...',
  successfullyUnsubscribedFromMailingList:
    'Önemli duyurulardan abonelik başarıyla iptal edildi.',
  errorUnsubscribingFromMailingList:
    'Önemli duyurulardan abonelik iptal edilirken bir hata oluştu. Lütfen daha sonra tekrar deneyin.',
  signingUpForMailingList: 'Önemli duyuruları almak için kaydoluyorsunuz...',
  successfullySignedUpForMailingList:
    'Önemli güncellemeleri almak için başarıyla kaydoldunuz.',
  errorSigningUpForMailingList:
    'Önemli güncellemeler için kaydolurken bir hata oluştu. Lütfen daha sonra tekrar deneyin.',
  recentlyUsed: 'Son Kullanılanlar',
  startStopWatch: 'Kronometre Başlat',
  stopWatch: 'Kronometre',
  stopWatches: 'Kronometreler',
  utilities: 'Araçlar',
  addAlarmForTask: 'Görev için alarm ekle',
  noExpiredAlarmsToDelete: 'Silinecek kaçırılan alarm yok',
  noAlarmsToDelete: 'Silinecek alarm yok',
  noAlarmsToEnable: 'Etkinleştirilecek alarm yok',
  noAlarmsToDisable: 'Devre dışı bırakılacak alarm yok',
  noAlarmsToMarkAsComplete: 'Tamamlandı olarak işaretlenecek alarm yok',
  noIncidentsToConfirm: 'Onaylanacak olay yok',
  noIncidentsToClose: 'Kapatılacak olay yok',
  noEventsToIgnore: 'Yok sayılacak etkinlik yok',
  noEventsToSchedule: 'Planlanacak etkinlik yok',
  addAlarmForChecklist: 'Görev Listesi için Alarm Ekle',
  openTaskList: 'Görev Listesini Aç',
  alarmForTask: 'Görev',
  alarmForTaskList: 'Görev Listesi',
  EnterpriseAlertIncidentTriggered:
    "{{alertName}}'i uyaran bir olay tetiklendi.",
  docChatbotWelcome:
    "Merhaba! Galarm Enterprise'ı kullanmayı öğrenmenize yardımcı olmak için buradayım. Özellikler, kurulum veya belirli görevleri nasıl gerçekleştireceğinizle ilgili her türlü soruyu bana sorabilirsiniz.",
  docChatbotError:
    'Üzgünüm, bir hata ile karşılaştım. Lütfen tekrar deneyin veya destek ekibiyle iletişime geçin.',
  docChatbotTitle: 'Allie',
  docChatbotPlaceholder: 'Bir soru sorun...',
  helpAssistant: 'Yardım',
  needHelp: 'Yardıma mı ihtiyacınız var?',
  helpPopupMessage:
    '"Allie", sohbet asistanımız, size yardımcı olmak için burada! Üst çubuktaki "Yardım" menüsünden istediğiniz zaman başlatabilirsiniz.',
  askTheHelpAssistant: '"Allie"\'ye sor',
  newConversation: 'Yeni konuşma',
  setupStep: 'Adım {{current}} / {{total}}',
  escalationPolicyTooltip:
    'Bir yükseltme politikası, bir olay meydana geldiğinde kimin bilgilendirileceğini ve hangi sırayla bilgilendirileceğini tanımlar. Olay tanınmazsa, farklı zamanlarda farklı kişileri uyarmak için birden fazla tetikleyici ekleyebilirsiniz.',
  stopwatchTotal: 'Toplam',
  stopwatchCurrent: 'Mevcut',
  stopwatchStart: 'Başlat',
  stopwatchStop: 'Durdur',
  stopwatchFinish: 'Bitir',
  stopwatchStartNextLap: 'Sonraki Tur Başlat',
  startTimer: 'Başlat',
  stopwatchLapAndContinue: 'Tur ve devam et',
  stopwatchLapAndPause: 'Tur ve duraklat',
  stopwatchLapAndStop: 'Tur ve bitir',
  savingStopwatch: 'Kronometre kaydediliyor...',
  errorSavingStopwatch: 'Kronometre kaydedilirken hata oluştu.',
  timerRequiresValidDuration: 'Önce bir zamanlayıcı süresi ayarlayın.',
  stopwatchLapAndContinueHelp:
    'Mevcut turu kaydeder ve hemen yeni bir tur başlatır.',
  stopwatchLapAndPauseHelp:
    'Mevcut turu kaydeder ve duraklatır. Bir sonraki tura başlamak için hazır olduğunuzda tur notları ekleyebilir ve devam edebilirsiniz.',
  stopwatchLapAndStopHelp:
    'Son turu kaydeder ve kronometreyi bitirir. Kaydetmeden önce her tur için bir etiket ve notlar ekleyebilirsiniz.',
  stopwatchDiscardConfirmMessage:
    'Devam eden bir kronometreniz var. Geri dönmek onu iptal edecektir. Devam edilsin mi?',
  stopwatchLapLabel: 'Tur {{index}}',
  stopwatchAddNote: 'Not ekle',
  stopwatchLabelPlaceholder: 'Bir etiket ekle',
  stopwatchStoppedAt: 'Durdurulduğu zaman',
  stopwatchDetails: 'Kronometre Detayları',
  deleteStopwatches: 'Kronometreleri Sil',
  deleteStopwatch: 'Kronometreyi Sil',
  deleteStopwatchConfirmMessage:
    'Bu kronometreyi silmek istediğinizden emin misiniz?',
  noStopwatchesToDelete: 'Silinecek kronometre yok',
  noStopwatchesYet:
    "+'ya dokunarak bir kronometre başlatın. Tur süreleriyle tamamlanan kronometreleriniz burada listelenecektir.",
  stopwatchInProgress: 'Kronometre devam ediyor — açmak için dokunun',
  stopwatchLaps: {
    one: '1 tur',
    other: '{{count}} tur'
  },
  newAlarmButtonBehavior: 'Yeni alarm düğmesi davranışı',
  newAlarmButtonBehaviorTooltipMessage:
    'Yeni alarm düğmesinde gösterilen seçenekleri değiştirin',
  classic: 'Varsayılan',
  mode: 'Mod',
  classicFabDescription: 'Hızlı Hatırlatma ve Alarm seçeneklerini göster',
  classicAlarmDescription: 'Alarm türü seçmek için seçenekleri gösterir',
  custom: 'Özel',
  customFabDescription: 'Hangi seçeneklerin gösterileceğini seçin',
  chooseNewAlarmButtonOptions: 'Yeni Alarm Düğmesi Seçenekleri',
  fabOptionsMustHaveAtLeastOne: 'En az bir seçenek seçilmelidir',
  actUtilities: 'Harekete Geç',
  connectUtilities: 'Bağlan',
  timer: 'Zamanlayıcı',
  setTimer: 'Zamanlayıcı Ayarla',
  timerFinished: 'Süre Doldu!',
  hoursShort: 'Saat',
  minutesShort: 'Dakika',
  secondsShort: 'Saniye',
  adBelow: 'Aşağıdaki Reklam',
  buyGalarmPremium: 'Galarm Premium Satın Al',
  phoneNumberForPremiumDescription: `Galarm ile kayitli telefon numarasini girin. Galarm uygulamaniza bir dogrulama kodu gonderecegiz.

Telefon numaranizin kayitli olup olmadigini kontrol etmek icin Galarm'da Ayarlar sekmesini acin. Kayitli telefon numaraniz profil adinizin altinda gorunur.

Henuz bir telefon numarasi kaydetmediyseniz, bunu Galarm uygulamasindaki Kisiler sekmesinden yapabilirsiniz. Kaydettikten sonra, Premium abonelik satin almak icin burada ayni telefon numarasini girin.`,
  enterPhoneNumberForPremiumValidation:
    'Lütfen ülke kodunuzu ve telefon numaranızı girin.',
  pleaseCompleteCaptcha: 'Lütfen CAPTCHA doğrulamasını tamamlayın.',
  requestVerificationCode: 'Kod İste',
  unableToSendAppVerificationCode:
    'Doğrulama kodu gönderilemedi. Lütfen tekrar deneyin. {{error}}',
  enterVerificationCodeForPremium: 'Doğrulama Kodunu Girin',
  verificationCodeForPremiumDescription: `Galarm uygulamaniza gonderilen dogrulama kodunu girin.

Kodu bulmak icin Bildirimler sekmesini acin ve Sistem Mesajlari'na dokunun.

Kodu gormuyorsaniz:
  - Galarm uygulamasinin en son surumunu kullandiginizdan emin olun.
  - Cihazinizin aktif bir internet baglantisi oldugunu dogrulayin.
  - Uygulamayi yeni guncellediyseniz geri donup kodu tekrar isteyin.

Kod hala gorunmuyorsa, uygulamadaki Ayarlar sekmesi > Geri Bildirim yolunu kullanarak destekle iletisime gecin.`,
  enterVerificationCodeForPremiumValidation: 'Lütfen doğrulama kodunu girin.',
  verifyCode: 'Doğrula',
  unableToVerifyAppCode:
    'Kod doğrulanamadı. Lütfen kontrol edip tekrar deneyin. {{error}}',
  buyPremiumMonthly: 'Aylık',
  buyPremiumYearly: 'Yıllık (En İyi Değer)',
  monthlyPrice: '{{price}}/ay',
  yearlyPrice: '{{price}}/yıl',
  buyPremiumLifetime: 'Ömür Boyu',
  lifetimePrice: '{{price}} tek seferlik',
  creatingStripeCustomer: 'Hesabınız hazırlanıyor...',
  problemCreatingStripeCustomer:
    'Hesabınızı ayarlarken bir sorun oluştu. Lütfen tekrar deneyin. {{error}}',
  premiumPurchaseSuccessTitle: "Galarm Premium'a Hoş Geldiniz!",
  premiumPurchaseSuccess:
    "Satın alma işleminiz başarılı oldu. Galarm Premium'a abone olduğunuz için teşekkür ederiz. Yeni özelliklerinizin keyfini çıkarmak için telefonunuzda Galarm uygulamasını açın.",
  goToGalarmWeb: "Galarm Web'e Git",
  premiumPurchaseCancelledTitle: 'Satın Alma İptal Edildi',
  premiumPurchaseCancelled:
    'Satın alma işleminiz tamamlanmadı. İstediğiniz zaman tekrar deneyebilirsiniz.',
  countryCode: 'Ülke Kodu',
  appVerificationCodeToBuyPremiumSubscription:
    'Premium abonelik satın almak için doğrulama kodu: {{verificationCode}}',
  loadingProducts: 'Ürünler yükleniyor...',
  invoicesSentToThisEmail: 'Faturalar bu e-posta adresine gönderilecektir.',
  tryPremiumFreeCancelAnytime:
    "🎉 14 günlük ücretsiz deneme — Premium'u ücretsiz deneyin, istediğiniz zaman iptal edin. Hesap başına bir deneme.",
  galarmWebPremium: 'Galarm Web bir Premium Özelliktir',
  subscribeToGetAccess:
    'Erişim sağlamak için abone olun. 14 günlük ücretsiz deneme sürümü ile birlikte gelir.',
  subscribeToPremium: "Galarm Premium'a Abone Ol",
  havingTroubleWithPremium: 'Premium satın alırken sorun mu yaşıyorsunuz?',
  purchaseOnWebsite: 'Web Sitesinden Satın Al',
  purchaseOnWebsiteDescription:
    'Uygulamadan premium satın almakta sorun yaşıyorsanız, web sitemizden satın alabilirsiniz.',
  manageSubscriptionFromBillingPortal:
    'Aboneliğinizde değişiklikleri faturalama portalından yapabilirsiniz.',
  docChatbotDefaultResponse:
    'Üzgünüm, aradığınız bilgiye sahip değilim. Lütfen https://docs.galarmapp.com adresindeki belgelerimize bakın veya daha fazla yardım için destek ekibiyle iletişime geçin.'
}
